import * as constants from '../constant';
import LocalStorage from '../Utils/LocalStorage';
import { serialize } from '../Utils/Helpers';
import axios from 'axios';
import qs from 'querystring';
import { doLogout } from '../Components/Login/AuthActions';
import { EMPREENDIMENTO_LANCAMENTO } from '~/constant';
import { dadosValidos } from '~/Components/DocumentoDigital/helpers';
import { construirPayloadListar } from '~/Pages/GES/Negocios/AutorizaDespesa/helpers/construirPayloadListar';

export const httpService = {
  //we pass the redux store and history in order to dispatch the logout actions
  //and push the user to login

  setupInterceptors: (store, history) => {
    axios.interceptors.response.use(
      response => {
        //simply return the response if there is no error
        return response;
      },
      error => {
        //in this case we only care about unauthorized errors
        if (
          error.response &&
          (error.response.status === 403 || error.response.status === 401)
        ) {
          //we dispatch our logout action (more than likely changes a boolean
          //somewhere in your store ex. isAuthenticated: false)
          store.dispatch(doLogout());
          //this could just as easily be localStorage.removeItem('your-token')
          //but it's best to encapsulate this logic so it can be used elsewhere
          //by just importing it.
          //AuthStorage.removeToken()
          //send the user to the login page since the user/token is not valid
          //history.push('/login?logout=true')
        }
        return Promise.reject(error.response ? error.response.data : error);
      }
    );
  },
  fetch: ({ url, data, headers, _returnFullResponse, ...rest }, usarApiBase = true) => {
    let accessToken = LocalStorage.get(constants.AUTH_KEY)
      ? `Bearer ${LocalStorage.get(constants.AUTH_KEY)}`
      : null;

    headers = {
      ...headers,
      Authorization: accessToken,
    };

    url = usarApiBase ? constants.APIBASE + url : url;

    // Caller que precisa dos response headers (ex.: Content-Disposition para
    // download de blob com nome dinâmico) passa _returnFullResponse: true e
    // recebe `res` completo em vez do unwrap padrão em `res.data`.
    const promise = axios({
      url,
      data,
      headers,
      ...rest,
    });
    return _returnFullResponse ? promise : promise.then(res => res.data);
  },
  // Compatibilidade: callers históricos passam `{ responseType: 'blob' }` (e
  // outras chaves de config do axios) no 3º arg `headers` dos métodos post/put/
  // patch/delete. Esse 3º arg deveria conter SÓ cabeçalhos HTTP — chaves de
  // config caem nos headers e ficam ignoradas pelo axios. Sem `responseType:
  // 'blob'` na config real, o axios decodifica a resposta binária como UTF-8 e
  // bytes >=0x80 viram `�` (sequência ef bf bd), corrompendo XLSX/PDF/ZIP.
  // Esta função extrai chaves conhecidas de config do objeto recebido e devolve
  // separados em { headers, config } — mantendo retro-compatibilidade total.
  _splitHeadersConfig: (headersOrConfig) => {
    const headers = {};
    const config = {};
    const configKeys = [
      'responseType',
      'timeout',
      'onUploadProgress',
      'onDownloadProgress',
      'maxContentLength',
      'maxBodyLength',
      'signal',
      'cancelToken',
      'withCredentials',
    ];
    if (headersOrConfig) {
      Object.keys(headersOrConfig).forEach((k) => {
        if (configKeys.includes(k)) {
          config[k] = headersOrConfig[k];
        } else {
          headers[k] = headersOrConfig[k];
        }
      });
    }
    return { headers, config };
  },
  post: (url, data, headers) => {
    const { headers: h, config } = httpService._splitHeadersConfig(headers);
    return httpService.fetch({ url, data, headers: h, ...config, method: 'post' });
  },
  get: (url, configOrUsarApiBase) => {
    if (
      typeof configOrUsarApiBase === 'boolean' ||
      configOrUsarApiBase === undefined
    ) {
      return httpService.fetch({ url }, configOrUsarApiBase);
    }
    return httpService.fetch({ url, ...configOrUsarApiBase });
  },
  put: (url, data, headers) => {
    const { headers: h, config } = httpService._splitHeadersConfig(headers);
    return httpService.fetch({ url, data, headers: h, ...config, method: 'put' });
  },
  patch: (url, data, headers) => {
    const { headers: h, config } = httpService._splitHeadersConfig(headers);
    return httpService.fetch({ url, data, headers: h, ...config, method: 'patch' });
  },
  delete: (url, data, headers) => {
    const { headers: h, config } = httpService._splitHeadersConfig(headers);
    return httpService.fetch({ url, data, headers: h, ...config, method: 'delete' });
  },
};

export default httpService;

//Endpoints da API
export const doLogin = (credentials, env = constants.DEFAULT_ENV) =>
  httpService.post(
    '/usuario/login',
    qs.stringify({ ...credentials, env, grant_type: 'password' }), //data
    { 'Content-Type': 'application/x-www-form-urlencoded' } //headers
  );

/**
 * @description
 * rota para poder recuperar senha,
 */
export const recuperarSenha = data =>
  httpService.post('/usuario/recuperar/senha', data);
/**
 * @description
 * rota para poder recuperar usuário,
 */
export const recuperarUser = data =>
  httpService.post('/usuario/recuperar', data);

export const consultarProspectos = data =>
  httpService.post('/prospecto/buscar', data);

export const consultarEtapasProspectos = data =>
  httpService.post('/prospecto/etapas', data);

export const consultarEtapasProspectosTerrenoConstrucao = data =>
  httpService.post('/prospecto/etapasTerrenoConstrucao', data);

export const atualizarEtapaProspecto = data =>
  httpService.post('/prospecto/etapa/atualizar', data);

export const atualizarEtapaConstrucaoProspecto = data =>
  httpService.post('/prospecto/etapa/construcao/atualizar', data);

export const getGerentes = () => httpService.get('/opcao/gerente');

export const getOpcoes = () => httpService.get('/opcao');
export const getOrigens = () => httpService.get('/opcao/origens');
export const getStatus = () => httpService.get('/opcao/status');
export const getModoRecebimento = () =>
  httpService.get('/opcao/modo-recebimento');

export const getAtendentesCAV = () => httpService.get('/opcao/Atendentes-CAV');

export const getCidades = uf => httpService.get(`/opcao/estado/${uf}`);

export const getCities = () => httpService.get('/opcao/cidades/');

export const verificarProspectoCPF = cpf =>
  httpService.get(`/prospecto/cpf/${cpf}`);

export const getProfissoes = (value = '') =>
  httpService.get(`/profissao?${serialize({ q: value })}`);

export const getNacionalidades = () => httpService.get('/opcao/nacionalidade');

export const getPDV = () => httpService.get('/opcao/pdv');

export const getProspecto = (id, liberarConsulta) =>
  httpService.get(
    `/prospecto/${id}${liberarConsulta ? '?liberarConsulta=s' : ''}`
  );

export const buscarResumoRescisaoProspecto = cpf =>
  httpService.get(`/prospecto/rescisao/resumo/${cpf}`);

export const criarProspecto = data => httpService.post('/prospecto', data);

export const importarProspectoSuaHouse = data =>
  httpService.post('/integration/suahouse/importar', data);

export const reImportarSuaHouse = codigoProspecto =>
  httpService.get(`/integration/suahouse/reimportar/${codigoProspecto}`);

export const atualizarProspecto = data =>
  httpService.post('/prospecto/atualizar', data);

export const uploadDocumento = formData =>
  httpService.post('/prospecto/upload', formData);

export const consultaCPF = cpf => httpService.get(`/prospecto/cpf/${cpf}`);

export const consultaEmail = email =>
  httpService.get(`/prospecto/email?email=${email}`);

export const consultaTelefone = telefone =>
  httpService.get(`/prospecto/telefone?telefone=${telefone}`);

export const criaContaGE = (data, familia) =>
  httpService.post(`/prospecto/conta/familia/${familia}`, data);

export const vincularEmpreendimento = data =>
  httpService.post('/empreendimento/prospecto', data);

export const consultarControlePdv = async (filtro = {}) =>
  httpService.post(`/empreendimento/consultar-controle-pdv`, filtro);

export const buscarTabelasDisponiveis = async codigo_familia =>
  httpService.get(`/empreendimento/tabela-preco-disponivel/${codigo_familia}`);

export const exibirTabelaPreco = async (
  codigo,
  codigoEmpreendimento,
  exibirProgramadas = false
) =>
  httpService.get(
    `/empreendimento/tabela-preco/${codigo}/${codigoEmpreendimento}?exibirProgramadas=${exibirProgramadas}`
  );

export const buscarEnderecoPorCEP = cep => httpService.get(`/busca/cep/${cep}`);

export const salvarSocio = data => httpService.post('/prospecto/socio', data);

export const copiarSocioConjuge = request =>
  httpService.post('/prospecto/socio/copiar', request);

export const atualizarSocio = data =>
  httpService.post('/prospecto/socio/atualizar', data);

export const excluirSocio = async socio =>
  httpService.post(`/prospecto/socio/excluir`, socio);

export const getPesquisa = () => httpService.get('/prospecto/questionario');

export const salvarPesquisa = (data, prospecto, GE) =>
  httpService.post(`/prospecto/questionario/${prospecto}/ge/${GE}`, data);

export const getQuestionarioPosVenda = () =>
  httpService.get(`/questionario/-1`);

export const getPesquisaPosVenda = codigoBoleto =>
  httpService.get(`/cliente/pesquisa-pos-venda/${codigoBoleto}`);

export const salvarPesquisaPosVenda = (data, codigo_boleto) =>
  httpService.post(`/cliente/pesquisa-pos-venda/${codigo_boleto}`, data);

export const salvarOcorrencia = data =>
  httpService.post('/prospecto/ocorrencia', data);

export const atualizarStatusProspecto = data =>
  httpService.post('/empreendimento/prospecto', data);

export const removerEmpreendimento = data =>
  httpService.post('/empreendimento/prospecto/remover', data);

export const vincularSenhaLancamento = data =>
  httpService.post('/prospecto/senha', data);

export const alterarAtendimentoPreferencial = data =>
  httpService.post('/prospecto/atendimento-preferencial', data);

export const getFolhaConferenciaCliente = (ge, conta) =>
  httpService.get(`/cliente/ge/${ge}/conta/${conta}/folha-conferencia`);

//COMERCIAL
export const consultarComprovantes = (preVenda, ge) =>
  httpService.get(`/comercial/arquivos/preVenda/${preVenda}/comprovantes`);

export const buscarHistoricoDocumentacao = preVenda =>
  httpService.get(
    `/comercial/arquivos/preVenda/${preVenda}/comprovantes/historico`
  );

export const buscarTitulosSinalPreVenda = preVenda =>
  httpService.get(`/preVenda/${preVenda}/titulos/sinal`);

export const obterDadosBancariosPreVenda = preVenda =>
  httpService.get(`/preVenda/${preVenda}/dados-bancarios`);

export const buscarBoletoSinal = preVenda =>
  httpService.get(`/titulos/boleto-sinal/${preVenda}`);

export const imprimirBoleto = codigoTitulo =>
  httpService.get(`/titulos/boleto/gerar-segunda-via/${codigoTitulo}`);

export const atualizarStatusComprovante = data =>
  httpService.post('/comercial/arquivos/alterarStatus', data);

export const removerComprovante = sequencia =>
  httpService.post(`/comercial/arquivos/${sequencia}/remover`);

export const uploadComprovante = (formData, ge, prevenda) =>
  httpService.post(
    `/comercial/arquivos/ge/${ge}/preVenda/${prevenda}/upload`,
    formData
  );

export const getPesquisaStatusSituacaoCliente = cpf =>
  httpService.get(`/cliente/situacao/${cpf}`);

export const getSituacaoSimplificadaCliente = cpf =>
  httpService.get(`/cliente/situacao/simplificada/${cpf}`);

//PRODUTIVIDADE
export const consultarProdutividade = data =>
  httpService.post('/dashboard-produtividade/geral', data);

export const consultarProdutividadePorCorretor = (data, gerente, corretor) =>
  httpService.post(
    `/dashboard-produtividade/imobiliaria/${gerente}/corretor/${corretor}`,
    data
  );

export const consultarProdutividadePorEmprendimento = (data, empreendimento) =>
  httpService.post(
    `/dashboard-produtividade/empreendimento/${empreendimento}`,
    data
  );

export const consultarRankingCorretores = (
  codigoCampanha = null,
  dataInicial = null,
  dataFinal = null,
  tipoRanking = null
) => {
  let queryParams = [];

  if (codigoCampanha !== null) {
    queryParams.push(`codigoCampanha=${codigoCampanha}`);
  }
  if (tipoRanking !== null) {
    queryParams.push(`tipoRanking=${tipoRanking}`);
  }
  if (dataInicial !== null) {
    queryParams.push(`dataInicial=${dataInicial}`);
  }
  if (dataFinal !== null) {
    queryParams.push(`dataFinal=${dataFinal}`);
  }

  const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
  const url = '/dashboard-produtividade/ranking-corretor' + queryString;

  return httpService.get(url);
};

//ATENDIMENTO
export const consultarAtendimentoMesas = env =>
  httpService.get(
    `/lancamento/atendimento/empreendimento/${EMPREENDIMENTO_LANCAMENTO}${env ? '?env=' + env : ''
    }`
  );

export const consultarMinhasSolicitacoesPendentes = () =>
  httpService.get(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/minhas-solicitacoes-pendentes`
  );

export const NotificarDepartamento = departamento =>
  httpService.post(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/notificar-departamento/${departamento}`,
    null
  );
export const NotificarDepartamentoPorMesa = (departamento, mesa) =>
  httpService.post(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/notificar-departamento/${departamento}${mesa ? `/${mesa}` : ''
    }`,
    null
  );

export const NotificarDepartamentoSemAtendimento = (departamento, codigoMesa) =>
  httpService.post(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/notificar-departamento-mesa/${departamento}/${codigoMesa}`,
    null
  );

export const consultarSolicitacoesPendentes = env =>
  httpService.get(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/solicitacoes-pendentes${env ? '?env=' + env : ''
    }`
  );

export const notificaCliente = data =>
  httpService.post(`/contato/acesso`, data);

export const getProspectoAtendimento = (tipo, value) =>
  httpService.get(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/buscar?codigo=${value}&tipo=${tipo}`
  );

export const getProspectoAtendimentoTodos = (tipo, value) =>
  httpService.get(
    `/lancamento/atendimento/${EMPREENDIMENTO_LANCAMENTO}/buscar-todos?codigo=${value}&tipo=${tipo}`
  );

export const salvarPesquisaAtendimento = pesquisa =>
  httpService.post(`/lancamento/atendimento/avaliar`, pesquisa);

export const finalizarFluxoAtendimentoLancamento = (
  codigo_atendimento_colaborador,
  confirmarFinalizacao
) =>
  httpService.post(
    `/lancamento/atendimento/finalizarfluxo/${codigo_atendimento_colaborador}/${confirmarFinalizacao != null ? confirmarFinalizacao.toString() : '0'
    }`
  );
// ESTORNO DE PROPOSTA
export const getSolicitacoesDeEstornoProposta = () =>
  httpService.get('/proposta/estorno/solicitacoes');

export const estornarProposta = data =>
  httpService.post(`/proposta/estorno/solicitacoes`, data);

export const getSolicitacaoParaEstornoProposta = proposta =>
  httpService.get(`/proposta/estorno/solicitacoes/${proposta}`);

export const solicitarEstorno = request =>
  httpService.post(`/proposta/estorno/solicitar`, request);

// W-0556 — busca direta admin de propostas efetivadas (UEstorno_de_Propostas.pas)
export const buscarPropostasParaEstorno = params =>
  httpService.get('/proposta/estorno/admin/buscar', { params });

export const buscarGruposEmpresaEstorno = () =>
  httpService.get('/proposta/estorno/admin/grupos-empresa');

export const estornarPropostaAdmin = data =>
  httpService.post('/proposta/estorno/admin/executar', data);

// ATRIBUIR PROSPECTO
export const buscarListaAtribuirProspectos = data =>
  httpService.post(`/empreendimento/vinculos`, data);

export const atribuirProspectos = data =>
  httpService.post(`/empreendimento/vinculos/trocar-corretor`, data);

export const buscarUsuariosPorCodigo = codigo =>
  httpService.get(`/usuario/${codigo}`);

export const resetSenhaUsuario = (codigo, senha, senha_atual) =>
  httpService.post(`/usuario/mudar/senha`, {
    codigo: codigo,
    senha: senha,
    senha_atual: senha_atual,
  });

export const retornoSenha = codigoUsuario =>
  httpService.get(`/usuario/retorno/senha/${codigoUsuario}`);

export const desabilitarHabilitarUsuario = (codigo, status) =>
  httpService.post(`/usuario/mudar/status`, {
    codigo: codigo,
    status: status,
  });

export const incluirCreci = (codigo, descricao) =>
  httpService.post('/usuario/incluir/creci', {
    codigo: codigo,
    descricao: descricao,
  });
export const excluirCreci = creci =>
  httpService.post(`/usuario/excluir/${creci}`);

export const atualizarUsuario = usuario =>
  httpService.post(`/usuario/atualizar`, usuario);

export const buscarContaBancaria = id =>
  httpService.get(`/usuario/conta-bancaria/${id}`);

export const inserirContaBancaria = usuario =>
  httpService.post('/usuario/conta-bancaria', usuario);

export const uploadFoto = (codigo, dados) =>
  httpService.post(`/usuario/${codigo}/foto`, dados);
//USUARIO
export const getClaims = () => httpService.get('/usuario/claims');

//PARAMETROS
export const getParametrosGerais = () => httpService.get('/parametros/gerais');

// Fonte: UManutContas.pas — Global.ParamCGCCPF (validação condicional de dígito CPF/CNPJ)
export const getParametroChecaCgcCpf = () =>
  httpService.get('/parametros/checa-cgccpf');

export const getMotivosDescarte = () =>
  httpService.get('/parametros/fluxo-prospecto/motivos-descarte');

export const updateLimiteFluxoProspectos = limite =>
  httpService.post('/parametros/fluxo-prospecto/limite', {
    LimiteFluxoProspecto: limite,
  });

export const inserirOrAtualizarMotivoDescarte = data =>
  httpService.post('/parametros/fluxo-prospecto/motivos-descarte', data);

export const desativarMotivoDescarte = codigoMotivo =>
  httpService.get(
    `/parametros/fluxo-prospecto/motivos-descarte/${codigoMotivo}/desativar`
  );

export const buscarPreVenda = numeroPreVenda =>
  httpService.get(`/preVenda/${numeroPreVenda}`);

export const buscarProcuradoresEmpreendimento = codigoFamilia =>
  httpService.get(`/empreendimento/${codigoFamilia}/procuradores`);

//DOCUMENTO DIGITAL
export const buscarParametrosDocumentoDigital = () =>
  httpService.get('/documento-digital/parametros');

export const solicitarAssinaturaDigital = data =>
  httpService.post('/documento-digital/solicitar', data);

export const buscarDocumentoDigital = codigoDocumentoDigital =>
  httpService.get(`/documento-digital/${codigoDocumentoDigital}`);

export const reprovarDocumentoDigital = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento
) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/reprovar?codigoMotivoCancelamento=${codigoMotivoCancelamento}`,
    {
      value: message,
    }
  );

export const solicitarCancelamentoDocDigital = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento
) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/SolicitarCancelamentoDocDigital?codigoMotivoCancelamento=${codigoMotivoCancelamento}`,
    {
      value: message,
    }
  );

export const destartarDocumentoDigital = (codigoDocumentoDigital, message) =>
  httpService.post(`/documento-digital/${codigoDocumentoDigital}/descartar`, {
    value: message,
  });

export const reSolicitarAssinaturaDigital = data =>
  httpService.post('/documento-digital/re-solicitar', data);

export const aprovarAssinaturaDigital = (formData, enviarCartaDesconto) =>
  httpService.post(
    `/documento-digital/aprovar?enviarCartaDesconto=${enviarCartaDesconto}`,
    formData
  );

export const uploadDocumentoDigital = (
  codigoDocumentoDigital,
  formData,
  enviarCartaDesconto
) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/upload?enviarCartaDesconto=${enviarCartaDesconto}`,
    formData
  );

export const cancelarDocumentoDigital = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento,
  estornoProposta = false,
  atualizarSolicitacaoCancelamentoDocDigital = false
) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/cancelar?codigoMotivoCancelamento=${codigoMotivoCancelamento}&atualizarSolicitacaoCancelamentoDocDigital=${atualizarSolicitacaoCancelamentoDocDigital}&estornoProposta=${estornoProposta}`,
    {
      value: message,
    }
  );

export const buscarMotivosCancelamento = tipoContrato =>
  httpService.get(
    `/documento-digital/motivoCancelamentoReprovacao?codigoTipoContrato=${tipoContrato}`
  );

export const notificarSignatario = codigoSignatario =>
  httpService.get(
    `/documento-digital/signatarios/${codigoSignatario}/notificar`
  );

export const incluirSignatario = (codigoDocumentoDigital, signatario) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/signatarios/incluir`,
    signatario
  );

export const removerSignatario = codigoSignatario =>
  httpService.get(`/documento-digital/signatarios/${codigoSignatario}/remover`);

export const editarSignatario = signatario =>
  httpService.post(
    `/documento-digital/signatarios/${signatario.codigo}/editar`,
    signatario
  );

export const getDownloadUrl = codigoDocumentoDigital =>
  httpService.get(`/documento-digital/${codigoDocumentoDigital}/url-download`);

export const buscarPreviaDocDigital = (numeroPreVenda, tipo) =>
  httpService.get(
    `/documento-digital/previa?numeroPreVenda=${numeroPreVenda}&tipo=${tipo}`
  );

export const buscarPlataformaAtiva = codigoDocumentoDigital =>
  httpService.get(
    `/documento-digital/${codigoDocumentoDigital}/plataforma-ativa`
  );

export const buscarValidadorAtivo = () =>
  httpService.get('/documento-digital/validador-ativo');

export const clickSignSolicitarAssinaturaDigital = data =>
  httpService.post('/clicksign/solicitar', data);

export const clickSignAprovarAssinaturaDigital = (
  formData,
  enviarCartaDesconto
) =>
  httpService.post(
    `/clicksign/aprovar?enviarCartaDesconto=${enviarCartaDesconto}`,
    formData
  );

export const clickSignUploadDocumentoDigital = (
  codigoDocumentoDigital,
  formData,
  enviarCartaDesconto
) =>
  httpService.post(
    `/clicksign/${codigoDocumentoDigital}/upload?enviarCartaDesconto=${enviarCartaDesconto}`,
    formData
  );

export const clickSignReprovarDocumentoDigital = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento
) =>
  httpService.post(
    `/clicksign/${codigoDocumentoDigital}/reprovar?codigoMotivoCancelamento=${codigoMotivoCancelamento}`,
    {
      value: message,
    }
  );

export const clickSignDescartarDocumentoDigital = (
  codigoDocumentoDigital,
  message
) =>
  httpService.post(`/clicksign/${codigoDocumentoDigital}/descartar`, {
    value: message,
  });

export const clickSignReSolicitarAssinaturaDigital = data =>
  httpService.post('/clicksign/re-solicitar', data);

export const clickSignCancelarDocumentoDigital = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento,
  estornoProposta = false,
  atualizarSolicitacaoCancelamentoDocDigital = false
) =>
  httpService.post(
    `/clicksign/${codigoDocumentoDigital}/cancelar?codigoMotivoCancelamento=${codigoMotivoCancelamento}&atualizarSolicitacaoCancelamentoDocDigital=${atualizarSolicitacaoCancelamentoDocDigital}&estornoProposta=${estornoProposta}`,
    {
      value: message,
    }
  );

export const clickSignNotificarSignatario = codigoSignatario =>
  httpService.get(`/clicksign/signatarios/${codigoSignatario}/notificar`);

export const clickSignIncluirSignatario = (
  codigoDocumentoDigital,
  signatario
) =>
  httpService.post(
    `/clicksign/${codigoDocumentoDigital}/signatarios/incluir`,
    signatario
  );

export const clickSignRemoverSignatario = codigoSignatario =>
  httpService.get(`/clicksign/signatarios/${codigoSignatario}/remover`);

export const clickSignEditarSignatario = signatario =>
  httpService.post(
    `/clicksign/signatarios/${signatario.codigo}/editar`,
    signatario
  );

export const clickSignGetDownloadUrl = codigoDocumentoDigital =>
  httpService.get(`/clicksign/${codigoDocumentoDigital}/url-download`);

//CAMPANHA (Empreendimento_Campanha)
export const buscarCampanhas = () => httpService.get('/campanha');

export const criarCampanha = campanha =>
  httpService.post('/campanha/inserir', campanha);

export const editarCampanha = campanha =>
  httpService.post('/campanha/editar', campanha);

export const removerCampanha = codigoCampanha =>
  httpService.get(`/campanha/remover?codigoCampanha=${codigoCampanha}`);

export const finalizarCampanha = codigoCampanha =>
  httpService.get(`/campanha/finalizar?codigoCampanha=${codigoCampanha}`);

export const buscarResultadosCampanha = codigoCampanha =>
  httpService.get(`/campanha/resultados?codigoCampanha=${codigoCampanha}`);

//Inadimplencia
export const buscarListaInadimplencias = filtros =>
  httpService.post('/cliente/inadimplencia', filtros);

export const buscarOcorrenciasCliente = (
  codigoConta,
  codigoGrupoEmpresa,
  codigoBoleto = null,
  somenteOcorrenciaDoUsuario = null
) =>
  httpService.get(
    `/cliente/ocorrencias?${qs.stringify({
      codigoConta,
      codigoGrupoEmpresa,
      codigoBoleto,
      somenteOcorrenciaDoUsuario,
    })}`
  );

export const gravarOcorrenciaCliente = (
  ocorrencia,
  numeroPreVenda,
  encaminhamento
) =>
  httpService.post(
    // numeroPreVenda é opcional, mas por enquanto estou sempre passando. Mude conforme necessário
    `/cliente/ocorrencia/gravar?numeroPreVenda=${numeroPreVenda}&encaminhamentoCobranca=${encaminhamento}`,
    ocorrencia
  );

export const obterUrlSegundaViaBoleto = codigoTitulo =>
  httpService.get(
    `/titulos/segunda-via-boleto/url?codigoTitulo=${codigoTitulo}`
  );

export const enviarEmailSegundaViaBoleto = (email, codigoTitulo) =>
  httpService.get(
    `/titulos/segunda-via-boleto/enviar?codigoTitulo=${codigoTitulo}&email=${email}`
  );

//VENDA
export const obterPropostaInicial = (codigoFamilia, idProspecto) =>
  httpService.get(
    `/venda/empreendimento/${codigoFamilia}/prospecto/${idProspecto}`
  );

export const gravarVenda = (codigoFamilia, codigoProspecto, request) =>
  httpService.post(
    `/venda/empreendimento/${codigoFamilia}/prospecto/${codigoProspecto}`,
    request
  );

export const buscarPropostasGravadas = request =>
  httpService.post('/venda/propostas/gravadas', request);

export const excluirPropostaRapidaAuxiliar = codigoProposta =>
  httpService.get(`/venda/proposta/${codigoProposta}/excluir`);

export const buscarPropostaAuxiliar = codigoProposta =>
  httpService.get(`/venda/proposta/${codigoProposta}/auxiliar`);

export const criarContraproposta = async (codigoProposta, request) =>
  httpService.post(
    `/venda/proposta/${codigoProposta}/criar-contraproposta`,
    request
  );

export const buscarUsuariosAutorizadoresVenda = (
  isCondicaoEspecial = false,
  porcentagemDesconto = 0,
  codigoFamilia = 0,
  travarCondicao = false
) => {
  const queryParams = isCondicaoEspecial
    ? `isCondicaoEspecial/${porcentagemDesconto}/${codigoFamilia}/${travarCondicao}`
    : '';
  return httpService.get(`/usuario/autorizadores/venda/${queryParams}`);
};

export const validarCheque = cheque =>
  httpService.post('/venda/validacao/cheque', cheque);

export const validarUsuarioSenha = (codigo_usuario, senha) =>
  httpService.post('/usuario/credenciais/validar', { codigo_usuario, senha });

export const autorizarVenda = (codigoProposta, autorizacao) =>
  httpService.post(`/venda/proposta/${codigoProposta}/aprovar`, autorizacao);

// ============================================================================
// SIMULADOR FINANCEIRO — endpoints paralelos (espelham os de venda real)
export const gravarVendaSimulador = (codigoFamilia, codigoProspecto, request) =>
  httpService.post(
    `/venda/simulador/empreendimento/${codigoFamilia}/prospecto/${codigoProspecto}`,
    request
  );

export const obterPropostaInicialSimulador = (codigoFamilia, idProspecto) =>
  httpService.get(
    `/venda/simulador/empreendimento/${codigoFamilia}/prospecto/${idProspecto}`
  );

export const autorizarVendaSimulador = (codigoProposta, autorizacao) =>
  httpService.post(`/venda/simulador/proposta/${codigoProposta}/aprovar`, autorizacao);

export const buscarCartoesSimulador = (codigoFamilia) =>
  httpService.get(`/venda/simulador/empreendimento/${codigoFamilia}/cartoes`);

export const validarChequeSimulador = (cheque) =>
  httpService.post('/venda/simulador/validacao/cheque', cheque);

// W-0075 (devolução SINAL pt.1): gera a Proposta REAL (mesmo PDF do CRM) a partir
// dos dados da simulação, sem gravar a venda e com cliente em branco.
// Retorna { url, nome_arquivo } — a URL aponta para o PDF temporário.
export const gerarPropostaSimuladorPdf = (request) =>
  httpService.post('/contratos/gerar-proposta-simulador-pdf', request);

// /usuario/credenciais/validar-flex aceita codigo_usuario como string (número OU login)
export const validarUsuarioSenhaSimulador = (codigo_usuario, senha) =>
  httpService.post('/usuario/credenciais/validar-flex', { codigo_usuario, senha });

export const consultarComissao = filtros =>
  httpService.post('/comissao/buscar', filtros);

//ANAPRO - FOI UNIFICADO NO "CRM Genérico"
// export const buscarLeadParaImportacao = atendimentoID =>
//   httpService.get(`/integration/anapro/buscar-atendimento/${atendimentoID}`);

// export const importarOuAtualizarLeadNaExtranet = (
//   atendimentoID,
//   codigoFamilia
// ) =>
//   httpService.post(
//     `/integration/anapro/importar/cliente/atendimento/${atendimentoID}/empreendimento/${codigoFamilia}`
//   );

//CRM Genérico
export const obterLeadDoCRM = id =>
  httpService.get(`/integration/crm/lead/${id}`);

export const importarLeadCRM = async (atendimentoID, codigoFamilia) => {
  try {
    return await httpService.post(
      `/integration/crm/lead/${atendimentoID}/empreendimento/${codigoFamilia}`
    );
  } catch (error) {
    throw new Error(
      error.message || 'Erro ao importar lead do CRM para a Extranet'
    );
  }
};

export const obterConstrutor = () => httpService.get(`/prospecto/construtor`);

/**
 *
 * @param {int} id - id do empreendimento
 * @returns string
 */
export const obterMioloContrato = id =>
  httpService.get(`/empreendimento/${id}/miolo-contrato`);

/**
 * @description Função que salva o miolo de um contrato de um empreendimento
 * @returns bool
 */
export const SalvarMioloContrato = async contrato =>
  httpService.post(`/empreendimento/miolo-contrato`, contrato);

/**
 * @description Função que pega informações de uma familia junto com informações dos lotes etc
 *
 */
export const buscarFamilia = async codigoFamilia =>
  httpService.get(`/empreendimento/buscar/${codigoFamilia}`);
/**
 * @description Função que pega informações de uma familia junto com informações dos lotes etc
 *
 */
export const buscarFamiliaLancamento = codigo =>
  httpService.get(`/empreendimento/buscar/lancamento/${codigo}`);
/**
 * @description Função que pega as informações de um ativo em especifico
 * @returns {import('~/Components/Mapa/MapaInterativo').Imovel}
 */
export const buscarAtivo = async codigoAtivo =>
  httpService.get(`/empreendimento/ativo/${codigoAtivo}`);

/**
 * @description Busca dados de simulação de financiamento de um ativo
 * @param {number} codigoAtivo
 * @param {number} [codigoTabela]
 */
export const buscarSimulacaoFinanciamento = async (codigoAtivo, codigoTabela) =>
  httpService.get(
    `/empreendimento/ativo/${codigoAtivo}/simulacao-financiamento${codigoTabela ? `?codigoTabela=${codigoTabela}` : ''
    }`
  );

/**
 * @description Função que faz a reserva do empreendimento
 * @returns bool
 */
export const reservarLote = async codigoAtivo =>
  httpService.post(`/empreendimento/reservar-lote`, codigoAtivo);

export const permitirReserva = async payload =>
  httpService.post('/empreendimento/permitir-reserva', payload);

export const solicitarReservaPendente = async payload =>
  httpService.post('/empreendimento/reserva-pendente', payload);

export const listarReservasPendentes = async filtros =>
  httpService.post('/empreendimento/reservas-pendentes', filtros || {});

export const aprovarReservaPendente = async (codigoPendencia, motivo) =>
  httpService.post(
    `/empreendimento/reserva-pendente/${codigoPendencia}/aprovar`,
    { motivo: motivo || null }
  );

export const reprovarReservaPendente = async (codigoPendencia, motivo) =>
  httpService.post(
    `/empreendimento/reserva-pendente/${codigoPendencia}/reprovar`,
    { motivo }
  );

/**
 * @description Função que pega as informações de alçada dos corretores e gerentes
 */
export const pegarValoresAlcadas = async codigoFamilia =>
  httpService.get(`/venda/valoresAlcadas/${codigoFamilia}`);
/**
 * @description Função que pega os lotes reservados de uma familia
 * @returns {Promise<[]>}
 */
export const listarLotesReservados = async codigoFamilia =>
  httpService.get(`/empreendimento/listar-reservados/${codigoFamilia}`);

/**
 * @description Função que excluir reserva de um ativo
 */
export const excluirReserva = async excluirReserva =>
  httpService.post(`/empreendimento/excluir-reserva/${excluirReserva}`);

export const excluirReservaComJustificativa = async (
  codigoAtivo,
  justificativa
) =>
  httpService.post(
    `/empreendimento/excluir-reserva-com-justificativa/${codigoAtivo}`,
    justificativa
  );

export const listarMotivosCancelamento = async () =>
  httpService.get('/empreendimento/motivos-cancelamento');

/**
 * @description Função que excluir reserva de um ativo
 */
export const estornarLote = async codigoAtivo =>
  httpService.post(`/empreendimento/estornar/${codigoAtivo}`);

/**
 * @description Retorna os dados das propostas baseadas nos filtros especificados
 */
export const consultarAdmVendas = async filtrosRequest =>
  httpService.post(`/proposta/consultar-adm-vendas`, filtrosRequest);

export const atualizarReserva = async payload =>
  httpService.post(`/empreendimento/atualizar-reserva`, payload);

export const obterCodigoDocDigital = async codigoPreVenda =>
  httpService.get(`/proposta/obter-codigo-docDigital/${codigoPreVenda}`);

export const obterFamiliaPreVenda = async codigoPreVenda =>
  httpService.get(`/proposta/obter-familia-preVenda/${codigoPreVenda}`);

export const obterProspectoCriptografado = async codigoProspecto =>
  httpService.get(
    `/prospecto/obter-prospecto-criptografado/${codigoProspecto}`
  );

/*
 * @description Função para pegar as informações da mesa
 * @returns {InfoMesa[]}
 */
export const pegarInformacoesMapa = async codigoFamilia =>
  httpService.get(`/lancamento/mesa/informacoes/${codigoFamilia}`);

/**
 * @description Função para transferir um lote para outra mesa
 * @returns {bool}
 */
export const transferenciaLote = async novaReserva =>
  httpService.post(`/lancamento/transferir-lote`, novaReserva);

export const buscarCorretoresTransferencia = familia =>
  httpService.get(`/lancamento/atendimento/${familia}/corretores`);

export const obterConferenciaDocumento = async codigoPreVenda =>
  httpService.get(`/proposta/obter-conferencia-documento/${codigoPreVenda}`);

export const conferirDocumento = async conferenciaRequest =>
  httpService.post(`/proposta/conferir-documento`, conferenciaRequest);

export const verificarBoletoPreVenda = async preVenda =>
  httpService.get(`/titulos/existe-boleto/${preVenda}`);

export const detalharPreVenda = async preVenda =>
  httpService.get(`/venda/detalharPreVenda/${preVenda}`);

export const obterDadosManutencaoVenda = async preVenda =>
  httpService.get(`/venda/manutencaoVenda/${preVenda}`);

export const assinarContratoConjugeSocio = async request =>
  httpService.post(`/venda/manutencaoVenda/assinar`, request);

export const incluirConjugeSocioPreVenda = async request =>
  httpService.post(`/venda/manutencaoVenda/incluir`, request);

export const obterSociedadeManutencaoVenda = (codigoProposta, seq) =>
  httpService.get(`/proposta/buscar-sociedade/${codigoProposta}/${seq}`);

export const incluirSociedade = async request =>
  httpService.post(`/venda/manutencaoVenda/incluir-sociedade`, request);

export const excluirSociedade = async request =>
  httpService.post(`/venda/manutencaoVenda/excluir-sociedade`, request);

export const obterDadosPreVendaSemConjuge = async preVenda =>
  httpService.get(`/preVenda/sem-conjuge/obter-dados/${preVenda}`);

export const autorizarPreVendaSemConjuge = async request =>
  httpService.post(`/preVenda/sem-conjuge/autorizar`, request);

export const gerarUrlDocumentoTemporario = async relativeUrl =>
  httpService.get(relativeUrl);

export const buscarDocumentosPreVenda = async codigoPreVenda =>
  httpService.get(`/proposta/buscar-documentos/${codigoPreVenda}`);

export const buscarDadosEstorno = async request =>
  httpService.post(`/proposta/relatorio/buscar-dados-estorno`, request);

export const pesquisarDocumentosParaAssinatura = async request =>
  httpService.post(`/documento-digital/pesquisar-contratos`, request);

export const pesquisarDocumentosD4sign = async request =>
  httpService.post(`/documento-digital/consultar`, request);

export const buscarContratosProspecto = async (codigoConta, ge) =>
  httpService.get(`/prospecto/obter-contrato/${codigoConta}/${ge}`);

export const BuscarSolicitacoesCancelamento = async (codigoDocDigital = 0) => {
  return httpService.get(
    `/documento-digital/BuscarSolicitacoesCancelamento/${codigoDocDigital}`
  );
};

export const buscarContraProposta = async codigoProposta =>
  httpService.get(`/venda/contraproposta/ocorrencias/${codigoProposta}`);

export const buscarCondicaoEspecial = async codigoProposta =>
  httpService.get(`/venda/condicao-especial/${codigoProposta}`);

export const buscarDocAprovacaoFinanciamento = async request =>
  httpService.post(`/prospecto/buscarDocAprovacaoFinanciamento`, request);

export const uploadDocAprovacaoFinanciamento = async request =>
  httpService.post(`/prospecto/uploadDocAprovacaoFinanciamento`, request);

export const deleteDocAprovacaoFinanciamento = async request =>
  httpService.post(`/prospecto/deleteDocAprovacaoFinanciamento`, request);

export const buscarDados = async request =>
  httpService.post(`/relatorios/produtividade/cobradores`, request);

export const buscarUsuariosCobradores = async request =>
  httpService.get(`/usuario/cobradores`, request);

export const obterDetalhesPrevenda = async codigoPrevenda =>
  httpService.get(`/proposta/detalhes-prevenda/${codigoPrevenda}`);

export const obterContrato = async (codigoProspecto, codigoEmpreendimento) =>
  httpService.get(
    `/prospecto/obter-contratos/${codigoProspecto}/${codigoEmpreendimento}`
  );
// W-0608: aceita string (retro-compat com chamadas antigas) ou objeto { status, validade }.
export const obterUsuarios = async filtroOuStatus => {
  const params =
    typeof filtroOuStatus === 'string' || filtroOuStatus == null
      ? { status: filtroOuStatus || 'ativos' }
      : {
        status: filtroOuStatus.status || 'ativos',
        validade: filtroOuStatus.validade || 'todos',
      };
  return httpService.get(`/usuario`, { params });
};

// W-0608: export PDF da consulta de usuarios.
// Pattern correto blob (LICOES Ciclo 10 L2): httpService.fetch com responseType, NUNCA httpService.post + 3o arg.
export const exportarUsuariosPdf = filtros =>
  httpService.fetch({
    method: 'post',
    url: '/usuario/exportar-pdf',
    data: filtros,
    responseType: 'blob',
  });

// Gerador de Assinatura de E-mail — migração de webforms-extranet/WebImob2015/Assinatura.aspx.
// Arte de fundo da unidade (blob, para o preview).
export const obterArteAssinatura = unidadeId =>
  httpService.get(`/assinatura-email/arte/${unidadeId}`, { responseType: 'blob' });

// Gera a imagem final no backend e devolve o JPG (blob) para download.
export const gerarAssinatura = payload =>
  httpService.fetch({
    method: 'post',
    url: '/assinatura-email/gerar',
    data: payload,
    responseType: 'blob',
  });

// Substitui a arte de uma unidade (multipart). Gated por característica no backend.
export const alterarArteAssinatura = formData =>
  httpService.post('/assinatura-email/alterar-arte', formData);

export const obterCreci = async id => httpService.get(`/usuario/${id}/creci`);
export const obterHistoricoProspecto = async codigoPrevenda =>
  httpService.get(`/prospecto/obter-historico/${codigoPrevenda}`);

export const salvarAtividade = async request =>
  httpService.post(`/prospecto/atividade/salvar`, request);

export const salvarAtividadeComAnexo = async (request, arquivo) => {
  const formData = new FormData();
  formData.append('request', JSON.stringify(request));
  formData.append('arquivo', arquivo);
  return httpService.post(`/prospecto/atividade/upload`, formData);
};

export const downloadAnexoAnotacao = async (codigoAtividade, nomeArquivo) => {
  const response = await httpService.get(
    `/prospecto/atividade/${codigoAtividade}/download-anexo`,
    {
      responseType: 'blob',
    }
  );
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const visualizarAnexoAnotacao = async (codigoAtividade, nomeArquivo) => {
  const response = await httpService.get(
    `/prospecto/atividade/${codigoAtividade}/visualizar-anexo`,
    {
      responseType: 'blob',
    }
  );
  const extensao = nomeArquivo
    .split('.')
    .pop()
    .toLowerCase();
  const mimeTypes = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
  };
  const tipo = mimeTypes[extensao] || 'application/octet-stream';
  const blob = new Blob([response], { type: tipo });
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
};

export const editarAtividade = async request =>
  httpService.post(`/prospecto/atividade/editar`, request);

export const buscarHistoricoEdicoesAtividades = async codigoProspecto =>
  httpService.get(`/prospecto/atividade/${codigoProspecto}/historico-edicoes`);

export const AtualizarStatusLeadBolsao = async (
  codigo_prospecto,
  codigo_familia,
  status
) =>
  httpService.post(
    `/prospecto/atualizar-status/bolsao/${codigo_prospecto}/${codigo_familia}/${status}`
  );
export const atualizarInteresseSocial = (codigoProspecto, valor) =>
  httpService.post(`/prospecto/${codigoProspecto}/interesse-social/${valor}`);
export const atualizarSetclubProspecto = (codigoProspecto, valor) =>
  httpService.post(`/prospecto/${codigoProspecto}/setclub/${valor}`);
export const verificarClausulaContratoAvista = async codigoPrevenda =>
  httpService.get(
    `/proposta/manutencao-venda/verificar-clausula-contrato/${codigoPrevenda}`
  );

export const atualizarClausulaContratoAvista = async request =>
  httpService.post(
    `/proposta/manutencao-venda/alterar-contrato-a-vista`,
    request
  );

export const BuscarClientesPainelRmm = async () =>
  httpService.get('/painelrmm/clients');

export const BuscarHosts = async clientSelecionado =>
  httpService.get(`/painelrmm/hosts/${clientSelecionado}`);

export const EnviarMensagemParaHost = async request =>
  httpService.post(`/painelrmm/enviar-mensagem`, request);

export const EnviarMensagemParaSite = async request =>
  httpService.post(`/painelrmm/enviar-mensagem/site`, request);

export const BuscarAgendaAtividades = async filtros =>
  httpService.post('/prospecto/agenda/atividades/buscar', filtros);

export const criarEventoCalendarioExterno = async request =>
  httpService.post('/agendamento/calendario-externo/evento/criar', request);

export const EnviarPlanilhaCargaLancamento = async request =>
  httpService.post(`/exportador/lancamento/carga-excel`, request);

export const BuscarTagsAtendimento = async filtros =>
  httpService.post('/prospecto/tag/buscar', filtros);

export const InserirTagAtendimento = async request =>
  httpService.post('/prospecto/tag/inserir', request);

export const AtualizarTagAtendimento = async request =>
  httpService.post('/prospecto/tag/atualizar', request);

export const ExcluirTagATendimento = async request =>
  httpService.post('/prospecto/tag/excluir', request);

export const BuscarVinculosTag = async codigo_tag =>
  httpService.get(`/prospecto/tag/buscar-vinculos/${codigo_tag}`);

export const buscarTagsAutocomplete = descricaoTag =>
  httpService.get(`/prospecto/tag/auto-complete?descricaoTag=${descricaoTag}`);

export const vincularTag = request =>
  httpService.post('/prospecto/tag/criar-vinculo', request);

export const removerTag = request =>
  httpService.post('/prospecto/tag/remover-vinculo', request);

export const obterSugestaoProspectos = request =>
  httpService.post('/prospecto/unificacao/sugestoes', request);

export const unificarProspectos = request =>
  httpService.post('/prospecto/unificar', request);

export const cadastrarEscala = request => httpService.post('/escala', request);
export const BuscarEscalas = request => httpService.get('/escala', request);
export const BuscarEscalasComEmpreendimento = (
  codigo_escala,
  codigo_escala_empreendimento
) =>
  httpService.get(
    `/escala/empreendimento/${codigo_escala}/${codigo_escala_empreendimento}`
  );

export const BuscarEscala = id => httpService.get(`/escala/${id}`);

export const VerDetalhesEscala = id =>
  httpService.get(`/escala/detalhes/${id}`);

export const EditarEscala = (request, id) =>
  httpService.post(`/escala/${id}`, request);

export const InativarEscala = id =>
  httpService.post(`/escala/alternar-status/${id}`);

export const BuscarAtendentesCAV = () =>
  httpService.get('/usuario/atendentes-CAV');

export const BuscarEmpreendimentosVinculados = request =>
  httpService.get('/escala/empreendimento', request);

export const VerDetalhesEscalaEmpreendimento = codigoEscalaEmpreendimento =>
  httpService.get(`/escala/empreendimento/${codigoEscalaEmpreendimento}`);

export const cadastrarEscalaEmpreendimento = request =>
  httpService.post('/escala/empreendimento', request);

export const BuscarEscalasEmpreendimento = request =>
  httpService.get('/escala/empreendimento', request);

export const BuscarEscalaEmpreendimento = id =>
  httpService.get(`/escala/empreendimento/${id}`);

export const EditarEscalaEmpreendimento = (request, id) =>
  httpService.post(`/escala/empreendimento/${id}`, request);

export const InativarEscalaEmpreendimento = id =>
  httpService.post(`/escala/empreendimento/alternar-status/${id}`);

export const BuscarCorretoresVinculados = request =>
  httpService.get('/escala/corretor', request);

export const cadastrarEscalaCorretor = request =>
  httpService.post('/escala/corretor', request);

export const BuscarEscalasCorretor = request =>
  httpService.get('/escala/corretor', request);

export const BuscarEscalaCorretor = id =>
  httpService.get(`/escala/corretor/${id}`);

export const BuscarDetalhesEscalaCorretor = codigoCorretor =>
  httpService.get(`/escala/corretor/detalhes/${codigoCorretor}`);

export const VerDetalhesEscalaCorretor = id =>
  httpService.get(`/escala/corretor/${id}`);

export const EditarEscalaCorretor = (request, id) =>
  httpService.post(`/escala/corretor/${id}`, request);

export const InativarEscalaCorretor = id =>
  httpService.post(`/escala/corretor/alternar-status/${id}`);

export const BuscarFamiliasEscala = request =>
  httpService.get('/escala/familias', request);

export const BuscarPdvsEscala = codigoFamilia =>
  httpService.get(`/opcao/pdv/${codigoFamilia}`);

export const BuscarEscalasParaFila = codigoFamilia =>
  httpService.get(`/escala/buscar/fila/${codigoFamilia}`);

export const BuscarInfoPosicaoCorretores = (
  codigoEscala,
  codigoEscalaEmpreendimento
) => {
  let url = `/escala/fila/corretores/${codigoEscala}/${codigoEscalaEmpreendimento ||
    0}`;

  return httpService.get(url);
};

export const AtualizarOrdemCorretores = request =>
  httpService.post(`/escala/fila/corretores/atualizar-ordem`, request);

export const AtribuirAtendenteCAV = request =>
  httpService.post(`/prospecto/atribuir/atendente-CAV`, request);

export const AtribuirCorretorManual = request =>
  httpService.post(`/escala/manual/corretor/atribuir-cliente`, request);

export const AtribuirCorretorFila = request =>
  httpService.post(`/escala/fila/corretor/atribuir-cliente`, request);
export const removerResponsavelProspecto = data =>
  httpService.post('/prospecto/desassociar-responsavel', data);
export const buscarOcorrenciasProspecto = cpf =>
  httpService.get(`/prospecto/ocorrencias/${cpf}`);

export const consultarRelatorioAlcadas = filtros =>
  httpService.post('/empreendimento/alcadas/consultar', filtros);

export const consultarRelatorioPosVenda = filtros =>
  httpService.post('/venda/pos-venda/consultar', filtros);

export const consultarRelatorio = filtros =>
  httpService.post('/log/escalas', filtros);

export const buscarProcessosJuridicosPorCPF = async cpf =>
  httpService.get(`/lawyer/processos-judiciais/consultar/${cpf}`);

export const buscarProcessosJuridicos = request =>
  httpService.post(`/lawyer/processos-judiciais/consultar`, request);

export const sincronizarDadosGESLawyer = boleto =>
  httpService.get(`/lawyer/processos-judiciais/sincronizar/${boleto}`);

export const buscarDadosConversaoLeads = request =>
  httpService.post(`/relatorios/conversao/leads`, request);

export const buscarDadosEnquadramentoGuarulhos = request =>
  httpService.post(`/relatorios/enquadramento-guarulhos/consultar`, request);

export const consultarRelatorioRankingVendas = filtros =>
  httpService.post('/venda/relatorio/ranking-vendas', filtros);

// W-0771 — Relatório Vendas com Desconto (Imob > Comercial > Vendas)
// Prefixo plural /relatorios/ — alinhado com RelatoriosController ([RoutePrefix("relatorios")])
// (ver MEMORY.md §Endpoints Publicados — divergência vs PROMPT resolvida pelo backend)
export const getEmpreendimentosVendasDesconto = () =>
  httpService.get('/relatorios/vendas-desconto/empreendimentos');

export const buscarVendasDesconto = filtro =>
  httpService.post('/relatorios/vendas-desconto/buscar', filtro);

// LICOES Ciclo 10 L2: blob via httpService.fetch, NUNCA httpService.post + 3o arg
export const exportarVendasDesconto = filtro =>
  httpService.fetch({
    method: 'post',
    url: '/relatorios/vendas-desconto/exportar-excel',
    data: filtro,
    responseType: 'blob',
  });

export const consultarRelatorioRescisoes = filtros =>
  httpService.post('/relatorios/rescisao', filtros);

export const buscarEventosTag = codigo_familia =>
  httpService.get(`/empreendimento/${codigo_familia}/eventos/tags`);

export const importarAtivosEmpreendimento = (codigoFamilia, formData) =>
  httpService.post(
    `/empreendimento/${codigoFamilia}/ativos/importar`,
    formData
  );

export const buscarTodosEventos = () =>
  httpService.get(`/empreendimento/eventos/tags`);

export const inserirOuAtualizarParametrosCorretor = request =>
  httpService.post(`/indicacao/parametros/corretor`, request);

export const inserirOuAtualizarParametrosEmpreendimento = request =>
  httpService.post(`/indicacao/parametros/empreendimento`, request);

export const buscarParametrosEmpreendimentos = () =>
  httpService.get('/indicacao/parametros/empreendimentos');

export const buscarParametrosEmpreendimento = codigoFamilia =>
  httpService.get(`/indicacao/familias/${codigoFamilia}/parametros`);

export const buscarParametrosCorretores = () =>
  httpService.get('/indicacao/parametros/corretores');

export const deletarParametro = (id, contexto) =>
  httpService.post(`/indicacao/parametros/${id}`, { contexto });

export const inserirPromotor = async dados => {
  await httpService.post(`/indicacao/cadastrar/promotor`, dados);
};

export const atualizarPromotor = async dados => {
  await httpService.patch(`/indicacao/atualizar/promotor`, dados);
};

export const buscarPromotor = codigo_usuario =>
  httpService.get(`/indicacao/buscar/promotores/${codigo_usuario}`);

export const buscarPromotores = () =>
  httpService.get('/indicacao/buscar/promotores');

export const ativarInativarPromotor = (id, ativo) =>
  httpService.post(`/indicacao/promotores/mudar/status`, {
    codigo_usuario: id,
    status: ativo,
  });
export const relatorioInatividadeLeads = filtro =>
  httpService.post(`/prospecto/relatorio/inatividade/buscar`, filtro);

export const buscarRelatorioEtapas = filtro =>
  httpService.post(`/prospecto/etapas/atualizar`, filtro);

export const atribuicaoAtendenteCavEmMassa = request =>
  httpService.post(`/prospecto/atribuir/atendente-CAV-em-massa`, request);

export const atribuicaoEtapaEmMassa = request =>
  httpService.post(`/prospecto/atribuir/etapas`, request);

export const getEtapas = () => httpService.get(`/prospecto/etapas-prospecto`);

export const getMidias = () => httpService.get(`/prospecto/midias`);

export const inativarProspectoEmTodasEscalas = codigo_corretor =>
  httpService.post(`/escala/corretor/inativar-todos/${codigo_corretor}`);

export const getCanalOrigem = () => httpService.get(`/prospecto/canal-origem`);

export const getMidiaOrigem = () => httpService.get(`/prospecto/midia-origem`);

export const lotesDisponiveis = familia => {
  return httpService.get(`/empreendimento/lotes-disponiveis/${familia}`);
};
export const dadosBancariosEmpreendimento = familia => {
  return httpService.get(`/empreendimento/conta-bancaria/${familia}`);
};

export const usuarioPromotor = async codigo => {
  return httpService.get(`/usuario/${codigo}/promotor-externo`);
};

export const relatorioAutoAtendimento = filtros =>
  httpService.post(`/relatorios/auto-atendimento/relatorios-acessos`, filtros);

export const ativosPrecificacao = async codigoFamilia => {
  return httpService.get(
    `/empreendimento/${codigoFamilia}/ativos/precificacao`
  );
};

export const salvarPrecificacaoAtivo = async (codigoAtivo, data) =>
  httpService.post(
    `/empreendimento/ativos/${codigoAtivo}/precificacao/atualizar`,
    data
  );

export const casasDisponiveis = () => {
  return httpService.get(`/empreendimento/casas-disponiveis`);
};

export const atualizarObsCasaDisponivel = async (codigoAtivo, data) =>
  httpService.patch(
    `/empreendimento/ativos/${codigoAtivo}/casas-disponiveis/atualizar-observacao`,
    data
  );

export const inserirCasaDisponivel = async data =>
  httpService.post(`/empreendimento/ativos/casas-disponiveis`, data);

export const modificarCasaDisponivel = async request =>
  httpService.post(
    `/empreendimento/ativos/casas-disponiveis/modificar`,
    request
  );

export const buscarFotosCasaDisponivel = async codigoAtivo =>
  httpService.get(`/empreendimento/casas-disponiveis/fotos/${codigoAtivo}`);

export const uploadFotosCasaDisponivel = (
  codigoAtivo,
  empreendimento,
  quadra,
  lote,
  formData
) =>
  httpService.post(
    `/empreendimento/casas-disponiveis/fotos/${codigoAtivo}?empreendimento=${encodeURIComponent(
      empreendimento
    )}&quadra=${encodeURIComponent(quadra)}&lote=${encodeURIComponent(lote)}`,
    formData
  );

export const downloadFotoCasaDisponivel = async codigoFoto =>
  httpService.get(
    `/empreendimento/casas-disponiveis/fotos/download/${codigoFoto}`
  );

export const excluirFotoCasaDisponivel = async codigoFoto =>
  httpService.post(
    `/empreendimento/casas-disponiveis/fotos/${codigoFoto}/excluir`
  );

export const relatorioAutoAtendimentoAnalitico = async data =>
  httpService.post(
    '/relatorios/auto-atendimento/relatorios-acessos/analitico',
    data
  );

export const buscarParametrosPDV = empreendimentoId =>
  httpService.get(`/empreendimento/parametros-pdv/buscar/${empreendimentoId}`);

export const salvarReservasMapaEmpreendimento = payload =>
  httpService.post(
    `/empreendimento/parametros-pdv/mapa-empreendimento`,
    payload
  );

export const buscarParametrosPdvLancamento = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/buscar/lancamento/${empreendimentoId}`
  );

export const salvarLancamentoEmpreendimento = payload =>
  httpService.post(`/empreendimento/parametros-pdv/lancamento`, payload);

export const BuscarEmpreendimentosPDV = () =>
  httpService.get(`/empreendimento/empreendimentos-pdv`);

export const salvarEspecifico = payload =>
  httpService.post('/empreendimento/parametros-pdv/especifico', payload);

export const buscarParametrosEspecifico = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/especifico/buscar/${empreendimentoId}`
  );

export const apagarParametroEspecifico = seCodigo =>
  httpService.post(
    `/empreendimento/parametros-pdv/especifico/apagar/${seCodigo}`
  );

export const incluirCheque = payload =>
  httpService.post('/empreendimento/parametros-pdv/incluir-cheque', payload);

export const buscarCheques = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/buscar-cheque/${empreendimentoId}`
  );

export const apagarCheque = codigo =>
  httpService.post(`/empreendimento/parametros-pdv/cheque/apagar/${codigo}`);

export const buscarAlcadaAtiva = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/buscar/alcada-cadastro/${empreendimentoId}`
  );

export const salvarAlcada = payload =>
  httpService.post(`/empreendimento/parametros-pdv/salvar-alcada`, payload);

export const buscarTabelaAlcada = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/buscar-tabela/alcada/${empreendimentoId}`
  );

export const buscarParametrosIntegracao = empreendimentoId =>
  httpService.get(
    `/empreendimento/parametros-pdv/integracao/buscar/${empreendimentoId}`
  );

export const salvarParametrosIntegracao = payload =>
  httpService.post(`/empreendimento/parametros-pdv/integracao`, payload);

// W-0645 — Parâmetros do sistema > Fusão (UPDATE-only sobre Param2 Codigo IN (1,2))
export const buscarParametrosFusao = () =>
  httpService.get('/parametros/fusao');

export const salvarParametrosFusaoSetCorp = payload =>
  httpService.post('/parametros/fusao/setcorp', payload);

export const salvarParametrosFusaoSetPar = payload =>
  httpService.post('/parametros/fusao/setpar', payload);

// DW-0999 — Parâmetros > Contatos de Teste
export const buscarParametrosContatosTeste = () =>
  httpService.get('/parametros/contatos-teste');

export const salvarParametrosContatosTeste = payload =>
  httpService.post('/parametros/contatos-teste/salvar', payload);

export const imoveisDisponiveis = async data =>
  httpService.post('/empreendimento/imoveis-disponiveis', data);

export const excluirEscalaCorretor = async codigoEscalaCorretor =>
  httpService.post(`/escala/corretor/${codigoEscalaCorretor}/excluir`);

export const atualizarProspectoGES = request =>
  httpService.post(`/prospecto/ges/atualizar`, request);

export const verificarSegundoProponente = async data =>
  httpService.post(`/prospecto/verificar-segundo-proponente`, data);

export const atualizarParametrosSegundoProponente = async params =>
  httpService.post(`/prospecto/segundo-proponente/parametros`, params);

export const buscarParametrosSegundoProponente = async () =>
  httpService.get(`/prospecto/segundo-proponente/parametros`);

export const listarSolicitacoesCessao = async filtros =>
  httpService.post(`/auto-atendimento/cessao/listar`, filtros);

export const obterHistoricoCessao = async codigoSolicitacao =>
  httpService.get(`/auto-atendimento/cessao/${codigoSolicitacao}/historico`);

export const obterDetalhesCessao = async codigoSolicitacao =>
  httpService.get(`/auto-atendimento/cessao/${codigoSolicitacao}/detalhes`);

export const alterarStatusCessao = async request =>
  httpService.post('/auto-atendimento/cessao/alterar-status', request);

export const bloquearSolicitacaoCessao = async request =>
  httpService.post('/auto-atendimento/cessao/bloquear', request);

export const desbloquearSolicitacaoCessao = async request =>
  httpService.post('/auto-atendimento/cessao/desbloquear-ferramenta', request);

export const alterarTipoTaxaCessao = async request =>
  httpService.post('/auto-atendimento/cessao/alterar-tipo-taxa', request);

export const cessaoTiposTaxa = async () =>
  httpService.get('/auto-atendimento/cessao/tipos-taxa');

export const processarInativacaoCessao = async () =>
  httpService.post('/auto-atendimento/cessao/processar-inativacao');

export const cancelarSolicitacaoCessao = async request =>
  httpService.post('/auto-atendimento/cessao/cancelar', request);

export const registrarLogCessao = async request =>
  httpService.post('/auto-atendimento/cessao/registrar-log', request);

export const cessaoInfosBoleto = async codigoSolicitacao =>
  httpService.get(`/auto-atendimento/cessao/${codigoSolicitacao}/infos-boleto`);

export const isentarTaxaCessao = async request =>
  httpService.post('/auto-atendimento/cessao/isentar', request);

export const gerarBoletoCessao = async request =>
  httpService.post('/auto-atendimento/cessao/gerar-boleto', request);

export const salvarConferenciaCamposCessao = async request =>
  httpService.post('/auto-atendimento/cessao/salvar-conferencia', request);

export const obterConferenciaCamposCessao = async codigoSolicitacao =>
  httpService.get(`/auto-atendimento/cessao/${codigoSolicitacao}/conferencia`);

export const obterCamposInvalidosCessao = async codigoSolicitacao =>
  httpService.get(
    `/auto-atendimento/cessao/${codigoSolicitacao}/campos-invalidos`
  );

export const obterDocumentoDigitalCessao = async codigoSolicitacao =>
  httpService.get(
    `/auto-atendimento/cessao/${codigoSolicitacao}/documento-digital`
  );

export const downloadDocumentoCessao = async codigoDocumento =>
  httpService.get(
    `/auto-atendimento/cessao/documento/${codigoDocumento}/download`,
    { responseType: 'blob' }
  );

export const obterDocumentoDigitalCessaoPorPreVenda = async numeroPreVenda =>
  httpService.get(
    `/auto-atendimento/cessao/pre-venda/${numeroPreVenda}/documento-digital`
  );

export const buscarRelatorioProdutividadeComissoes = request =>
  httpService.post('/comissao/relatorio/produtividade/buscar', request);

export const relatorioGestaoRecisoes = async data =>
  httpService.post('/relatorios/gestao-rescisoes', data);

export const SismacObterDetalhes = async familia =>
  httpService.get(`/empreendimento/sismac/detalhes-empreendimento/${familia}`);

export const SismacAtualizarStatusEmpreendimento = async (
  codigoFamilia,
  data
) =>
  httpService.post(
    `/empreendimento/sismac/${codigoFamilia}/atualizar-status`,
    data
  );

export const SismacListar = async (categoria, emp) =>
  httpService.get(`/sismac/${categoria}/${emp}`);

const codificarAlbum = album =>
  encodeURIComponent(album.replace(/\./g, '__DOT__'));

export const SismacListarAlbum = async (categoria, emp, album) =>
  httpService.get(`/sismac/${categoria}/${emp}/album/${codificarAlbum(album)}`);

export const SismacDownloadArquivo = (categoria, emp, arquivo) =>
  httpService.get(
    `/sismac/${categoria}/${emp}/download?arquivo=${encodeURIComponent(
      arquivo
    )}`
  );

export const SismacDownloadArquivoAlbum = (categoria, emp, album, arquivo) =>
  httpService.get(
    `/sismac/${categoria}/${emp}/album/${codificarAlbum(
      album
    )}/download?arquivo=${encodeURIComponent(arquivo)}`
  );

export const SismacDownloadAlbumZip = (categoria, emp, album) =>
  httpService.get(
    `/sismac/${categoria}/${emp}/album/${codificarAlbum(album)}/download-zip`
  );

export const SismacUploadArquivo = (categoria, emp, data) =>
  httpService.post(`/sismac/${categoria}/${emp}/upload`, data);

export const SismacUploadArquivoAlbum = (categoria, emp, album, data) =>
  httpService.post(
    `/sismac/${categoria}/${emp}/album/${codificarAlbum(album)}/upload`,
    data
  );

export const SismacCriarAlbum = async (categoria, emp, data) =>
  httpService.post(`/sismac/${categoria}/${emp}/album`, data);

export const SismacExcluirArquivo = async (categoria, emp, arquivo) =>
  httpService.post(
    `/sismac/${categoria}/${emp}/delete?arquivo=${encodeURIComponent(arquivo)}`
  );

export const SismacExcluirArquivoAlbum = async (
  categoria,
  emp,
  album,
  arquivo
) =>
  httpService.post(
    `/sismac/${categoria}/${emp}/album/${codificarAlbum(
      album
    )}/delete?arquivo=${encodeURIComponent(arquivo)}`
  );

export const SismacExcluirAlbum = async (categoria, emp, album) =>
  httpService.post(
    `/sismac/${categoria}/${emp}/album/${codificarAlbum(album)}/excluir`
  );

export const SismacObterArteFacebook = async emp =>
  httpService.get(`/sismac/pecas-facebook/${emp}`);

export const SismacUploadArteFacebook = async (emp, data) =>
  httpService.post(`/sismac/pecas-facebook/${emp}/upload`, data);

export const SismacGerarArteFacebookPersonalizada = async data =>
  httpService.post('/sismac/pecas-facebook/gerar', data);

export const BuscarLogoImob = async imob =>
  httpService.get(`/sismac/pecas-facebook/imobiliaria/${imob}`);

export const confirmarEnderecoProspecto = async codigoProspecto =>
  httpService.post(`/prospecto/${codigoProspecto}/confirmar-endereco`);

export const atribuirResponsavelDocumentoDigital = async codigoDocumentoDigital =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/atribuir-assinatura`
  );

export const desatribuirResponsavelDocumentoDigital = async (
  codigoDocumentoDigital,
  justificativa
) =>
  httpService.post(
    `/documento-digital/${codigoDocumentoDigital}/desatribuir-assinatura`,
    { value: justificativa }
  );

export const buscarHistoricoAtribuicaoDocumentoDigital = async codigoDocumentoDigital =>
  httpService.get(
    `/documento-digital/${codigoDocumentoDigital}/historico-atribuicao`
  );

export const buscarOptionsMesa = (familia, tipoAtendimento) =>
  httpService.get(`/lancamento/mesas/options/${familia}/${tipoAtendimento}`);

export const buscarTabelaMesa = (familia, tipoAtendimento) =>
  httpService.get(
    `/lancamento/mesas/buscar-tabela/${familia}/${tipoAtendimento}`
  );

export const salvarNovaMesa = async payload =>
  httpService.post(`/lancamento/mesas/salvar`, payload);

export const apagarMesa = (
  codigoUsuario,
  familia,
  tipoAtendimento,
  codigoGrupo
) =>
  httpService.post(
    `/lancamento/mesas/deletar/${codigoUsuario}?familia=${familia}&tipoAtendimento=${tipoAtendimento}&codigoGrupo=${codigoGrupo}`
  );

export const ativarDesativarTodos = (familia, tipoAtendimento, tipoOperacao) =>
  httpService.post(
    `/lancamento/mesas/ativar-desativar-todos/${familia}/${tipoAtendimento}/${tipoOperacao}`
  );

export const inserirGrupoTodos = (familia, tipoAtendimento) =>
  httpService.post(
    `/lancamento/mesas/inserir-grupo-todos/${familia}/${tipoAtendimento}`
  );

export const removerGrupoTodos = (familia, tipoAtendimento) =>
  httpService.post(
    `/lancamento/mesas/remover-grupo-todos/${familia}/${tipoAtendimento}`
  );

export const ativarUsuarioUnico = (
  codigoUsuario,
  familia,
  tipoAtendimento,
  codigoGrupo
) =>
  httpService.post(
    `/lancamento/mesas/ativar-unico/${codigoUsuario}/${familia}/${tipoAtendimento}/${codigoGrupo}`
  );

export const desativarUsuarioUnico = (
  codigoUsuario,
  familia,
  tipoAtendimento
) =>
  httpService.post(
    `/lancamento/mesas/desativar-unico/${codigoUsuario}/${familia}/${tipoAtendimento}`
  );

export const buscarLeadRDStation = uuid =>
  httpService.get(`/prospecto/rdStation/${uuid}`);

export const consultarEtapaAtualProspecto = codigoProspecto =>
  httpService.get(`/prospecto/etapa/${codigoProspecto}`);

export const verificarTemMesa = familia =>
  httpService.get(`/lancamento/mesas/verificar-tem-mesa/${familia}`);

export const incluirNumeroMesa = (familia, codigoMesa, numeroMesa) =>
  httpService.post(
    `/lancamento/mesas/incluir-numero-mesa?familia=${familia}&codigoMesa=${codigoMesa}&numeroMesa=${numeroMesa}`
  );

export const definirDisponivel = (codigo, livre) =>
  httpService.post(`/lancamento/mesas/definir-disponivel/${codigo}/${livre}`);

export const buscarCorretoresLancamento = familia =>
  httpService.get(`/lancamento/atendimento/${familia}/corretores`);

export const buscarClienteLancamento = (
  familia,
  codigo,
  atendimentoPreferencial
) => {
  var url = `/lancamento/atendimento/buscar-cliente/${familia}/${codigo}`;
  if (atendimentoPreferencial != null) {
    url += '?atendimentoPreferencial=' + atendimentoPreferencial;
  }
  return httpService.get(url);
};

export const verificarVinculoProspecto = (familia, codigoProspecto) =>
  httpService.get(
    `/lancamento/atendimento/verificar-vinculo/${familia}/${codigoProspecto}`
  );

export const buscarAtendimentoAtual = familia =>
  httpService.get(`/lancamento/atendimento/${familia}/atual`);

export const validarSenhaTrocaCorretor = senha =>
  httpService.post(`/lancamento/atendimento/validar-senha-liberacao`, {
    senha,
  });

export const trocarCorretorAtendimento = request =>
  httpService.post(`/lancamento/atendimento/trocar-corretor`, request);

export const iniciarAtendimento = request =>
  httpService.post(`/lancamento/atendimento/iniciar`, request);

export const finalizarAtendimentoColaborador = (
  codigo,
  removerReservas = true
) =>
  httpService.post(`/lancamento/atendimento/${codigo}/finalizar`, {
    remover_reservas: removerReservas,
  });

export const finalizarComoVisitaLoteamento = codigo =>
  httpService.post(`/lancamento/atendimento/${codigo}/visitar-loteamento`);

export const buscarMotivosNaoCompra = () =>
  httpService.get(`/lancamento/atendimento/motivos-nao-compra`);

export const gravarPesquisaNaoCompra = (codigo, request) =>
  httpService.post(
    `/lancamento/atendimento/${codigo}/gravar-pesquisa`,
    request
  );
export const BuscarCorretores = () =>
  httpService.get(`/empreendimento/comercial/corretores`);

export const BuscarCorretoresUsuarios = () =>
  httpService.get(`/opcao/corretor`);
export const listarContratosComConstrucao = filtro =>
  httpService.post('/empreendimento/contrato/alienacao-fiduciaria', filtro);

export const HierarquiaComercial = corretor =>
  httpService.get(`/empreendimento/comercial/hierarquia/${corretor}`);

export const consultarIndicadoresLeadsSintetico = filtros =>
  httpService.post(
    '/relatorio-leads-vendas/indicadores-leads/sintetico',
    filtros
  );

export const consultarConversoesVendasSintetico = filtros =>
  httpService.post(
    '/relatorio-leads-vendas/conversoes-vendas/sintetico',
    filtros
  );

export const getImobiliariasRelatorioLeadsVendas = () =>
  httpService.get('/relatorio-leads-vendas/imobiliarias');

export const buscarHistoricoCEDOC = numeroPreVenda =>
  httpService.get(`/cedoc/contrato/${numeroPreVenda}/historico`);

export const buscarStatusCEDOC = numeroPreVenda =>
  httpService.get(`/cedoc/contrato/${numeroPreVenda}/status`);

export const receberContratoCEDOC = numeroPreVenda =>
  httpService.post(`/cedoc/contrato/${numeroPreVenda}/receber`);

export const aprovarContratoCEDOC = (numeroPreVenda, data) =>
  httpService.post(`/cedoc/contrato/${numeroPreVenda}/aprovar`, data);

export const recusarContratoCEDOC = (numeroPreVenda, data) =>
  httpService.post(`/cedoc/contrato/${numeroPreVenda}/recusar`, data);

export const criarRegistroPendenteCEDOC = numeroPreVenda =>
  httpService.post(`/cedoc/contrato/${numeroPreVenda}/criar-pendente`);

export const getCorretoresPorImobiliaria = codigosImobiliaria =>
  httpService.post('/relatorio-leads-vendas/corretores', {
    codigos_imobiliaria: codigosImobiliaria,
  });

export const consultarIndicadoresLeadsAnalitico = filtros =>
  httpService.post(
    '/relatorio-leads-vendas/indicadores-leads/analitico',
    filtros
  );

export const consultarConversoesVendasAnalitico = filtros =>
  httpService.post(
    '/relatorio-leads-vendas/conversoes-vendas/analitico',
    filtros
  );

export const consultarSolicitacoesAutoatendimentoEscritura = filtros =>
  httpService.post('/autoatendimento/escritura/solicitacoes/obter', filtros);

export const atualizarSolicitacaoEscritura = dados =>
  httpService.post('/autoatendimento/escritura/solicitacoes/atualizar', dados);

export const enviarDocumentoEscritura = formData =>
  httpService.post(
    '/autoatendimento/escritura/solicitacoes/enviar-documento',
    formData
  );

export const obterDetalhesSolicitacaoEscritura = (
  codigoBoleto,
  codigoConta,
  ge
) =>
  httpService.get(
    `/autoatendimento/escritura/solicitacoes/detalhes/${codigoBoleto}/${codigoConta}/${ge}`
  );

export const buscarDocumentoDigitalEscritura = (codigoBoleto, tipo) =>
  httpService.get(
    `/autoatendimento/escritura/solicitacoes/${codigoBoleto}/documento-digital/${tipo}`,
    { responseType: 'blob' }
  );

export const obterAnexoHerdeiro = codigoAnexo =>
  httpService.get(
    `/autoatendimento/escritura/solicitacoes/herdeiros/anexo/${codigoAnexo}`,
    { responseType: 'blob' }
  );

export const uploadDocumentoDigitalEscritura = (
  codigoBoleto,
  codigoDocumentoDigital
) =>
  httpService.post(
    `/autoatendimento/escritura/solicitacoes/${codigoBoleto}/upload/${codigoDocumentoDigital}`
  );

export const cancelarDocumentoDigitalEscritura = (
  codigoDocumentoDigital,
  message,
  codigoMotivoCancelamento
) =>
  httpService.post(
    `/autoatendimento/escritura/solicitacoes/${codigoDocumentoDigital}/cancelar?codigoMotivoCancelamento=${codigoMotivoCancelamento}`,
    { value: message }
  );

export const descartarDocumentoDigitalEscritura = (
  codigoDocumentoDigital,
  message
) =>
  httpService.post(
    `/autoatendimento/escritura/solicitacoes/${codigoDocumentoDigital}/descartar`,
    { value: message }
  );



export const listarHerdeirosEscritura = codigoBoleto =>
  httpService.get(
    `/autoatendimento/escritura/solicitacoes/${codigoBoleto}/herdeiros`
  );

export const obterAnexoHerdeiroEscrituraUrl = codigoAnexo =>
  `/autoatendimento/escritura/solicitacoes/herdeiros/anexo/${codigoAnexo}`;

export const obterAnexoHerdeiroEscritura = codigoAnexo =>
  httpService.get(
    `/autoatendimento/escritura/solicitacoes/herdeiros/anexo/${codigoAnexo}`,
    { responseType: 'blob' }
  );

export const buscarEmpreendimentosBaseConhecimento = data => {
  return httpService.post(`/base-conhecimento/empreendimentos`, data);
};

export const buscarDetalhesEmpreendimentoBaseConhecimento = codigoFamilia =>
  httpService.get(`/base-conhecimento/empreendimentos/${codigoFamilia}`);

export const buscarInformacoesAdicionais = data =>
  httpService.post(`/base-conhecimento/informacoes`, data);

export const buscarUsuariosInformacoes = () =>
  httpService.get(`/base-conhecimento/informacoes/usuarios`);

export const buscarInformacaoPorCodigo = codigo =>
  httpService.get(`/base-conhecimento/informacoes/${codigo}`);

export const salvarInformacaoAdicional = data =>
  httpService.post(`/base-conhecimento/informacoes/salvar`, data);

export const excluirInformacaoAdicional = codigo =>
  httpService.post(`/base-conhecimento/informacoes/${codigo}/excluir`);

export const buscarAnexos = (tipo, codigoReferencia) =>
  httpService.get(`/base-conhecimento/anexos/${tipo}/${codigoReferencia}`);

export const uploadAnexo = (tipo, codigoReferencia, formData) =>
  httpService.post(
    `/base-conhecimento/anexos/${tipo}/${codigoReferencia}/upload`,
    formData
  );

export const excluirAnexo = codigo =>
  httpService.post(`/base-conhecimento/anexos/${codigo}/excluir`);

export const downloadAnexo = async (codigo, nomeArquivo) => {
  const response = await httpService.get(
    `/base-conhecimento/anexos/${codigo}/download`,
    {
      responseType: 'blob',
    }
  );
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const buscarPerguntas = data =>
  httpService.post(`/base-conhecimento/perguntas`, data);

export const buscarUsuariosPerguntas = () =>
  httpService.get(`/base-conhecimento/perguntas/usuarios`);

export const buscarPerguntaPorCodigo = codigo =>
  httpService.get(`/base-conhecimento/perguntas/${codigo}`);

export const salvarPergunta = data =>
  httpService.post(`/base-conhecimento/perguntas/salvar`, data);

export const responderPergunta = data =>
  httpService.post(`/base-conhecimento/perguntas/responder`, data);

export const excluirPergunta = codigo =>
  httpService.post(`/base-conhecimento/perguntas/${codigo}/excluir`);
export const buscarVideosTreinamento = id =>
  httpService.get(`/lancamento/treinamento/videos/${id}`);

export const salvarCampanhaMarketing = async filtros =>
  httpService.post('/marketing/campanha', filtros);

export const editarCampanhaMarketing = async (id, filtros) =>
  httpService.post(`/marketing/campanha/${id}`, filtros);

export const listarCampanhasMarketing = filtros =>
  httpService.post('/marketing/campanha/listar', filtros || {});

export const inativarCampanhaMarketing = id =>
  httpService.post('/marketing/campanha/' + id + '/inativar');

export const alterarStatusCampanhaMarketing = (codigoCampanha, status) =>
  httpService.post('/marketing/campanha/alterar-status', {
    codigo_campanha: codigoCampanha,
    status: status,
  });

export const ativarInativarCampanhaMarketing = (
  codigoCampanha,
  ativa,
  motivoInativacao
) =>
  httpService.post('/marketing/campanha/ativar-inativar', {
    codigo_campanha: codigoCampanha,
    ativa: ativa,
    motivo_inativacao: motivoInativacao,
  });

export const buscarConsolidadoCampanhasMarketing = filtros =>
  httpService.post('/marketing/campanha/consolidado', filtros || {});

export const verificarPeriodoLancamento = codigoFamilia =>
  httpService.get(`/lancamento/verificar-periodo/${codigoFamilia}`);

export const removerMesaUsuario = (codigoUsuario, familia) =>
  httpService.post(
    `/lancamento/mesas/remover-mesa/${familia}/${codigoUsuario}`
  );

export const getRelatorioPreEncaminhamento = codigoFamilia =>
  httpService.get(`/lancamento/pre-encaminhamento/${codigoFamilia}/relatorio`);

export const getSenhasPreEncaminhamento = codigoFamilia =>
  httpService.get(`/lancamento/pre-encaminhamento/${codigoFamilia}/senhas`);

export const chamarProximaSenhaPreEncaminhamento = (
  codigoFamilia,
  senhaEspecifica = null
) =>
  httpService.post('/lancamento/pre-encaminhamento/chamar-proxima', {
    codigo_familia: codigoFamilia,
    senha_especifica: senhaEspecifica,
  });

export const recallSenhaPreEncaminhamento = codigoSenha =>
  httpService.post(`/lancamento/pre-encaminhamento/recall/${codigoSenha}`);

export const toggleSenhaPreEncaminhamento = codigoSenha =>
  httpService.post(`/lancamento/pre-encaminhamento/toggle/${codigoSenha}`);

export const encaminharSenhaPreEncaminhamento = codigoSenha =>
  httpService.post(`/lancamento/pre-encaminhamento/encaminhar/${codigoSenha}`);

export const atualizarPainelPreEncaminhamento = codigoFamilia =>
  httpService.post(
    `/lancamento/pre-encaminhamento/${codigoFamilia}/atualizar-painel`
  );

export const getRelatorioEncaminhamento = codigoFamilia =>
  httpService.get(`/lancamento/encaminhamento/${codigoFamilia}/relatorio`);

export const getSenhasEncaminhamento = codigoFamilia =>
  httpService.get(`/lancamento/encaminhamento/${codigoFamilia}/senhas`);

export const getMesasEncaminhamento = codigoFamilia =>
  httpService.get(`/lancamento/encaminhamento/${codigoFamilia}/mesas`);

export const chamarProximaSenhaEncaminhamento = codigoFamilia =>
  httpService.post(
    `/lancamento/encaminhamento/${codigoFamilia}/chamar-proxima`
  );

export const recallSenhaEncaminhamento = codigoSenha =>
  httpService.post(`/lancamento/encaminhamento/recall/${codigoSenha}`);

export const toggleSenhaEncaminhamento = codigoSenha =>
  httpService.post(`/lancamento/encaminhamento/toggle/${codigoSenha}`);

export const atualizarPainelEncaminhamento = codigoFamilia =>
  httpService.post(
    `/lancamento/encaminhamento/${codigoFamilia}/atualizar-painel`
  );

export const encaminharParaMesa = (
  codigoSenha,
  codigoFamilia,
  mesaEspecifica = null
) =>
  httpService.post('/lancamento/encaminhamento/encaminhar-mesa', {
    codigo_senha: codigoSenha,
    codigo_familia: codigoFamilia,
    mesa_especifica: mesaEspecifica,
  });

export const getRelatorioAssinatura = codigoFamilia =>
  httpService.get(
    `/lancamento/encaminhamento-assinatura/${codigoFamilia}/relatorio`
  );

export const getSenhasAssinatura = codigoFamilia =>
  httpService.get(
    `/lancamento/encaminhamento-assinatura/${codigoFamilia}/senhas`
  );

export const chamarSenhaAssinatura = codigoSenha =>
  httpService.post(
    `/lancamento/encaminhamento-assinatura/chamar/${codigoSenha}`
  );

export const recallSenhaAssinatura = codigoSenha =>
  httpService.post(
    `/lancamento/encaminhamento-assinatura/recall/${codigoSenha}`
  );

export const entradaSenhaEspecifica = (
  codigoFamilia,
  senha,
  atendimentoPreferencial
) =>
  httpService.post('/lancamento/encaminhamento-assinatura/entrada-especifica', {
    codigo_familia: codigoFamilia,
    senha,
    atendimento_preferencial: atendimentoPreferencial,
  });

export const marcarComparecimentoAssinatura = codigoSenha =>
  httpService.post(
    `/lancamento/encaminhamento-assinatura/marcar-comparecimento/${codigoSenha}`
  );

export const chamarProximaSenhaAssinatura = codigoFamilia =>
  httpService.post(
    `/lancamento/encaminhamento-assinatura/${codigoFamilia}/chamar-proxima`
  );

export const removerMesaUsuarioAssinatura = (codigoUsuario, familia) =>
  httpService.post(
    `/lancamento/mesas/remover-mesa/${familia}/${codigoUsuario}`
  );

export const buscarProspectoParaUnificacao = request =>
  httpService.post(`/prospecto/unificacao/buscar`, request);

export const buscarFilasDistribuicao = codigoEmpreendimento =>
  httpService.get(`/escala/buscar/fila/${codigoEmpreendimento}`);

export const atribuirCorretorEmMassa = request =>
  httpService.post(`/prospecto/atribuir/corretor-em-massa`, request);

export const enviarParaFilaDistribuicao = request =>
  httpService.post(`/prospecto/atribuir/fila-distribuicao`, request);

export const atribuirInteresseEmMassa = request =>
  httpService.post(`/prospecto/atribuir/interesse-em-massa`, request);

export const inserirBolsaoEmMassa = request =>
  httpService.post(`/prospecto/atribuir/bolsao-em-massa`, request);

export const removerBolsaoEmMassa = request =>
  httpService.post(`/prospecto/remover/bolsao-em-massa`, request);

export const atribuirSetclubEmMassa = request =>
  httpService.post(`/prospecto/atribuir/setclub-em-massa`, request);

export const removerSetclubEmMassa = request =>
  httpService.post(`/prospecto/remover/setclub-em-massa`, request);

export const desassociarCorretorEmMassa = request =>
  httpService.post(`/prospecto/desassociar/corretor-em-massa`, request);

export const desassociarGestorCAVEmMassa = request =>
  httpService.post(`/prospecto/desassociar/gestor-cav-em-massa`, request);

export const buscarCorretoresPorImobiliaria = codigoImobiliaria =>
  httpService.get(`/corretor/imobiliaria/${codigoImobiliaria}`);

export const buscarImoveisEmpreendimento = empreendimento =>
  httpService.get(`/empreendimento/${empreendimento}/ativos`);

export const buscarImovel = codigoAtivo =>
  httpService.get(`/empreendimento/ativo/${codigoAtivo}`);

export const buscarFilaLote = request =>
  httpService.post('/fila-lote/buscar', request);

export const incluirNaFilaLote = request =>
  httpService.post('/fila-lote/incluir', request);

export const excluirDaFilaLote = request =>
  httpService.post('/fila-lote/excluir', request);

export const buscarProspectoFilaCPF = cpf =>
  httpService.get(`/fila-lote/prospecto/${cpf}/buscar`);

export const verificarFilaAtivo = codigoAtivo =>
  httpService.get(`/fila-lote/verificar-fila/${codigoAtivo}`);

export const buscarAtivosPorEmpreendimento = request =>
  httpService.post('/fila-lote/relatorio/ativos', request);

export const buscarDetalheAtivoFila = codigoAtivo =>
  httpService.get(`/fila-lote/relatorio/ativo/${codigoAtivo}/detalhe`);
export const buscarRelatorioConferencia = filtros =>
  httpService.post(`/venda/relatorio/conferencia`, filtros);

export const consultarDashboardVendasImobiliaria = filtros =>
  httpService.post(
    '/relatorios/dashboard-vendas-imobiliaria/consultar',
    filtros
  );

export const buscarPdfPorUrl = url =>
  httpService.get(url, { responseType: 'blob' });

export const buscarAlcadasAutoatendimento = () =>
  httpService.get('/auto-atendimento-renegociacao/alcadas');

export const buscarParametrosAutoatendimento = codigoAlcada => {
  return httpService.post(`/auto-atendimento-renegociacao/parametros`, {
    codigo_alcada: codigoAlcada,
  });
};

export const exportarParametrosAutoatendimento =
  '/exportador/excel/parametros-renegociacao';

export const importarParametrosAutoatendimento = (codigoAlcada, formData) =>
  httpService.post(
    `/auto-atendimento-renegociacao/importar?codigoAlcada=${codigoAlcada}`,
    formData
  );

export const confirmarImportacaoAutoatendimento = data =>
  httpService.post('/auto-atendimento-renegociacao/confirmar', data);

export const buscarHistoricoAutoatendimento = codigoAlcada =>
  httpService.get(
    `/auto-atendimento-renegociacao/alcada/${codigoAlcada}/historico`
  );

export const reverterVersaoAutoatendimento = data =>
  httpService.post('/auto-atendimento-renegociacao/reverter', data);

export const previewVersaoAutoatendimento = data =>
  httpService.post('/auto-atendimento-renegociacao/preview-versao', data);

export const buscarClassificacoesAutoatendimento = () =>
  httpService.get('/auto-atendimento-renegociacao/classificacoes');

export const buscarClassificacoesEmpreendimento = () =>
  httpService.get('/empreendimento/classificacoes');
export const getPermissoesConsultaAcesso = () =>
  httpService.get('/usuario/consulta-acesso/permissoes');

export const listarGruposConsultaAcesso = () =>
  httpService.get('/usuario/consulta-acesso/grupos');

export const buscarUsuarioConsultaAcesso = (
  termo,
  codigoDepartamento,
  codigoGrupo
) => {
  const params = {};
  if (termo) params.termo = termo;
  if (codigoDepartamento) params.codigoDepartamento = codigoDepartamento;
  if (codigoGrupo) params.codigoGrupo = codigoGrupo;
  return httpService.get('/usuario/consulta-acesso/buscar-usuarios', {
    params,
  });
};

export const buscarClienteConsultaAcesso = termo =>
  httpService.get(
    `/cliente/consulta-acesso/buscar-clientes?termo=${encodeURIComponent(
      termo
    )}`
  );

export const buscarClienteConsultaAcessoSenhaAmbiente = termo =>
  httpService.get(
    `/cliente/consulta-acesso/buscar-clientes-senha?termo=${encodeURIComponent(
      termo
    )}`
  );

export const listarFavoritosConsultaAcesso = () =>
  httpService.get('/usuario/consulta-acesso/favoritos');

export const adicionarFavoritoConsultaAcesso = (identificador, isUser) =>
  httpService.post('/usuario/consulta-acesso/favoritos', {
    identificador,
    is_user: isUser,
  });

export const removerFavoritoConsultaAcesso = identificador =>
  httpService.post(
    `/usuario/consulta-acesso/favorito/excluir/${identificador}`
  );

export const removerTodosFavoritosConsultaAcesso = () =>
  httpService.post('/usuario/consulta-acesso/favoritos/excluir');

export const consultarRelatorioVendasEmpreendimento = filtros =>
  httpService.post(
    '/relatorios/dashboard-vendas-empreendimento/consultar',
    filtros
  );

export const consultarRelatorioVendasTrimestre = filtros =>
  httpService.post('/relatorios/relatorio-vendas-trimestre/consultar', filtros);

export const consultarAtendimentosLancamento = filtros =>
  httpService.post('/relatorios/lancamento/atendimentos', filtros);

export const consultarDashboardLancamento = filtros =>
  httpService.post('/relatorios/lancamento/dashboard', filtros);

export const consultarPainelExecutivoLancamento = filtros =>
  httpService.post('/relatorios/lancamento/painel-executivo', filtros);

export const consultarProspectosPainelExecutivo = filtros =>
  httpService.post(
    '/relatorios/lancamento/painel-executivo/prospectos',
    filtros
  );

export const consultarVendasPainelExecutivo = filtros =>
  httpService.post('/relatorios/lancamento/painel-executivo/vendas', filtros);

export const consultarDashboardEstoque = filtros =>
  httpService.post('/relatorios/dashboard-estoque/consultar', filtros);

export const consultarDashboardEstoqueHistorico = filtros =>
  httpService.post('/relatorios/dashboard-estoque/historico', filtros);

export const obterEmpreendimentosEstoque = () =>
  httpService.get('/relatorios/dashboard-estoque/empreendimentos');

export const obterCidadesEstoque = () =>
  httpService.get('/relatorios/dashboard-estoque/cidades');

export const consultarRelatorioMotivosNaoCompra = filtros =>
  httpService.post('/relatorios/motivos-nao-compra/consultar', filtros);

export const consultarRelatorioMotivosNaoCompraDetalhado = filtros =>
  httpService.post('/relatorios/motivos-nao-compra/detalhado', filtros);

export const exportarMotivosNaoCompraExcel = filtros =>
  httpService.post('/relatorios/motivos-nao-compra/exportar-excel', filtros, {
    responseType: 'blob',
  });

export const obterEmpreendimentosMotivosNaoCompra = () =>
  httpService.get('/relatorios/motivos-nao-compra/empreendimentos');

// Comissao Corretor
export const obterDatasRelatorioComissao = codigoUsuario =>
  httpService.get('/relatorios/comissao/datas/' + (codigoUsuario || ''));

export const obterRelatorioComissao = filtros =>
  httpService.post('/relatorios/comissao/listar', filtros);

export const exportarComissaoExcel = filtros =>
  httpService.post('/relatorios/comissao/exportar-excel', filtros, {
    responseType: 'blob',
  });

export const exportarComissaoPdf = filtros =>
  httpService.post('/relatorios/comissao/exportar-pdf', filtros, {
    responseType: 'blob',
  });

export const exportarReciboComissaoIntPdf = filtros =>
  httpService.post('/relatorios/comissao/recibo-intermediacao', filtros, {
    responseType: 'blob',
  });
export const consultarRelatorioProspectosPastas = filtros =>
  httpService.post('/relatorios/prospectos-pastas/consultar', filtros);

export const obterEmpreendimentosProspectosPastas = () =>
  httpService.get('/relatorios/prospectos-pastas/empreendimentos');

export const consultarRelatorioPesquisaProspecto = filtros =>
  httpService.post('/relatorios/pesquisa-prospecto/consultar', filtros);

export const obterDadosIniciaisPesquisaProspecto = filtros =>
  httpService.post('/relatorios/pesquisa-prospecto/dados-iniciais', filtros);

export const obterEmpreendimentosPesquisaProspecto = () =>
  httpService.get('/relatorios/pesquisa-prospecto/empreendimentos');

export const buscarEmpreendimentoLancamento = codigoFamilia =>
  httpService.get(`/empreendimento/buscar/dados/lancamento/${codigoFamilia}`);

export const consultarRelatorioLancamento = filtros =>
  httpService.post('/relatorios/lancamento/consultar', filtros);

export const obterDadosIniciaisLancamento = () =>
  httpService.get('/relatorios/lancamento/dados-iniciais');

// Fila do Lote
export const consultarFilaLote = filtros =>
  httpService.post('/relatorios/fila-lote/consultar', filtros);

export const obterDetalheAtivoFilaLote = filtros =>
  httpService.post('/relatorios/fila-lote/detalhe', filtros);

export const obterEmpreendimentosFilaLote = () =>
  httpService.get('/relatorios/fila-lote/empreendimentos');

// Debitos/Creditos
export const obterOpcoesDebitosCreditos = () =>
  httpService.get('/relatorios/debitos-creditos/opcoes');

export const obterContasDebitosCreditos = codigoUsuario =>
  httpService.get('/relatorios/debitos-creditos/contas/' + codigoUsuario);

export const consultarDebitosCreditos = filtros =>
  httpService.post('/relatorios/debitos-creditos/consultar', filtros);
export const gerarLinkCadastro = data =>
  httpService.post('/prospecto/gerar-link-cadastro', data);

export const consultarRelatorioInteressesLote = filtros =>
  httpService.post('/relatorios/interesses-lote/consultar', filtros);

export const consultarInteressesLoteDetalhe = filtros =>
  httpService.post('/relatorios/interesses-lote/detalhe', filtros);

export const inserirNovaLocalidade = data =>
  httpService.post('/brinde/inserir/localidade', data);

export const buscarLocalidadesCadastradas = () =>
  httpService.get('/brinde/localidades-cadastradas');

export const inserirUsuarioLocalidade = (codigoLocalidade, codigoUsuario) =>
  httpService.post(
    `/brinde/inserir/localidades/${codigoLocalidade}/usuario/${codigoUsuario}`
  );

export const atualizarLocalidade = data =>
  httpService.post('/brinde/atualizar/localidade', data);

export const excluirLocalidade = (codigoLocalidade, justificativa) =>
  httpService.post(`/brinde/excluir/localidade/${codigoLocalidade}`, {
    justificativa,
  });

export const excluirUsuarioLocalidade = (
  codigoLocalidade,
  codigoUsuario,
  justificativa
) =>
  httpService.post(
    `/brinde/excluir/localidades/${codigoLocalidade}/usuario/${codigoUsuario}`,
    { justificativa }
  );

export const inserirTipoBrinde = data =>
  httpService.post('/brinde/inserir/tipo-brinde', data);

export const buscarTiposBrinde = () => httpService.get('/brinde/tipos-brinde');

export const excluirTipoBrinde = codigo =>
  httpService.post(`/brinde/excluir/tipo-brinde/${codigo}`);

export const buscarEstoqueBrindes = () =>
  httpService.get('/brinde/estoque-brindes');

export const buscarEstoqueUsuario = () =>
  httpService.get('/brinde/estoque-usuario');

export const inserirBrindeLocalidade = data =>
  httpService.post('/brinde/inserir/brinde-localidade', data);

export const atualizarBrindeLocalidade = data =>
  httpService.post('/brinde/atualizar/brinde-localidade', data);

export const excluirBrindeLocalidade = data =>
  httpService.post('/brinde/excluir/brinde-localidade', data);

export const buscarRelatorioAdministracaoBrinde = filtros =>
  httpService.post('/brinde/relatorio/administracao', filtros);

export const verificarElegibilidadeCliente = cpf =>
  httpService.get(`/brinde/cliente/${cpf}/elegibilidade`);

export const entregarBrinde = data =>
  httpService.post('/brinde/entregar', data);

export const buscarHistoricoClienteBrinde = cpf =>
  httpService.get(`/brinde/cliente/${cpf}/historico`);

export const buscarRelatorioEntreguesBrinde = filtros =>
  httpService.post('/brinde/relatorio/entregues', filtros);

export const buscarRelatorioClientesBrinde = filtros =>
  httpService.post('/brinde/relatorio/clientes', filtros);

export const buscarOpcoesFiltrosBrinde = () =>
  httpService.get('/brinde/opcoes/filtros');

export const obterOpcoesSaldos = () =>
  httpService.get('/relatorios/saldos/opcoes');

export const buscarCorretoresSaldos = () =>
  httpService.get('/relatorios/saldos/corretores');

export const consultarSaldos = codigoUsuario =>
  httpService.get('/relatorios/saldos/consultar/' + codigoUsuario);

export const lancarConferenciaSaldo = dados =>
  httpService.post('/relatorios/saldos/conferir', dados);

// Portador Usuário
export const listarPortadoresUsuario = codigoUsuario =>
  httpService.get(
    `/portador-usuario${codigoUsuario ? `?codigo_usuario=${codigoUsuario}` : ''
    }`
  );

export const incluirPortadorUsuario = dados =>
  httpService.post('/portador-usuario', dados);

export const excluirPortadorUsuario = dados =>
  httpService.post('/portador-usuario/excluir', dados);

export const marcarPortadorPrincipal = dados =>
  httpService.post('/portador-usuario/principal/atualizar', dados);

export const listarUsuariosAtivosPortador = () =>
  httpService.get('/portador-usuario/usuarios');

export const listarGruposEmpresaPortador = excluirUsuario =>
  httpService.get(
    '/portador-usuario/grupos-empresa' +
    (excluirUsuario ? '?excluir_usuario=' + excluirUsuario : '')
  );

export const listarContasPortador = codigoGrupoEmpresa =>
  httpService.get(`/portador-usuario/contas/${codigoGrupoEmpresa}`);

export const listarVinculosCopiaPortador = codigoGrupoEmpresa =>
  httpService.get(`/portador-usuario/copia/${codigoGrupoEmpresa}`);

export const copiarPortadoresEntreGEs = dados =>
  httpService.post('/portador-usuario/copia', dados);

// W-0724: Portador Jurídico (Imob)
export const listarPortadoresJuridicos = (codigoGE, page = 1, pageSize = 20) =>
  httpService.get('/portador-juridico', {
    params: { ge: codigoGE, page, page_size: pageSize },
  });

export const listarGruposEmpresaPortadorJuridico = () =>
  httpService.get('/portador-juridico/grupos-empresa');

export const listarContasJuridicas = codigoGE =>
  httpService.get(`/portador-juridico/contas-juridicas/${codigoGE}`);

export const listarPortadoresPorGE = codigoGE =>
  httpService.get(`/portador-juridico/portadores/${codigoGE}`);

export const incluirPortadorJuridico = dados =>
  httpService.post('/portador-juridico', dados);

export const excluirPortadorJuridico = dados =>
  httpService.post('/portador-juridico/excluir', dados);

// === W-0234: TABELA DE PREÇO ===

// Correção
export const getCorrecoes = familia =>
  httpService.get(`/tabela-preco/correcao?familia=${familia}`);
export const criarCorrecao = data =>
  httpService.post('/tabela-preco/correcao', data);
export const atualizarCorrecao = (codigo, data) =>
  httpService.post(`/tabela-preco/correcao/${codigo}/atualizar`, data);
export const excluirCorrecao = codigo =>
  httpService.post(`/tabela-preco/correcao/${codigo}/excluir`);
export const alterarStatusCorrecao = (codigo, status) =>
  httpService.post(`/tabela-preco/correcao/${codigo}/alterar-status`, {
    status,
  });

// Taxa
export const getTaxas = () => httpService.get('/tabela-preco/taxa');
export const getPrazos = codigoTaxa =>
  httpService.get(`/tabela-preco/taxa/${codigoTaxa}/prazos`);
export const criarTaxa = data => httpService.post('/tabela-preco/taxa', data);
export const atualizarTaxa = (codigo, data) =>
  httpService.post(`/tabela-preco/taxa/${codigo}/atualizar`, data);
export const excluirTaxa = codigo =>
  httpService.post(`/tabela-preco/taxa/${codigo}/excluir`);
export const getCorrecoesVinculadas = codigoTaxa =>
  httpService.get(`/tabela-preco/taxa/${codigoTaxa}/correcoes-vinculadas`);

// Preço
export const getPrecos = familia =>
  httpService.get(`/tabela-preco/preco?familia=${familia}`);
export const criarPreco = data => httpService.post('/tabela-preco/preco', data);
export const atualizarPreco = data =>
  httpService.post('/tabela-preco/preco/atualizar', data);
export const excluirPreco = (familia, qualidade) =>
  httpService.post(`/tabela-preco/preco/${familia}/${qualidade}/excluir`);
export const importarPrecos = formData =>
  httpService.post('/tabela-preco/preco/importar', formData);
export const exportarPrecos = familia =>
  httpService.get(`/tabela-preco/preco/exportar?familia=${familia}`, {
    responseType: 'blob',
  });

// Tabelas geradas
export const getTabelas = (familia, correcao, status) => {
  let url = `/tabela-preco/tabela?familia=${familia}&status=${status || 'T'}`;
  if (correcao) url += `&correcao=${correcao}`;
  return httpService.get(url);
};
export const alterarDataTabela = (codigo, data) =>
  httpService.post(`/tabela-preco/tabela/${codigo}/data/atualizar`, data);
export const alterarStatusTabela = codigo =>
  httpService.post(`/tabela-preco/tabela/${codigo}/status/atualizar`);
export const alterarDpcTabela = (codigo, data) =>
  httpService.post(`/tabela-preco/tabela/${codigo}/dpc/atualizar`, data);
export const excluirTabela = codigo =>
  httpService.post(`/tabela-preco/tabela/${codigo}/excluir`);

// Geração
export const getCorrecoesAtivasGeracao = familia =>
  httpService.get(`/tabela-preco/geracao/correcoes-ativas?familia=${familia}`);
export const getCotacao = (moeda, data) =>
  httpService.get(`/tabela-preco/geracao/cotacao?moeda=${moeda}&data=${data}`);
export const gerarTabela = data =>
  httpService.post('/tabela-preco/geracao/gerar', data);

// Intermediária
export const getIntermediarias = familia =>
  httpService.get(`/tabela-preco/intermediaria?familia=${familia}`);
export const criarIntermediaria = data =>
  httpService.post('/tabela-preco/intermediaria', data);
export const atualizarIntermediaria = (codigo, data) =>
  httpService.post(`/tabela-preco/intermediaria/${codigo}/atualizar`, data);
export const excluirIntermediaria = codigo =>
  httpService.post(`/tabela-preco/intermediaria/${codigo}/excluir`);
export const toggleStatusIntermediaria = codigo =>
  httpService.post(`/tabela-preco/intermediaria/${codigo}/status/atualizar`);
export const reordenarIntermediarias = data =>
  httpService.post('/tabela-preco/intermediaria/reordenar', data);

// Lookups
export const getMoedas = () => httpService.get('/tabela-preco/moeda');
export const getQualidades = () => httpService.get('/tabela-preco/qualidade');

// === W-0234: QUALIDADE ATIVO ===

export const getAtivosQualidade = (
  familia,
  quadra,
  loteDe,
  loteAte,
  inativos
) =>
  httpService.get(
    `/qualidade-ativo/ativos?familia=${familia}&quadra=${quadra ||
    ''}&loteDe=${loteDe || ''}&loteAte=${loteAte || ''}&inativos=${inativos ||
    false}`
  );
export const atualizarQualidadeEmMassa = data =>
  httpService.post('/qualidade-ativo/qualidade/atualizar', data);
export const importarQualidades = formData =>
  httpService.post('/qualidade-ativo/qualidade/importar', formData);
export const exportarQualidades = familia =>
  httpService.get(`/qualidade-ativo/qualidade/exportar?familia=${familia}`, {
    responseType: 'blob',
  });
export const getQualidadesEmpreendimento = familia =>
  httpService.get(`/qualidade-ativo/qualidade/opcoes?familia=${familia}`);
export const importarDadosImovel = formData =>
  httpService.post('/qualidade-ativo/dados-imovel/importar', formData);
export const exportarDadosImovel = familia =>
  httpService.get(`/qualidade-ativo/dados-imovel/exportar?familia=${familia}`, {
    responseType: 'blob',
  });
export const uploadAnexoQualidade = (codigoAtivo, formData) =>
  httpService.post(`/qualidade-ativo/anexo/${codigoAtivo}`, formData);
export const excluirAnexoQualidade = codigoAtivo =>
  httpService.post(`/qualidade-ativo/anexo/${codigoAtivo}/excluir`);
export const visualizarAnexoQualidade = codigoAtivo =>
  httpService.get(`/qualidade-ativo/anexo/${codigoAtivo}`, {
    responseType: 'blob',
  });
export const importarParcelas = formData =>
  httpService.post('/qualidade-ativo/parcelas/importar', formData);
export const exportarParcelas = familia =>
  httpService.get(`/qualidade-ativo/parcelas/exportar?familia=${familia}`, {
    responseType: 'blob',
  });

// W-0530: Relatório de Qualidade de Ativos
export const consultarRelatorioQualidadesAtivos = filtros =>
  httpService.post('/relatorios/qualidades-ativos/listar', filtros);

export const exportarRelatorioQualidadesAtivosExcel = filtros =>
  httpService.post('/relatorios/qualidades-ativos/exportar-excel', filtros, {
    responseType: 'blob',
  });

// W-0787: Relatório Análise Empreendimento (Imob/Relatórios/Gerencial)
export const listarGruposEmpresaAnaliseEmpreendimento = () =>
  httpService.get('/analise-empreendimento/grupos-empresa');

export const consultarAnaliseEmpreendimento = filtro =>
  httpService.post('/analise-empreendimento/listar', filtro);

// === W-0431: MANUTENÇÃO DE USUÁRIOS ===

// --- Usuário Admin ---
export const cadastrarUsuarioAdmin = dados =>
  httpService.post('/usuario/admin/cadastrar', dados);

export const atualizarUsuarioAdmin = (codigo, dados) =>
  httpService.post(`/usuario/admin/${codigo}/atualizar`, dados);

export const excluirUsuarioAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/excluir`);

export const inativarUsuarioAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/inativar`);

export const ativarUsuarioAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/ativar`);

export const inativarCorretorAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/inativar-corretor`);

export const ativarCorretorAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/ativar-corretor`);

export const ativarRankingVendaUsuarioAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/ativar-ranking-venda`);

export const inativarRankingVendaUsuarioAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/inativar-ranking-venda`);

export const reinicializarSenhaAdmin = codigo =>
  httpService.post(`/usuario/admin/${codigo}/reinicializar-senha`);

export const testarEmailSmtp = payload =>
  httpService.post('/usuario/testar-email', payload);

// --- Grupo Empresa do Usuário ---
export const listarGrupoEmpresaUsuario = codigo =>
  httpService.get(`/usuario/${codigo}/grupo-empresa`);

export const listarGruposEmpresaDoUsuario = () =>
  httpService.get('/grupo-empresa/lookup/do-usuario');

export const incluirGrupoEmpresa = (codigo, dados) =>
  httpService.post(`/usuario/${codigo}/grupo-empresa`, dados);

export const incluirTodosGrupoEmpresa = codigo =>
  httpService.post(`/usuario/${codigo}/grupo-empresa/incluir-todos`);

export const copiarGrupoEmpresa = (codigo, codigoFonte) =>
  httpService.post(`/usuario/${codigo}/grupo-empresa/copiar/${codigoFonte}`);

export const excluirGrupoEmpresaUsuario = (codigo, codigoGe) =>
  httpService.post(`/usuario/${codigo}/grupo-empresa/${codigoGe}/excluir`);

// --- Características do Usuário ---
export const listarCaracteristicasUsuario = codigo =>
  httpService.get(`/usuario/${codigo}/caracteristica-usuario`);

export const incluirCaracteristicaUsuario = (codigo, dados) =>
  httpService.post(`/usuario/${codigo}/caracteristica-usuario`, dados);

export const copiarCaracteristicasUsuario = (codigo, codigoFonte) =>
  httpService.post(
    `/usuario/${codigo}/caracteristica-usuario/copiar/${codigoFonte}`
  );

export const excluirCaracteristicaUsuario = (codigo, codigoCaract) =>
  httpService.post(
    `/usuario/${codigo}/caracteristica-usuario/${codigoCaract}/excluir`
  );

// --- Grupos de Famílias (W-0473) ---
export const listarGrupoFamilias = () => httpService.get('/grupo-familia');

export const incluirGrupoFamilia = dados =>
  httpService.post('/grupo-familia', dados);

export const atualizarGrupoFamilia = (codigo, dados) =>
  httpService.post(`/grupo-familia/${codigo}/atualizar`, dados);

export const excluirGrupoFamilia = codigo =>
  httpService.post(`/grupo-familia/${codigo}/excluir`);

// --- Variantes de Ativos (W-0465) ---

export const listarVariantesAtivo = () => httpService.get('/variante-ativo');

export const incluirVarianteAtivo = dados =>
  httpService.post('/variante-ativo', dados);

export const atualizarVarianteAtivo = (codigo, dados) =>
  httpService.post(`/variante-ativo/${codigo}/atualizar`, dados);

export const excluirVarianteAtivo = codigo =>
  httpService.post(`/variante-ativo/${codigo}/excluir`);

// --- Grupos de Usuários ---
export const listarGruposUsuario = () => httpService.get('/grupo-usuario');

export const criarGrupoUsuario = dados =>
  httpService.post('/grupo-usuario', dados);

export const atualizarGrupoUsuario = (codigo, dados) =>
  httpService.post(`/grupo-usuario/${codigo}/atualizar`, dados);

export const excluirGrupoUsuario = codigo =>
  httpService.post(`/grupo-usuario/${codigo}/excluir`);

export const copiarGrupoUsuario = (codigo, dados) =>
  httpService.post(`/grupo-usuario/${codigo}/copiar`, dados);

export const listarCaracteristicasGrupo = codigo =>
  httpService.get(`/grupo-usuario/${codigo}/caracteristica`);

export const incluirCaracteristicaGrupo = (codigo, dados) =>
  httpService.post(`/grupo-usuario/${codigo}/caracteristica`, dados);

export const excluirCaracteristicaGrupo = (codigo, codigoCaract) =>
  httpService.post(
    `/grupo-usuario/${codigo}/caracteristica/${codigoCaract}/excluir`
  );

export const listarUsuariosGrupo = codigo =>
  httpService.get(`/grupo-usuario/${codigo}/usuario`);

// --- Catálogo de Características ---
export const listarCaracteristicasCatalogo = (termo = '', filtro = 'todos') => {
  var params = [];
  if (termo) params.push('termo=' + encodeURIComponent(termo));
  if (filtro && filtro !== 'todos') params.push('filtro=' + filtro);
  var qs = params.length > 0 ? '?' + params.join('&') : '';
  return httpService.get('/caracteristica' + qs);
};

export const criarCaracteristica = dados =>
  httpService.post('/caracteristica', dados);

export const atualizarCaracteristica = (codigo, dados) =>
  httpService.post(`/caracteristica/${codigo}/atualizar`, dados);

export const excluirCaracteristica = codigo =>
  httpService.post(`/caracteristica/${codigo}/excluir`);

// --- Lookups Usuário ---
export const buscarUsuarioLogado = () => httpService.get('/usuario/me');

export const contarNaoLidasChat = () =>
  httpService.get('/chat/contagem-nao-lidas');

export const buscarChatsDepartamento = () =>
  httpService.get('/chat/departamento');

export const buscarMeusChats = () => httpService.get('/chat/meus-chats');

export const iniciarConversa = data => httpService.post('/chat/iniciar', data);

export const buscarMensagensChat = (codigoConversa, antes) =>
  httpService.get(`/chat/${codigoConversa}/mensagens`, {
    params: { antes },
  });

export const enviarMensagemChat = data =>
  httpService.post('/chat/enviar-mensagem', data);

export const marcarChatComoLido = codigoConversa =>
  httpService.post(`/chat/${codigoConversa}/marcar-lido`);

export const downloadAnexoChat = async (codigoAnexo, nomeArquivo) => {
  const response = await httpService.get(
    `/chat/anexo/${codigoAnexo}/download`,
    {
      responseType: 'blob',
    }
  );
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const enviarMensagemChatAnexo = formData =>
  httpService.post('/chat/enviar-mensagem-anexo', formData);

export const listarDepartamentos = () =>
  httpService.get('/usuario/lookup/departamentos');

export const listarGruposDepartamento = () =>
  httpService.get('/chat/grupos-departamento');

export const listarDepartamentosPorGrupo = codigoGrupo =>
  httpService.get('/chat/departamentos-por-grupo', {
    params: { codigoGrupo },
  });

export const buscarComunicados = antes =>
  httpService.get('/chat/comunicados', { params: { antes } });

export const publicarComunicado = data =>
  httpService.post('/chat/comunicados/publicar', data);

export const publicarComunicadoAnexo = formData =>
  httpService.post('/chat/comunicados/publicar-anexo', formData);

export const editarComunicado = (codigo, data) =>
  httpService.put(`/chat/comunicados/${codigo}/editar`, data);

export const excluirComunicado = codigo =>
  httpService.delete(`/chat/comunicados/${codigo}`);

export const marcarComunicadoLido = () =>
  httpService.post('/chat/comunicados/marcar-lido');

export const contarNaoLidasComunicados = () =>
  httpService.get('/chat/comunicados/contagem-nao-lidas');

export const downloadAnexoComunicado = async (codigoAnexo, nomeArquivo) => {
  const response = await httpService.get(
    `/chat/comunicado-anexo/${codigoAnexo}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const buscarLeiturasMensagem = (codigoConversa, codigoMensagem) =>
  httpService.get(
    `/chat/${codigoConversa}/mensagens/${codigoMensagem}/leituras`
  );

export const buscarLeiturasComunicado = codigoComunicado =>
  httpService.get(`/chat/comunicados/${codigoComunicado}/leituras`);

export const listarImobiliarias = () =>
  httpService.get('/usuario/lookup/imobiliarias');

export const listarContasPorGrupoEmpresa = codigoGe =>
  httpService.get(`/usuario/lookup/contas-por-ge/${codigoGe}`);

export const listarClientesPorGrupoEmpresa = codigoGe =>
  httpService.get(`/usuario/lookup/clientes-por-ge/${codigoGe}`);

// W-0972: Cadastro de Imobiliárias
export const listarImobiliariasCadastro = () => httpService.get('/imobiliaria');

export const buscarGerentesDisponiveisImobiliaria = () =>
  httpService.get('/imobiliaria/gerentes-disponiveis');

export const buscarContasDisponiveisImobiliaria = () =>
  httpService.get('/imobiliaria/contas-disponiveis');

export const cadastrarImobiliaria = (campos, logoFile) => {
  const fd = new FormData();
  fd.append('nome', campos.nome);
  fd.append('cor', campos.cor);
  fd.append('codigo_gerente', campos.codigo_gerente);
  fd.append('conta_imobiliaria', campos.conta_imobiliaria);
  fd.append('ranking_venda', campos.ranking_venda ? 'true' : 'false');
  fd.append('ativo', campos.ativo ? 'true' : 'false');
  if (logoFile) fd.append('logo', logoFile, logoFile.name);
  return httpService.post('/imobiliaria/cadastrar', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const editarImobiliaria = (campos, logoFile, acaoLogo) => {
  const fd = new FormData();
  fd.append('codigo', campos.codigo);
  fd.append('nome', campos.nome);
  fd.append('cor', campos.cor);
  fd.append('codigo_gerente', campos.codigo_gerente);
  fd.append('conta_imobiliaria', campos.conta_imobiliaria);
  fd.append('acao_logo', acaoLogo);
  if (acaoLogo === 'substituir' && logoFile) {
    fd.append('logo', logoFile, logoFile.name);
  }
  return httpService.post('/imobiliaria/editar', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const alterarStatusImobiliaria = (codigo, ativo) =>
  httpService.post('/imobiliaria/alterar-status', { codigo, ativo });

export const alterarRankingImobiliaria = (codigo, rankingVenda) =>
  httpService.post('/imobiliaria/alterar-ranking', {
    codigo,
    ranking_venda: rankingVenda,
  });

export const listarTodosGruposEmpresa = () =>
  httpService.get('/usuario/lookup/grupos-empresa');

export const listarGruposPorCaracteristica = codigoCaract =>
  httpService.get(`/caracteristica/${codigoCaract}/grupo`);

export const listarUsuariosDiretoCaracteristica = codigoCaract =>
  httpService.get(`/caracteristica/${codigoCaract}/usuario-direto`);

export const listarUsuariosIndiretoCaracteristica = codigoCaract =>
  httpService.get(`/caracteristica/${codigoCaract}/usuario-indireto`);

// === W-0436: INTENÇÕES DE VENDAS ===

export const listarIntencoesVendas = (
  ge,
  empreendimento,
  imovel,
  prevenda,
  corretor,
  status
) =>
  httpService.get('/intencoes-vendas', {
    params: { ge, empreendimento, imovel, prevenda, corretor, status },
  });

export const listarPrestadoresIntencaoVenda = (prevenda, imovel, proposta) =>
  httpService.get(`/intencoes-vendas/${prevenda}/prestadores`, {
    params: { imovel, proposta },
  });

export const detalharIntencaoVenda = (prevenda, conta, tipo) =>
  httpService.get('/intencoes-vendas/detalhamento', {
    params: { prevenda, conta, tipo },
  });

export const listarEmpreendimentosIntencaoVenda = ge =>
  httpService.get('/intencoes-vendas/empreendimentos', { params: { ge } });

// Hierarquia Comercial — W-0435
export const listarTiposComissao = () =>
  httpService.get('/hierarquia-comercial/tipos-comissao');

export const listarContasTipo = (ge, tipo) =>
  httpService.get(`/hierarquia-comercial/contas-tipo/${ge}/${tipo}`);

export const listarSubordinados = (ge, conta, tipo) =>
  httpService.get(`/hierarquia-comercial/subordinados/${ge}/${conta}/${tipo}`);

export const incluirContaTipo = dados =>
  httpService.post('/hierarquia-comercial/conta-tipo', dados);

export const excluirContaTipo = dados =>
  httpService.post('/hierarquia-comercial/conta-tipo/excluir', dados);

export const incluirSubordinado = dados =>
  httpService.post('/hierarquia-comercial/subordinado', dados);

export const excluirSubordinado = dados =>
  httpService.post('/hierarquia-comercial/subordinado/excluir', dados);

export const listarGruposEmpresaHierarquia = () =>
  httpService.get('/hierarquia-comercial/grupos-empresa');

export const listarContasDisponiveisHierarquia = ge =>
  httpService.get(`/hierarquia-comercial/contas-disponiveis/${ge}`);

export const listarContasSubordinadosHierarquia = (ge, nivelPai) =>
  httpService.get(
    `/hierarquia-comercial/contas-subordinados/${ge}?nivelPai=${nivelPai}`
  );

export const validarCopiaHierarquia = dados =>
  httpService.post('/hierarquia-comercial/copiar/validar', dados);

export const copiarHierarquia = dados =>
  httpService.post('/hierarquia-comercial/copiar', dados);

export const copiarHierarquiaMassa = dados =>
  httpService.post('/hierarquia-comercial/copiar-massa', dados);

export const listarGruposEmpresaComHierarquia = () =>
  httpService.get('/hierarquia-comercial/grupos-empresa-hierarquia');

// === W-0437: LOG DE ATUALIZAÇÕES ===

export const buscarLogAtualizacoes = filtros =>
  httpService.post('/audit/log-atualizacoes/buscar', filtros);

export const buscarTiposLog = () =>
  httpService.get('/audit/log-atualizacoes/tipos');

export const buscarCodigosLog = filtros =>
  httpService.post('/audit/log-atualizacoes/codigos', filtros);

export const buscarUsuarioOptions = status =>
  httpService.get('/usuario/options', {
    params: { status: status || 'ativos' },
  });

export const buscarUsuariosPorDepartamento = codigoDepartamento =>
  httpService.get(`/usuario/options/departamento/${codigoDepartamento}`);

// === W-0438: GRUPO DE EMPRESAS ===

// CRUD Principal
export const listarGruposEmpresaAdmin = params =>
  httpService.get('/grupo-empresa', { params });

export const obterDetalhesGrupoEmpresa = codigo =>
  httpService.get(`/grupo-empresa/${codigo}`);

export const criarGrupoEmpresa = dados =>
  httpService.post('/grupo-empresa', dados);

export const atualizarGrupoEmpresa = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/atualizar`, dados);

export const excluirGrupoEmpresa = codigo =>
  httpService.post(`/grupo-empresa/${codigo}/excluir`);

export const toggleStatusGrupoEmpresa = codigo =>
  httpService.post(`/grupo-empresa/${codigo}/toggle-status`);

// Razões Sociais
export const incluirRazaoSocialGE = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/razao-social`, dados);

export const excluirRazaoSocialGE = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/razao-social/excluir`, dados);

// Grupos GE
export const incluirGrupoGEVinculo = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/grupo-ge`, dados);

export const excluirGrupoGEVinculo = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/grupo-ge/excluir`, dados);

// Parâmetros
export const obterParametrosGrupoEmpresa = codigo =>
  httpService.get(`/grupo-empresa/${codigo}/parametros`);

export const salvarParametrosGrupoEmpresa = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/parametros`, dados);

// Gestão Operacional
export const incluirGestaoOP = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/gestao-op`, dados);

export const excluirGestaoOP = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/gestao-op/excluir`, dados);

// Batch
export const importContasGE = dados =>
  httpService.post('/grupo-empresa/import-contas', dados);

export const incluirGEUsuariosAtivos = codigo =>
  httpService.post(`/grupo-empresa/${codigo}/incluir-usuarios-ativos`);

export const importarParametrosGE = (codigo, dados) =>
  httpService.post(`/grupo-empresa/${codigo}/importar-parametros`, dados);

// Lookups
export const listarCategoriasGE = () =>
  httpService.get('/grupo-empresa/lookup/categorias');

export const listarGruposGELookup = () =>
  httpService.get('/grupo-empresa/lookup/grupos-ge');

export const listarRazoesSociaisLookup = busca =>
  httpService.get('/grupo-empresa/lookup/razoes-sociais', {
    params: { busca },
  });

export const listarDepartamentosLookup = () =>
  httpService.get('/grupo-empresa/lookup/departamentos');

export const listarContasGE = (codigoGe, params) =>
  httpService.get(`/grupo-empresa/lookup/contas/${codigoGe}`, { params });

// === W-0446: RESTRINGIR EMPREENDIMENTOS ===

export const listarUsuarioFamilia = codigoUsuario =>
  httpService.get('/usuario-familia', {
    params: codigoUsuario ? { codigo_usuario: codigoUsuario } : {},
  });

export const incluirUsuarioFamilia = data =>
  httpService.post('/usuario-familia', data);

export const excluirUsuarioFamilia = data =>
  httpService.post('/usuario-familia/excluir', data);

export const listarPdvs = () => httpService.get('/pdv/listar');

export const criarPdv = data => httpService.post('/pdv/criar', data);

export const atualizarPdv = data => httpService.post('/pdv/atualizar', data);

export const excluirPdv = data => httpService.post('/pdv/excluir', data);

export const listarEmpreendimentosPdv = codigoPdv =>
  httpService.get(`/pdv/empreendimentos/${codigoPdv}`);

export const vincularEmpreendimentoPdv = data =>
  httpService.post('/pdv/vincular-empreendimento', data);

export const desvincularEmpreendimentoPdv = data =>
  httpService.post('/pdv/desvincular-empreendimento', data);
// === FAQ ===

export const buscarAssuntosFaq = codigoDepartamento =>
  httpService.get('/faq/buscar-assuntos', {
    params: { codigoDepartamento: codigoDepartamento },
  });

export const criarAssuntoFaq = data =>
  httpService.post('/faq/criar-assunto', data);

export const criarConteudoFaq = data =>
  httpService.post('/faq/criar-conteudo', data);

export const buscarConteudosFaq = params =>
  httpService.get('/faq/buscar-conteudo', { params: params });

export const buscarCriadoresFaq = () =>
  httpService.get('/faq/buscar-criadores');

export const uploadAnexoFaq = (codigoConteudo, formData) =>
  httpService.post('/faq/anexos/' + codigoConteudo + '/upload', formData);

export const buscarAnexosFaq = codigoConteudo =>
  httpService.get('/faq/anexos/' + codigoConteudo);

export const excluirAnexoFaq = codigo =>
  httpService.post('/faq/anexos/' + codigo + '/excluir');

export const editarConteudoFaq = (codigo, data) =>
  httpService.post('/faq/conteudo/' + codigo + '/atualizar', data);

export const excluirConteudoFaq = codigo =>
  httpService.post('/faq/conteudo/' + codigo + '/excluir');

export const downloadAnexoFaq = async (codigo, nomeArquivo) => {
  var response = await httpService.get('/faq/anexos/' + codigo + '/download', {
    responseType: 'blob',
  });
  var url = window.URL.createObjectURL(new Blob([response]));
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const listarCadUnicoFornecedores = busca =>
  httpService.get(
    `/cadastro-unico-fornecedor/listar${busca ? `?busca=${busca}` : ''}`
  );

export const obterCadUnicoFornecedor = codigo =>
  httpService.get(`/cadastro-unico-fornecedor/${codigo}`);

export const criarCadUnicoFornecedor = data =>
  httpService.post('/cadastro-unico-fornecedor', data);

export const atualizarCadUnicoFornecedor = (codigo, data) =>
  httpService.post(`/cadastro-unico-fornecedor/${codigo}/atualizar`, data);

export const excluirCadUnicoFornecedor = codigo =>
  httpService.post(`/cadastro-unico-fornecedor/${codigo}/excluir`);

export const listarContasCadUnico = codigo =>
  httpService.get(`/cadastro-unico-fornecedor/${codigo}/contas`);

export const cadastrarCadUnicoNoGE = (codigo, ge) =>
  httpService.post(`/cadastro-unico-fornecedor/${codigo}/cadastrar-ge/${ge}`);

export const validarDocumentoCadUnico = (documento, excluirCodigo) =>
  httpService.get(
    `/cadastro-unico-fornecedor/validar-documento?documento=${documento}${excluirCodigo ? `&excluir_codigo=${excluirCodigo}` : ''
    }`
  );

export const consultarCNPJ = cnpj => httpService.get(`/busca/cnpj/${cnpj}`);

// === W-0443: Cadastro de Contas ===

// CRUD Principal
export const listarContas = params => httpService.get('/conta', { params });

export const buscarConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}`);

export const inserirConta = data => httpService.post('/conta/salvar', data);

export const atualizarConta = data => httpService.post('/conta/salvar', data);

export const sugerirCodigoConta = (ge, tipo) =>
  httpService.get(`/conta/${ge}/sugerir-codigo`, { params: { tipo } });

export const verificarContaExclusiva = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/verificar-exclusiva`);

export const verificarDuplicidadeConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/verificar-duplicidade`);

// Fonte: UManutContas.pas, BitBtn11Click ~linha 5970 — duplicidade de CPF/CNPJ
export const verificarDuplicidadeCpf = (cpf, excluirConta, excluirGe) =>
  httpService.get('/conta/verificar-duplicidade-cpf', {
    params: { cpf, excluirConta, excluirGe },
  });

// Propagação Cross-GE
export const propagarDespesaReceita = data =>
  httpService.post('/conta/propagar-despesa-receita', data);

export const listarFornecedoresMesmoCnpj = (ge, codigo) =>
  httpService.get(`/conta/fornecedores-mesmo-cnpj/${ge}/${codigo}`);

export const propagarFornecedor = data =>
  httpService.post('/conta/propagar-fornecedor', data);

// Ocorrências
export const listarOcorrenciasConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/ocorrencias`);

export const inserirOcorrenciaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/ocorrencias/salvar`, data);

export const atualizarOcorrenciaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/ocorrencias/salvar`, data);

export const excluirOcorrenciaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/ocorrencias/excluir`, data);

// Fonte: UOcoConta.pas — lookups de Atendimento e SubTipo
// Endpoints existentes no OcorrenciaController
export const listarAtendimentosOcorrencia = () =>
  httpService.get('/ocorrencia/atendimentoTipo');

export const listarSubtiposAtendimento = codigoAtendimento =>
  httpService.get(`/ocorrencia/atendimentoSubTipo/${codigoAtendimento}`);

// Cônjuge/Sócio
export const listarConjugesSocios = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/conjuges-socios`);

export const inserirConjugeSocio = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/conjuges-socios/salvar`, data);

export const atualizarConjugeSocio = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/conjuges-socios/salvar`, data);

export const excluirConjugeSocio = (ge, codigo, data) =>
  httpService.post(
    `/conta/${ge}/${codigo}/conjuges-socios/${data.codigo}/excluir`,
    data
  );

// Observações
export const listarObservacoesConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/observacao`);

export const salvarObservacaoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/observacao/salvar`, data);

export const excluirObservacaoConta = (ge, codigo) =>
  httpService.post(`/conta/${ge}/${codigo}/observacao/salvar`, { obs: '' });

// Coligados
export const listarColigadosConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/coligados`);

export const inserirColigadoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/coligados/inserir`, data);

export const excluirColigadoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/coligados/excluir`, data);

// Contas Bancárias
export const listarContasBancariasConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/bancarias`);

export const inserirContaBancariaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/bancarias/salvar`, data);

export const atualizarContaBancariaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/bancarias/salvar`, data);

export const excluirContaBancariaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/bancarias/excluir`, data);

// Endereços
export const listarEnderecosConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/enderecos`);

export const inserirEnderecoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/enderecos/salvar`, data);

export const atualizarEnderecoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/enderecos/salvar`, data);

export const excluirEnderecoConta = (ge, codigo, data) =>
  httpService.post(
    `/conta/${ge}/${codigo}/enderecos/${data.seq}/excluir`,
    data
  );

// Endereço de Cobrança
export const buscarEnderecoCobrancaConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/endereco-cobranca`);

export const salvarEnderecoCobrancaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/endereco-cobranca/salvar`, data);

export const excluirEnderecoCobrancaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/endereco-cobranca/salvar`, {
    endereco: '',
    bairro: '',
    cep: '',
    codigo_cidade: null,
  });

// Endereço Comercial — registro único (PK: Codigo_Conta + codigo_grupo_empresa, sem Seq)
export const buscarEnderecoComercialConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/endereco-comercial`);

export const salvarEnderecoComercialConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/endereco-comercial/salvar`, data);

export const excluirEnderecoComercialConta = (ge, codigo) =>
  httpService.post(`/conta/${ge}/${codigo}/endereco-comercial/excluir`, {});

// Centro de Custo
export const listarCentroCustoConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/centros-custo`);

export const vincularCentroCustoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/centros-custo/vincular`, data);

export const vincularTodosCentroCustoConta = (ge, codigo) =>
  httpService.post(`/conta/${ge}/${codigo}/centros-custo/vincular-todos`);

export const desvincularCentroCustoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/centros-custo/desvincular`, data);

// Juros Auto
export const listarJurosAutoConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/juros-auto`);

export const inserirJurosAutoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/juros-auto/salvar`, data);

export const atualizarJurosAutoConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/juros-auto/salvar`, data);

export const excluirJurosAutoConta = (ge, codigo, data) =>
  httpService.post(
    `/conta/${ge}/${codigo}/juros-auto/${data.sequencia}/excluir`,
    data
  );

export const listarUsuariosJuros = () =>
  httpService.get('/conta/lookup/usuarios-juros');

export const listarContasIntercambio = ge =>
  httpService.get(`/conta/${ge}/lookup/contas-intercambio`);

// Tarifas
export const listarTarifasConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/tarifas`);

export const listarTarifasDisponiveis = () =>
  httpService.get('/conta/tarifas/disponiveis');

export const vincularTarifaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/tarifas/vincular`, data);

export const desvincularTarifaConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/tarifas/desvincular`, data);

// Informações Comerciais
export const listarInfoComerciaisConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/info-comercial`);

export const inserirInfoComercialConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/info-comercial/salvar`, data);

export const atualizarInfoComercialConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/info-comercial/salvar`, data);

export const excluirInfoComercialConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/info-comercial/excluir`, data);

// Índices de Remuneração (read-only)
export const listarIndicesRemuneracaoConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/indices-remuneracao`);

// Saldos (read-only)
export const listarSaldosConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/saldos`);

// Negativação de CPF
export const negativarCpfConta = (ge, codigo, data) =>
  httpService.post('/conta/negativacao/negativar', data);

export const listarHistoricoNegativacaoConta = (ge, codigo, cpf) =>
  httpService.get(`/conta/negativacao/${cpf}`);

// Perfil Exterior
export const buscarPerfilExteriorConta = (ge, codigo) =>
  httpService.get(`/conta/${ge}/${codigo}/perfil-exterior`);
export const salvarPerfilExteriorConta = (ge, codigo, data) =>
  httpService.post(`/conta/${ge}/${codigo}/perfil-exterior/salvar`, data);

// Banco → Empreendimento
export const listarFamiliasBancoEmpreendimento = ge =>
  httpService.get(`/conta/${ge}/banco-empreendimento/familias`);
export const atualizarBancoEmpreendimento = data =>
  httpService.post('/conta/banco-empreendimento', data);

// Lookups
export const listarRamosAtividade = () =>
  httpService.get('/conta/lookup/ramos');

export const listarGrupoContas = tipo =>
  httpService.get('/conta/lookup/grupo-contas', { params: { tipo } });

export const listarUsuariosResponsaveis = () =>
  httpService.get('/conta/lookup/usuarios-responsaveis');

export const listarVendedoresContas = () =>
  httpService.get('/conta/lookup/vendedores');

export const listarCobradoresContas = () =>
  httpService.get('/conta/lookup/cobradores');

export const listarCentrosCustoLookup = ge =>
  httpService.get(`/conta/${ge}/lookup/centros-custo`);

export const listarTiposInternosContas = () =>
  httpService.get('/conta/lookup/tipos-internos');

export const listarBancosLista = () => httpService.get('/conta/lookup/bancos');

export const listarMoedasContas = () => httpService.get('/conta/lookup/moedas');

export const listarCargosContas = () => httpService.get('/conta/lookup/cargos');

export const listarTabelasPrecosConta = () =>
  httpService.get('/conta/lookup/tabelas-precos');

export const listarPerfisComprador = () =>
  httpService.get('/conta/lookup/perfis-comprador');

export const listarTabelasComissao = () =>
  httpService.get('/conta/lookup/tabelas-comissao');

export const listarContasAtivas = () =>
  httpService.get('/conta/lookup/contas-ativas');
// === W-0241: SOLICITAÇÕES DE COMUNICAÇÃO ===

export const listarSolicitacoesComunicacao = async filtros =>
  httpService.get('/solicitacao-comunicacao', { params: filtros });

export const buscarSolicitacaoComunicacao = async codigo =>
  httpService.get(`/solicitacao-comunicacao/${codigo}`);

export const criarSolicitacaoComunicacao = async request =>
  httpService.post('/solicitacao-comunicacao', request);

export const alterarStatusSolicitacaoComunicacao = async (codigo, request) =>
  httpService.post(`/solicitacao-comunicacao/${codigo}/status`, request);

export const buscarHistoricoSolicitacaoComunicacao = async codigo =>
  httpService.get(`/solicitacao-comunicacao/${codigo}/historico`);

export const uploadAnexoSolicitacaoComunicacao = async (
  codigo,
  formData,
  codigoHistorico
) => {
  var url = `/solicitacao-comunicacao/${codigo}/anexo`;
  if (codigoHistorico) {
    url += `?codigo_historico=${codigoHistorico}`;
  }
  return httpService.post(url, formData);
};

export const downloadAnexoSolicitacaoComunicacao = async (
  codigo,
  codigoAnexo
) =>
  httpService.get(`/solicitacao-comunicacao/${codigo}/anexo/${codigoAnexo}`, {
    responseType: 'blob',
  });

export const buscarTiposSolicitacaoPorDepartamento = async codigoDepartamento =>
  httpService.get(`/solicitacao-comunicacao/tipo/${codigoDepartamento}`);

export const buscarStatusSolicitacaoComunicacao = async () =>
  httpService.get('/solicitacao-comunicacao/status');

export const criarTipoSolicitacaoComunicacao = async request =>
  httpService.post('/solicitacao-comunicacao/tipo', request);

// ===== Procuracoes (W-0461) =====

// Lookups
export const listarTiposInstrumentoProcuracao = async () =>
  httpService.get('/procuracao/tipos-instrumento');

export const listarTiposPoderProcuracao = async () =>
  httpService.get('/procuracao/tipos-poder');

export const listarTiposSubstabelecimentoProcuracao = async () =>
  httpService.get('/procuracao/tipos-substabelecimento');

export const listarEstadosProcuracao = async () =>
  httpService.get('/procuracao/estados');

// Externos
export const criarProcuracaoExterno = async request =>
  httpService.post('/procuracao/externo', request);

export const listarProcuracaoExternos = async () =>
  httpService.get('/procuracao/externo');

// Procuracao CRUD
export const criarProcuracao = async request =>
  httpService.post('/procuracao', request);

export const listarProcuracoes = async () => httpService.get('/procuracao');

export const buscarProcuracao = async codigo =>
  httpService.get('/procuracao/' + codigo);

export const editarProcuracao = async (codigo, request) =>
  httpService.post('/procuracao/' + codigo + '/editar', request);

export const inativarProcuracao = async (codigo, request) =>
  httpService.post('/procuracao/' + codigo + '/inativar', request);

// Outorgantes disponiveis (dropdown) — tipo: 'PF' ou 'PJ'
export const listarOutorgantesDisponiveis = async (tipo = 'PJ') =>
  httpService.get('/procuracao/outorgantes-disponiveis?tipo=' + tipo);

// Filhos (por procuracao)
export const listarOutorgantesProcuracao = async codigo =>
  httpService.get('/procuracao/' + codigo + '/outorgantes');

export const listarOutorgadosProcuracao = async codigo =>
  httpService.get('/procuracao/' + codigo + '/outorgados');

export const listarPoderesProcuracao = async codigo =>
  httpService.get('/procuracao/' + codigo + '/poderes');

// Substabelecimento
export const criarSubstabelecimento = async (codigoOrigem, request) =>
  httpService.post(
    '/procuracao/' + codigoOrigem + '/substabelecimento',
    request
  );

export const listarSubstabelecimentos = async codigo =>
  httpService.get('/procuracao/' + codigo + '/substabelecimentos');

export const buscarSubstabelecimentoOrigem = async codigo =>
  httpService.get('/procuracao/' + codigo + '/substabelecimento-origem');

export const excluirSubstabelecimento = async codigo =>
  httpService.post('/procuracao/substabelecimento/' + codigo + '/excluir');

// Anexos
export const uploadAnexoProcuracao = async (codigoProcuracao, formData) =>
  httpService.post(
    '/procuracao/' + codigoProcuracao + '/anexo/upload',
    formData
  );

export const listarAnexosProcuracao = async codigo =>
  httpService.get('/procuracao/' + codigo + '/anexos');

export const downloadAnexoProcuracao = async (codigo, nomeArquivo) => {
  var response = await httpService.get(
    '/procuracao/anexo/' + codigo + '/download',
    {
      responseType: 'blob',
    }
  );
  var url = window.URL.createObjectURL(new Blob([response]));
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const excluirAnexoProcuracao = async codigo =>
  httpService.post('/procuracao/anexo/' + codigo + '/excluir');

// W-0470: Categorias de Departamento
export const buscarCategoriasDepartamento = () =>
  httpService.get('/categoria-departamento');

export const criarCategoriaDepartamento = dados =>
  httpService.post('/categoria-departamento', dados);

export const atualizarCategoriaDepartamento = dados =>
  httpService.post('/categoria-departamento/atualizar', dados);

export const excluirCategoriaDepartamento = dados =>
  httpService.post('/categoria-departamento/excluir', dados);

// W-0471: Cadastro de Departamentos
export const buscarDepartamentos = () => httpService.get('/departamento');

export const sugerirCodigoDepartamento = codigoCategoria =>
  httpService.get(`/departamento/sugerir-codigo/${codigoCategoria}`);

export const criarDepartamento = dados =>
  httpService.post('/departamento', dados);

export const atualizarDepartamento = dados =>
  httpService.post('/departamento/atualizar', dados);

export const excluirDepartamento = dados =>
  httpService.post('/departamento/excluir', dados);

export const buscarColaboradoresDepartamento = codigo =>
  httpService.get(`/departamento/${codigo}/colaboradores`);

export const adicionarColaboradorDepartamento = dados =>
  httpService.post('/departamento/colaborador/adicionar', dados);

export const removerColaboradorDepartamento = dados =>
  httpService.post('/departamento/colaborador/remover', dados);

export const buscarHierarquiaDepartamento = codigo =>
  httpService.get(`/departamento/${codigo}/hierarquia`);

export const adicionarNivelHierarquia = dados =>
  httpService.post('/departamento/hierarquia/adicionar', dados);

export const excluirNivelHierarquia = dados =>
  httpService.post('/departamento/hierarquia/excluir', dados);

export const toggleStatusNivelHierarquia = dados =>
  httpService.post('/departamento/hierarquia/toggle-status', dados);

// --- W-0515: Comunicado de Quitação (Enviadas) ---
export const listarComunicadosQuitacao = params =>
  httpService.get('/comunicado-quitacao/listar', { params });

export const obterClientesComunicadoQuitacao = codigoGe =>
  httpService.get('/comunicado-quitacao/obter-clientes', {
    params: { codigoGe },
  });

// W-0492: Parcerias — mestre
export const listarParcerias = termo =>
  httpService.get(
    '/parcerias' + (termo ? '?termo=' + encodeURIComponent(termo) : '')
  );

export const obterDetalhesParceria = codigo =>
  httpService.get('/parcerias/' + codigo);

export const criarParceria = dados => httpService.post('/parcerias', dados);

export const atualizarParceria = dados =>
  httpService.post('/parcerias/atualizar', dados);

export const excluirParceria = dados =>
  httpService.post('/parcerias/excluir', dados);

// W-0492: Parcerias — participantes
export const adicionarParticipanteParceria = dados =>
  httpService.post('/parcerias/participantes/adicionar', dados);

export const marcarLoteadorParceria = dados =>
  httpService.post('/parcerias/participantes/marcar-loteador', dados);

export const excluirParticipanteParceria = dados =>
  httpService.post('/parcerias/participantes/excluir', dados);

// W-0492: Parcerias — contas autorizadas
export const adicionarContaAutorizadaParceria = dados =>
  httpService.post('/parcerias/contas/adicionar', dados);

export const atualizarContaAutorizadaParceria = dados =>
  httpService.post('/parcerias/contas/atualizar', dados);

export const excluirContaAutorizadaParceria = dados =>
  httpService.post('/parcerias/contas/excluir', dados);

// W-0492: Parcerias — empreendimentos
export const adicionarEmpreendimentoParceria = dados =>
  httpService.post('/parcerias/empreendimentos/adicionar', dados);

export const excluirEmpreendimentoParceria = dados =>
  httpService.post('/parcerias/empreendimentos/excluir', dados);

// W-0492: Parcerias — usuarios
export const adicionarUsuarioParceria = dados =>
  httpService.post('/parcerias/usuarios/adicionar', dados);

export const excluirUsuarioParceria = dados =>
  httpService.post('/parcerias/usuarios/excluir', dados);

// W-0492: Parcerias — lista negra
export const adicionarListaNegraParceria = dados =>
  httpService.post('/parcerias/lista-negra/adicionar', dados);

export const excluirListaNegraParceria = dados =>
  httpService.post('/parcerias/lista-negra/excluir', dados);

// W-0492: Parcerias — lookups
export const lookupContasParceria = (codigoGrupoEmpresa, tipos, termo) => {
  const params =
    'codigo_grupo_empresa=' +
    codigoGrupoEmpresa +
    '&tipos=' +
    tipos +
    (termo ? '&termo=' + encodeURIComponent(termo) : '');
  return httpService.get('/parcerias/lookup/contas?' + params);
};

export const lookupContasCapitalParceria = (codigoGrupoEmpresa, termo) => {
  const params =
    'codigo_grupo_empresa=' +
    codigoGrupoEmpresa +
    (termo ? '&termo=' + encodeURIComponent(termo) : '');
  return httpService.get('/parcerias/lookup/contas-capital?' + params);
};

export const lookupFamiliasParceria = termo =>
  httpService.get(
    '/parcerias/lookup/familias' +
    (termo ? '?termo=' + encodeURIComponent(termo) : '')
  );

export const lookupGruposEmpresaAtivos = termo =>
  httpService.get(
    '/grupo-empresa' + (termo ? '?busca=' + encodeURIComponent(termo) : '')
  );
// W-0498 — Feriados
export const listarFeriados = (dataInicio, dataFim, comemoracao) => {
  const params = {};
  if (dataInicio) params.data_inicio = dataInicio;
  if (dataFim) params.data_fim = dataFim;
  if (comemoracao) params.comemoracao = comemoracao;
  return httpService.get('/feriado/listar', { params });
};

export const inserirFeriado = (data, comemoracao) =>
  httpService.post('/feriado/inserir', { data, comemoracao });

export const atualizarFeriado = (data, comemoracao) =>
  httpService.post('/feriado/atualizar', { data, comemoracao });

export const excluirFeriado = data =>
  httpService.post('/feriado/excluir', { data });
// W-0499: Países
export const listarPaises = () => httpService.get('/pais');

export const criarPais = dados => httpService.post('/pais', dados);

export const atualizarPais = dados =>
  httpService.post('/pais/atualizar', dados);

export const excluirPais = dados => httpService.post('/pais/excluir', dados);
// W-0514: Cotações
export const listarCotacoes = data =>
  httpService.get(`/cotacoes/listar?data=${data}`);
export const gravarCotacao = dados =>
  httpService.post('/cotacoes/gravar', dados);
export const removerCotacao = dataCotacao =>
  httpService.post('/cotacoes/remover', { data_cotacao: dataCotacao });
// W-0538: Manutenção de Cotação Moeda Forte
export const listarCotacoesMoedaForte = data =>
  httpService.get(`/cotacoes-moeda-forte/listar${data ? `?data=${data}` : ''}`);

export const listarAtivosMoedaForte = () =>
  httpService.get('/cotacoes-moeda-forte/ativos');

export const incluirCotacaoMoedaForte = payload =>
  httpService.post('/cotacoes-moeda-forte/incluir', payload);

export const alterarCotacaoMoedaForte = payload =>
  httpService.post('/cotacoes-moeda-forte/alterar', payload);

export const listarValidadoresCotacao = (codigoAtivo, data) =>
  httpService.get(
    `/cotacoes-moeda-forte/validadores?codigoAtivo=${codigoAtivo}&data=${data}`
  );
// W-0544: Tipo de Conta Interna (GES > Contas > Tabelas)
export const listarTiposContaInterna = () =>
  httpService.get('/tipo-conta-interna/listar');

export const cadastrarTipoContaInterna = dados =>
  httpService.post('/tipo-conta-interna/cadastrar', dados);

export const atualizarTipoContaInterna = dados =>
  httpService.post('/tipo-conta-interna/atualizar', dados);

export const excluirTipoContaInterna = dados =>
  httpService.post('/tipo-conta-interna/excluir', dados);

// W-0509: Ramos de Atividade
export const listarRamos = () => httpService.get('/ramo/listar');

export const cadastrarRamo = dados =>
  httpService.post('/ramo/cadastrar', dados);

export const atualizarRamo = dados =>
  httpService.post('/ramo/atualizar', dados);

export const excluirRamo = dados => httpService.post('/ramo/excluir', dados);

// W-0588: Relatório de Ramos de Atividade
export const listarRamosFiltrado = filtro =>
  httpService.fetch({
    url: '/ramo/listar',
    method: 'get',
    params: filtro,
  });

export const exportarRelatorioRamosExcel = lista =>
  httpService.fetch({
    url: '/exportador/excel/relatorio-ramos',
    method: 'post',
    data: lista,
    responseType: 'blob',
  });
// --- Famílias de Ativos (W-0467) ---
export const listarFamiliasAtivos = (filtro, tipo, grupo, status) =>
  httpService.get('/familia-ativo', {
    params: { filtro, tipo, grupo, status },
  });

export const buscarFamiliaAtivo = codigo =>
  httpService.get(`/familia-ativo/${codigo}`);

export const incluirFamiliaAtivo = dados =>
  httpService.post('/familia-ativo', dados);

export const atualizarFamiliaAtivo = (codigo, dados) =>
  httpService.post(`/familia-ativo/${codigo}/atualizar`, dados);

export const excluirFamiliaAtivo = codigo =>
  httpService.post(`/familia-ativo/${codigo}/excluir`);

export const obterRelatorioFamiliasAtivos = params =>
  httpService.get('/familia-ativo/relatorio', { params });
// --- Qualidades de Ativos (W-0466) ---

export const listarQualidades = () => {
  return httpService.get('/qualidade');
};

export const incluirQualidade = dados => {
  return httpService.post('/qualidade', dados);
};

export const atualizarQualidade = (codigo, dados) => {
  return httpService.post(`/qualidade/${codigo}/atualizar`, dados);
};

export const excluirQualidade = codigo => {
  return httpService.post(`/qualidade/${codigo}/excluir`);
};

// === W-0473: MANUTENÇÃO DE ATIVOS ===

export const ativoManutencaoListar = data =>
  httpService.post('/ativo/listar', data);

export const ativoManutencaoBuscar = codigoAtivo =>
  httpService.get('/ativo/buscar/' + codigoAtivo);

export const ativoManutencaoProximoCodigo = () =>
  httpService.get('/ativo/proximo-codigo');

export const ativoManutencaoSalvar = data =>
  httpService.post('/ativo/salvar', data);

export const ativoManutencaoDuplicar = data =>
  httpService.post('/ativo/duplicar', data);

export const ativoManutencaoVerificarBloqueio = codigoAtivo =>
  httpService.get('/ativo/verificar-bloqueio/' + codigoAtivo);

export const ativoManutencaoListarObs = codigoAtivo =>
  httpService.get('/ativo/observacoes/' + codigoAtivo);

export const ativoManutencaoSalvarObs = data =>
  httpService.post('/ativo/observacoes/salvar', data);

export const ativoManutencaoExcluirObs = data =>
  httpService.post('/ativo/observacoes/excluir', data);

export const ativoManutencaoListarOcorrencias = codigoAtivo =>
  httpService.get('/ativo/ocorrencias/' + codigoAtivo);

export const ativoManutencaoSalvarOcorrencia = data =>
  httpService.post('/ativo/ocorrencias/salvar', data);

export const ativoManutencaoListarValidadoresCotacao = codigoAtivo =>
  httpService.get('/ativo/validadores-cotacao/' + codigoAtivo);

export const ativoManutencaoSalvarValidadorCotacao = data =>
  httpService.post('/ativo/validadores-cotacao/salvar', data);

export const ativoManutencaoExcluirValidadorCotacao = data =>
  httpService.post('/ativo/validadores-cotacao/excluir', data);

export const ativoManutencaoListarGrupoFamiliaImovel = codigoAtivo =>
  httpService.get('/ativo/grupo-familia-imovel/' + codigoAtivo);

export const ativoManutencaoSalvarGrupoFamiliaImovel = data =>
  httpService.post('/ativo/grupo-familia-imovel/salvar', data);

export const ativoManutencaoExcluirGrupoFamiliaImovel = data =>
  httpService.post('/ativo/grupo-familia-imovel/excluir', data);

export const ativoManutencaoHistoricoCarne = codigoAtivo =>
  httpService.get('/ativo/historico-carne/' + codigoAtivo);

export const ativoManutencaoLookupCarneStatus = () =>
  httpService.get('/ativo/lookup/carne-status');

export const ativoManutencaoLookupMoedas = () =>
  httpService.get('/ativo/lookup/moedas');

export const ativoManutencaoLookupGrupoFamilia = () =>
  httpService.get('/ativo/lookup/grupo-familia');

export const buscarUsuariosPorTermo = termo =>
  httpService.get(
    '/usuario/list' + (termo ? '?termo=' + encodeURIComponent(termo) : '')
  );

export const listarAtivosOcorrenciaImovel = codigoFamilia =>
  httpService.get(`/ocorrencia-imovel/familias/${codigoFamilia}/ativos`);

export const listarOcorrenciasImovel = (
  codigoAtivo,
  pagina = 1,
  itensPorPagina = 20
) =>
  httpService.get(
    `/ocorrencia-imovel/ativos/${codigoAtivo}/ocorrencias?pagina=${pagina}&itensPorPagina=${itensPorPagina}`
  );
// --- Importação XLS Ativos (W-0468) ---

export var processarPlanilhaAtivos = function (formData) {
  return httpService.post('/importacao-ativo/processar', formData);
};

export var gravarImportacaoAtivos = function (dados) {
  return httpService.post('/importacao-ativo/gravar', dados);
};

export var listarQualidadesAtivo = function () {
  return httpService.get('/importacao-ativo/qualidades');
};
// --- Ajustar Dados de Imóveis (W-0469) ---

export const buscarFamiliasAjusteImoveis = () =>
  httpService.get('/ajustar-imoveis/familias');

export const buscarQuadrasAjusteImoveis = codigoFamilia =>
  httpService.get('/ajustar-imoveis/quadras/' + codigoFamilia);

export const buscarImoveisAjuste = data =>
  httpService.post('/ajustar-imoveis/buscar', data);

export const gravarAjusteImoveis = data =>
  httpService.post('/ajustar-imoveis/gravar', data);

// === W-0482: Empreendimento Config ===

// Leitura
export const listarFamiliasConfig = () =>
  httpService.get('/empreendimento-config/familias');

export const listarGrupoEmpreendimento = () =>
  httpService.get('/empreendimento-config/grupo-empreendimento');

export const buscarEmpreendimentoConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}`);

export const buscarComissoesConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/comissoes`);

export const buscarComFixaConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/comfixa`);

export const buscarProjetoConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/projeto`);

export const buscarContabilConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/contabil`);

export const buscarIntegracaoConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/integracao`);

export const buscarPermissoesEmpreendimento = () =>
  httpService.get('/empreendimento-config/permissoes');

// Escrita - Dados Gerais
export const salvarDadosGerais = dados =>
  httpService.post('/empreendimento-config/salvar-dados-gerais', dados);

export const incluirEmpreendimento = dados =>
  httpService.post('/empreendimento-config/incluir', dados);

// Escrita - Config Vendas
export const salvarConfigVendas = dados =>
  httpService.post('/empreendimento-config/salvar-config-vendas', dados);

// Escrita - Comissões
export const incluirFaixaConfig = dados =>
  httpService.post('/empreendimento-config/faixa/incluir', dados);

export const excluirFaixaConfig = dados =>
  httpService.post('/empreendimento-config/faixa/excluir', dados);

export const incluirComissaoConfig = dados =>
  httpService.post('/empreendimento-config/comissao/incluir', dados);

export const excluirComissaoConfig = dados =>
  httpService.post('/empreendimento-config/comissao/excluir', dados);

export const copiarComissaoConfig = dados =>
  httpService.post('/empreendimento-config/comissao/copiar', dados);

export const incluirCaptacaoConfig = dados =>
  httpService.post('/empreendimento-config/captacao/incluir', dados);

export const excluirCaptacaoConfig = dados =>
  httpService.post('/empreendimento-config/captacao/excluir', dados);

export const incluirProspectoConfig = dados =>
  httpService.post('/empreendimento-config/prospecto/incluir', dados);

export const excluirProspectoConfig = dados =>
  httpService.post('/empreendimento-config/prospecto/excluir', dados);

export const incluirRetidaConfig = dados =>
  httpService.post('/empreendimento-config/retida/incluir', dados);

export const excluirRetidaConfig = dados =>
  httpService.post('/empreendimento-config/retida/excluir', dados);

export const gerarComFixa = dados =>
  httpService.post('/empreendimento-config/comfixa/gerar', dados);

export const salvarComFixaValor = dados =>
  httpService.post('/empreendimento-config/comfixa/salvar-valor', dados);

export const incluirChequeBonusConfig = dados =>
  httpService.post('/empreendimento-config/cheque-bonus/incluir', dados);

export const excluirChequeBonusConfig = dados =>
  httpService.post('/empreendimento-config/cheque-bonus/excluir', dados);

// Escrita - Comissões (valores)
export const salvarValoresComissaoConfig = dados =>
  httpService.post('/empreendimento-config/salvar-valores-comissao', dados);

// Escrita - Projeto
export const salvarProjetoConfig = dados =>
  httpService.post('/empreendimento-config/salvar-projeto', dados);

export const incluirIptuConfig = dados =>
  httpService.post('/empreendimento-config/iptu/incluir', dados);

export const excluirIptuConfig = dados =>
  httpService.post('/empreendimento-config/iptu/excluir', dados);

// Escrita - Etapas
export const incluirEtapaConfig = dados =>
  httpService.post('/empreendimento-config/etapa/incluir', dados);

export const alterarEtapaConfig = dados =>
  httpService.post('/empreendimento-config/etapa/alterar', dados);

export const excluirEtapaConfig = dados =>
  httpService.post('/empreendimento-config/etapa/excluir', dados);

// Escrita - Contas Projeto
export const listarContasProjetoLookup = codigoGe =>
  httpService.get(
    '/empreendimento-config/' + codigoGe + '/contas-projeto-lookup'
  );
export const incluirContaProjetoConfig = dados =>
  httpService.post('/empreendimento-config/conta-projeto/incluir', dados);
export const excluirContaProjetoConfig = dados =>
  httpService.post('/empreendimento-config/conta-projeto/excluir', dados);

// Escrita - Áreas Projeto
export const listarAtivosLookup = codigoFamilia =>
  httpService.get('/empreendimento-config/' + codigoFamilia + '/ativos-lookup');
export const incluirAreaProjetoConfig = dados =>
  httpService.post('/empreendimento-config/area-projeto/incluir', dados);
export const excluirAreaProjetoConfig = dados =>
  httpService.post('/empreendimento-config/area-projeto/excluir', dados);

// Escrita - Expectativa
export const incluirExpectativaConfig = dados =>
  httpService.post('/empreendimento-config/expectativa/incluir', dados);
export const excluirExpectativaConfig = dados =>
  httpService.post('/empreendimento-config/expectativa/excluir', dados);

// Escrita - Contábil
export const incluirLanctoAdmConfig = dados =>
  httpService.post('/empreendimento-config/lancto-adm/incluir', dados);

export const excluirLanctoAdmConfig = dados =>
  httpService.post('/empreendimento-config/lancto-adm/excluir', dados);

export const salvarTransfComissao = dados =>
  httpService.post('/empreendimento-config/transf-comissao/salvar', dados);

export const excluirTransfComissao = dados =>
  httpService.post('/empreendimento-config/transf-comissao/excluir', dados);

export const incluirRetencaoConfig = dados =>
  httpService.post('/empreendimento-config/retencao/incluir', dados);

export const excluirRetencaoConfig = dados =>
  httpService.post('/empreendimento-config/retencao/excluir', dados);

// Escrita - Integração
export const toggleStatusIntVendas = dados =>
  httpService.post('/empreendimento-config/int-vendas/toggle-status', dados);

export const marcarPrincipalIntVendas = dados =>
  httpService.post('/empreendimento-config/int-vendas/marcar-principal', dados);

export const incluirIntVendasConfig = dados =>
  httpService.post('/empreendimento-config/int-vendas/incluir', dados);

export const excluirIntVendasConfig = dados =>
  httpService.post('/empreendimento-config/int-vendas/excluir', dados);

export const listarDocVendaConfig = () =>
  httpService.get('/empreendimento-config/doc-venda');

export const incluirDocumentoConfig = dados =>
  httpService.post('/empreendimento-config/documento/incluir', dados);

export const excluirDocumentoConfig = dados =>
  httpService.post('/empreendimento-config/documento/excluir', dados);

export const incluirRepasseConfig = dados =>
  httpService.post('/empreendimento-config/repasse/incluir', dados);

export const excluirRepasseConfig = dados =>
  httpService.post('/empreendimento-config/repasse/excluir', dados);

export const incluirBoletoGraficaConfig = dados =>
  httpService.post('/empreendimento-config/boleto-grafica/incluir', dados);

export const excluirBoletoGraficaConfig = dados =>
  httpService.post('/empreendimento-config/boleto-grafica/excluir', dados);

export const listarUsuariosFaseConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/usuarios-fase`);

export const incluirUsuarioFaseConfig = dados =>
  httpService.post('/empreendimento-config/usuario-fase/incluir', dados);

export const excluirUsuarioFaseConfig = dados =>
  httpService.post('/empreendimento-config/usuario-fase/excluir', dados);

export const copiarUsuariosFaseConfig = dados =>
  httpService.post('/empreendimento-config/copiar-usuarios-fase', dados);

export const listarPdvLookupConfig = () =>
  httpService.get('/empreendimento-config/pdv-lookup');

export const incluirPdvEmpConfig = dados =>
  httpService.post('/empreendimento-config/pdv-emp/incluir', dados);

export const excluirPdvEmpConfig = dados =>
  httpService.post('/empreendimento-config/pdv-emp/excluir', dados);

export const listarParceirosConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/parceiros`);

export const listarContasLookupConfig = codigoGrupoEmpresa =>
  httpService.get(`/empreendimento-config/${codigoGrupoEmpresa}/contas-lookup`);

export const incluirParceiroConfig = dados =>
  httpService.post('/empreendimento-config/parceiro/incluir', dados);

export const excluirParceiroConfig = dados =>
  httpService.post('/empreendimento-config/parceiro/excluir', dados);

export const buscarTaxaDescricaoConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/taxa-descricao`);

export const listarQuadrasConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/quadras`);

export const listarLotesConfig = (codigoFamilia, quadra) =>
  httpService.get(
    `/empreendimento-config/${codigoFamilia}/lotes${quadra ? '?quadra=' + encodeURIComponent(quadra) : ''
    }`
  );

export const listarQualidadesConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/qualidades`);

export const listarSequenciasComissaoLookupConfig = codigoFamilia =>
  httpService.get(
    `/empreendimento-config/${codigoFamilia}/sequencias-comissao-lookup`
  );

export const listarCentrosCustoConfig = () =>
  httpService.get('/empreendimento-config/centros-custo');

export const listarTiposComissaoConfig = () =>
  httpService.get('/empreendimento-config/tipos-comissao');

export const listarTipoOutroConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/tipo-outro`);

export const incluirTipoOutroConfig = dados =>
  httpService.post('/empreendimento-config/tipo-outro/incluir', dados);

export const excluirTipoOutroConfig = dados =>
  httpService.post('/empreendimento-config/tipo-outro/excluir', dados);

export const exportarPdfsConfig = dados =>
  httpService.post('/empreendimento-config/exportar-pdfs', dados);

export const salvarLogoEmpreendimento = (codigoFamilia, base64) =>
  httpService.post(`/empreendimento-config/${codigoFamilia}/logo`, { base64 });

export const salvarLogoParceiroEmpreendimento = (codigoFamilia, base64) =>
  httpService.post(`/empreendimento-config/${codigoFamilia}/logo-parceiro`, {
    base64,
  });

export const listarCartoesLookupConfig = () =>
  httpService.get('/empreendimento-config/cartoes-lookup');

export const listarCartoesEmpreendimentoConfig = codigoFamilia =>
  httpService.get(`/empreendimento-config/${codigoFamilia}/cartoes`);

export const incluirCartaoEmpreendimentoConfig = dados =>
  httpService.post('/empreendimento-config/cartao/incluir', dados);

export const excluirCartaoEmpreendimentoConfig = dados =>
  httpService.post('/empreendimento-config/cartao/excluir', dados);

// === W-0474: IMÓVEIS RESCINDIDOS ===

export const buscarImoveisRescindidos = filtros =>
  httpService.post('/relatorios/imoveis-rescindidos', filtros);

export const buscarImoveisRescindidosJuridico = filtros =>
  httpService.post('/relatorios/imoveis-rescindidos/juridico', filtros);

export const buscarImoveisRescindidosFuturos = filtros =>
  httpService.post(
    '/relatorios/imoveis-rescindidos/pagamentos-futuros',
    filtros
  );

export const listarEmpreendimentosPorGEImoveisRescindidos = ges =>
  httpService.get(`/relatorios/imoveis-rescindidos/empreendimentos?ges=${ges}`);

export const listarCorretoresPorGEImoveisRescindidos = ges =>
  httpService.get(`/relatorios/imoveis-rescindidos/corretores?ges=${ges}`);

// W-0483 — Vendas por Valor à Vista
export const consultarVendasValorVista = filtros =>
  httpService.post('/relatorios/vendas-valor-vista/consultar', filtros);

export const listarGrupoEmpresaVendasVista = () =>
  httpService.get('/relatorios/vendas-valor-vista/grupo-empresa');

export const listarGrupoGeVendasVista = () =>
  httpService.get('/relatorios/vendas-valor-vista/grupo-ge');

export const listarEmpreendimentosVendasVista = filtro =>
  httpService.post('/relatorios/vendas-valor-vista/empreendimentos', filtro);

export const listarHierarquiaComercialVendasVista = filtro =>
  httpService.post('/relatorios/vendas-valor-vista/hierarquia', filtro);

// Consulta Imóveis — W-0476
export const consultaImoveisBuscarEmpreendimentos = () =>
  httpService.get('/empreendimento/consulta-imoveis/empreendimentos');

export const consultaImoveisBuscarMapa = request =>
  httpService.post('/empreendimento/consulta-imoveis/mapa', request);

export const consultaImoveisBuscarDetalhe = codigoAtivo =>
  httpService.get(`/empreendimento/consulta-imoveis/detalhe/${codigoAtivo}`);

export const consultaImoveisAlterarStatus = request =>
  httpService.post('/empreendimento/consulta-imoveis/alterar-status', request);

export const consultaImoveisVincularProposta = request =>
  httpService.post(
    '/empreendimento/consulta-imoveis/vincular-proposta',
    request
  );

export const consultaImoveisCancelarVinculoProposta = request =>
  httpService.post(
    '/empreendimento/consulta-imoveis/cancelar-vinculo-proposta',
    request
  );

export const consultaImoveisReservaEspecial = request =>
  httpService.post(
    '/empreendimento/consulta-imoveis/reserva-especial',
    request
  );

export const consultaImoveisReservaCasa = request =>
  httpService.post('/empreendimento/consulta-imoveis/reserva-casa', request);

export const consultaImoveisInativarAtivo = request =>
  httpService.post('/empreendimento/consulta-imoveis/inativar-ativo', request);

export const consultaImoveisEspelhoVendasUrl = codigoFamilia =>
  `/empreendimento/consulta-imoveis/espelho-vendas/${codigoFamilia}`;

// W-0478: Documentos Necessários para Vendas
export const listarDocumentosVenda = () => httpService.get('/doc-venda');

export const buscarDocumentoVenda = codigo =>
  httpService.get(`/doc-venda/${codigo}`);

export const incluirDocumentoVenda = dados =>
  httpService.post('/doc-venda', dados);

export const atualizarDocumentoVenda = (codigo, dados) =>
  httpService.post(`/doc-venda/${codigo}/atualizar`, dados);

export const excluirDocumentoVenda = codigo =>
  httpService.post(`/doc-venda/${codigo}/excluir`);
export const alterarAlertaCliente = body =>
  httpService.post('/alerta-cliente/alterar', body);

export const removerAlertaCliente = body =>
  httpService.post('/alerta-cliente/remover', body);

export const replicarAlertaCliente = body =>
  httpService.post('/alerta-cliente/replicar', body);

export const verificarUnicidadeAlerta = params =>
  httpService.get('/alerta-cliente/verificar-unicidade', { params });

// W-0517: Cancelamento de Taxa de Transferência
export const listarTaxasTransferencia = (ge, conta) =>
  httpService.get(`/cancelataxa/listar?ge=${ge}&conta=${conta}`);

export const listarClientesCancelaTaxa = ge =>
  httpService.get(`/cancelataxa/listar-clientes?ge=${ge}`);

export const cancelarTaxaTransferencia = data =>
  httpService.post('/cancelataxa/cancelar', data);

// Controle de Taxa de Transferência
export const listarControleTaxaTransferencia = ({
  codigoGrupoEmpresa,
  codigoConta,
} = {}) => {
  const params = {};
  if (codigoGrupoEmpresa) params.codigoGrupoEmpresa = codigoGrupoEmpresa;
  if (codigoConta) params.codigoConta = codigoConta;
  return httpService.get('/controle-taxa-transferencia/listar', { params });
};

export const listarClientesPorGeControleTaxa = codigoGrupoEmpresa =>
  httpService.get(
    `/controle-taxa-transferencia/listar-clientes-por-ge/${codigoGrupoEmpresa}`
  );

export const getTaxasTransferencia = () =>
  httpService.get('/empreendimento/taxa-transferencia');

export const updateTaxasTransferenciaEmLote = payload =>
  httpService.post('/empreendimento/taxa-transferencia/lote', payload);

// W-0523: Lançamento de Despesa de Cartão de Crédito

export const listarDespesasCartao = filtros =>
  httpService.post('/despesa-cartao-credito/listar', filtros);

export const obterDespesaCartao = codigo =>
  httpService.get(`/despesa-cartao-credito/obter/${codigo}`);

export const criarDespesaCartao = data =>
  httpService.post('/despesa-cartao-credito/criar', data);

export const alterarDespesaCartao = data =>
  httpService.post('/despesa-cartao-credito/alterar', data);

export const excluirDespesaCartao = codigo =>
  httpService.post('/despesa-cartao-credito/excluir', { codigo });

export const listarCartoesAtivos = codigoGrupoEmpresa =>
  httpService.get('/despesa-cartao-credito/cartoes-ativos', {
    params: { codigoGrupoEmpresa },
  });

export const listarTipoDocumentoCartao = () =>
  httpService.get('/despesa-cartao-credito/tipo-documento/listar');

export const uploadAnexoDespesaCartao = (codigo, formData) =>
  httpService.post('/despesa-cartao-credito/anexo/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { codigo },
  });

export const excluirAnexoDespesaCartao = seq =>
  httpService.post('/despesa-cartao-credito/anexo/excluir', { seq });

export const listarFornecedoresDespesaCartaoPorGE = codigoGrupoEmpresa =>
  httpService.get('/despesa-cartao-credito/fornecedores-por-ge', {
    params: { codigoGrupoEmpresa },
  });

export const buscarDepartamentosAtivosPorGE = codigoGrupoEmpresa =>
  httpService.get('/departamento/buscar-ativos-por-ge', {
    params: { codigoGrupoEmpresa },
  });

// W-0536: Rastreamento de Títulos (GES)
export const buscarRastreamentoTitulos = params =>
  httpService.get('/rastreamento-titulos/buscar', { params });

export const obterRastreamentoTitulo = codigoTitulo =>
  httpService.get(`/rastreamento-titulos/${codigoTitulo}`);

export const obterMovimentacoesTitulo = codigoTitulo =>
  httpService.get(`/rastreamento-titulos/${codigoTitulo}/movimentacoes`);

export const obterRemessaTitulo = codigoTitulo =>
  httpService.get(`/rastreamento-titulos/${codigoTitulo}/remessa`);

export const imprimirRastreamentoTitulo = codigoTitulo =>
  httpService.get(`/rastreamento-titulos/${codigoTitulo}/imprimir`, {
    responseType: 'blob',
  });

// W-0557: Simulação de Propostas (GES)
export const simulacaoGetGruposEmpresa = () =>
  httpService.get('/simulacao-proposta/grupos-empresa');

export const simulacaoGetCedentes = codigoGE =>
  httpService.get(`/simulacao-proposta/cedentes?codigoGE=${codigoGE}`);

export const simulacaoGetParametros = () =>
  httpService.get('/simulacao-proposta/parametros');

export const simulacaoCalcular = payload =>
  httpService.post('/simulacao-proposta/calcular', payload);

// W-0525: Relatório de Cidades
export const consultarRelatorioCidades = filtros =>
  httpService.post('/relatorios/cidades/listar', filtros);

export const exportarRelatorioCidadesExcel = filtros =>
  httpService.post('/relatorios/cidades/exportar-excel', filtros, {
    responseType: 'blob',
  });

// W-0491: Relatório Lista de Ocorrências de Contas (GES > Relatórios > Contas)
// Listagem paginada via GET [FromUri]. As chaves enviadas usam os nomes das
// propriedades do DTO C# (OcorrenciasFiltro) — o binder de URI nao aplica o
// snake_case global do formatter JSON (ver memoria de binding [FromUri]).
const _montarParamsOcorrencias = filtros => {
  const f = filtros || {};
  const params = {};
  if (f.dataInicio) params.DataInicio = f.dataInicio;
  if (f.dataFim) params.DataFim = f.dataFim;
  if (f.codigoGrupoEmpresa != null) params.CodigoGrupoEmpresa = f.codigoGrupoEmpresa;
  if (f.codigoUsuario != null) params.CodigoUsuario = f.codigoUsuario;
  if (f.codigoFamilia != null) params.CodigoFamilia = f.codigoFamilia;
  if (f.codigoConta != null) params.CodigoConta = f.codigoConta;
  if (f.titulo) params.Titulo = f.titulo;
  params.Ordem = f.ordem || 'data_desc';
  params.IncluirTexto = f.incluirTexto ? true : false;
  params.Pagina = f.pagina || 1;
  params.TamanhoPagina = f.tamanhoPagina || 20;
  return params;
};

export const consultarRelatorioOcorrencias = filtros =>
  httpService.get('/relatorios/ocorrencias', {
    params: _montarParamsOcorrencias(filtros),
  });

export const listarUsuariosAtivosOcorrencias = () =>
  httpService.get('/relatorios/ocorrencias/usuarios-ativos');

export const listarClientesPorGeOcorrencias = codigoGrupoEmpresa =>
  httpService.get('/relatorios/ocorrencias/clientes-por-ge', {
    params: { codigoGrupoEmpresa },
  });

// W-0488 — Consulta de Ocorrências de Contas
export const consultaOcorrenciasContasTitulos = (body) =>
  httpService.post('/consulta-ocorrencias-contas/titulos', body);

export const consultaOcorrenciasContasClientes = (body) =>
  httpService.post('/consulta-ocorrencias-contas/clientes', body);

export const consultaOcorrenciasContasDatas = (body) =>
  httpService.post('/consulta-ocorrencias-contas/datas', body);

export const consultaOcorrenciasContasTexto = (params) =>
  httpService.get('/consulta-ocorrencias-contas/texto', { params });

export const consultaOcorrenciasContasClienteTexto = (body) =>
  httpService.post('/consulta-ocorrencias-contas/cliente-texto', body);

export const consultaOcorrenciasContasTitulosDisponiveis = (body) =>
  httpService.post('/consulta-ocorrencias-contas/titulos-disponiveis', body);

export const consultaOcorrenciasContasRelPorTitulos = (body) =>
  httpService.post('/consulta-ocorrencias-contas/relatorio/por-titulos', body, { responseType: 'blob' });

export const consultaOcorrenciasContasRelPorCliente = (body) =>
  httpService.post('/consulta-ocorrencias-contas/relatorio/por-cliente', body, { responseType: 'blob' });

export const consultaOcorrenciasContasRelPorData = (body) =>
  httpService.post('/consulta-ocorrencias-contas/relatorio/por-data', body, { responseType: 'blob' });

export const consultaOcorrenciasContasRelListaCompleta = (body) =>
  httpService.post('/consulta-ocorrencias-contas/relatorio/lista-completa', body, { responseType: 'blob' });

export const consultaOcorrenciasContasLookupContas = (params) =>
  httpService.get('/consulta-ocorrencias-contas/lookup/contas', { params });

export const consultaOcorrenciasContasLookupFamilias = () =>
  httpService.get('/consulta-ocorrencias-contas/lookup/familias');

export const consultaOcorrenciasContasLookupUsuarios = (params) =>
  httpService.get('/consulta-ocorrencias-contas/lookup/usuarios', { params });

export const consultaOcorrenciasContasLookupGeUsuario = () =>
  httpService.get('/consulta-ocorrencias-contas/lookup/ge-usuario');

// W-0525 — Cidades CRUD (implementação isolada em src/Services/Cidades/CidadesService.js — ADR-010)
// W-0587 — listarRegioes adicionada para o relatório de cidades por região
export {
  listarCidades,
  obterCidade,
  criarCidade,
  atualizarCidade,
  excluirCidade,
  listarRegioesAtendimento,
  listarRegioes,
  listarCidadesPorRegiao,
} from './Cidades/CidadesService';

// W-0535 — Consulta CGC/CPF (Títulos)
export const listarGruposEmpresaConsultaCgcCpf = () =>
  httpService.get('/consulta-cgc-cpf/grupos-empresa');

export const obterDashboardCgcCpf = payload =>
  httpService.post('/consulta-cgc-cpf/dashboard', payload);

export const listarAbertosCgcCpf = payload =>
  httpService.post('/consulta-cgc-cpf/drilldown-abertos', payload);

export const listarDevolvidosCgcCpf = payload =>
  httpService.post('/consulta-cgc-cpf/drilldown-devolvidos', payload);

export const listarLiquidadosCgcCpf = payload =>
  httpService.post('/consulta-cgc-cpf/drilldown-liquidados', payload);

// ============ Despesa de Cartão de Crédito (W-0524) ============
// W-0527: RoutePrefix renomeado de /cartao-credito → /despesa-cartao-credito
// para evitar colisão com o controller de cadastro (W-0527).
export const listarGruposEmpresaLancamentoDespesaCartao = () =>
  httpService.get('/despesa-cartao-credito/grupos-empresa-lancamento');

export const listarCartoesCredito = codigoGe =>
  httpService.get('/despesa-cartao-credito/cartoes-lookup', {
    params: { codigo_grupo_empresa: codigoGe },
  });

// Fonte: uLancaDespesaCartao.pas:974-980 — mesma query do Fechamento (SELECT * FROM Departamento WHERE codigo <> 0 + FiltroDepto)
export const listarDepartamentosLookupGE = () =>
  httpService.get('/despesa-cartao-credito/fechamento/departamentos-lookup');

export const listarContasDespesa = codigoGe =>
  httpService.get('/contas/listar', {
    params: { tipo: 3, codigo_grupo_empresa: codigoGe },
  });

// Novos lookups do fechamento (W-0524 — correção de gaps; TASK_01 backend)
export const listarDepartamentosFechamentoCartao = () =>
  httpService.get('/despesa-cartao-credito/fechamento/departamentos-lookup');

export const listarContasFechamentoCartao = codigoGe =>
  httpService.get('/despesa-cartao-credito/fechamento/contas-lookup', {
    params: { codigo_grupo_empresa: codigoGe },
  });

export const listarFornecedoresFechamentoCartao = (codigoGe, busca) => {
  const params = { codigo_grupo_empresa: codigoGe };
  if (busca) params.busca = busca;
  return httpService.get('/despesa-cartao-credito/fechamento/fornecedores-lookup', {
    params,
  });
};

// Fonte: uFechamentoCartaoCredito.pas:480-482 — Param.Conta_Despesa_Cartao (default do painel).
export const obterContaDespesaPadraoCartao = () =>
  httpService.get('/despesa-cartao-credito/fechamento/conta-despesa-padrao');

export const listarDespesasCartaoCredito = filtros =>
  httpService.get('/despesa-cartao-credito/listar', { params: filtros });

export const buscarDespesaCartaoCredito = id =>
  httpService.get(`/despesa-cartao-credito/buscar/${id}`);

export const criarDespesaCartaoCredito = data =>
  httpService.post('/despesa-cartao-credito/criar', data);

export const alterarDespesaCartaoCredito = data =>
  httpService.post('/despesa-cartao-credito/alterar', data);

export const removerDespesaCartaoCredito = codigo =>
  httpService.post('/despesa-cartao-credito/remover', { codigo });

export const listarDespesasPorChavePagamento = seqCAP =>
  httpService.get(`/despesa-cartao-credito/por-chave-pagamento/${seqCAP}`);

export const buscarDespesasElegiveis = filtros =>
  httpService.get('/despesa-cartao-credito/fechamento/buscar', { params: filtros });

export const gravarFechamentoDespesas = (dados, arquivoPdf) => {
  const formData = new FormData();
  formData.append('dados', JSON.stringify(dados));
  if (arquivoPdf) formData.append('arquivo', arquivoPdf);
  return httpService.post('/despesa-cartao-credito/fechamento/gravar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const alterarValorPosFechamento = data =>
  httpService.post('/despesa-cartao-credito/fechamento/alterar-valor', data);

export const anexarPdfDespesaCartao = (codigo, arquivoPdf) => {
  const formData = new FormData();
  formData.append('arquivo', arquivoPdf);
  return httpService.post(`/despesa-cartao-credito/${codigo}/anexo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const listarAnexosDespesaCartao = codigo =>
  httpService.get(`/despesa-cartao-credito/${codigo}/anexos`);

// W-0510: Vínculo Conta × Usuário × GE
export const listarGruposEmpresaVinculo = () =>
  httpService.get('/vinculo-conta-usuario/grupos-empresa');

export const listarUsuariosAtivosVinculo = () =>
  httpService.get('/vinculo-conta-usuario/usuarios-ativos');

export const listarContasElegiveis = (codigoGrupoEmpresa, codigoConta) =>
  httpService.get('/vinculo-conta-usuario/contas-elegiveis', {
    params: {
      codigo_grupo_empresa: codigoGrupoEmpresa,
      codigo_conta: codigoConta || null,
    },
  });

export const listarVinculosContaUsuario = (
  codigoGrupoEmpresa,
  codigoUsuario,
  codigoConta
) => {
  const params = { codigo_grupo_empresa: codigoGrupoEmpresa };
  if (codigoUsuario != null) params.codigo_usuario = codigoUsuario;
  if (codigoConta != null) params.codigo_conta = codigoConta;
  return httpService.get('/vinculo-conta-usuario/listar', { params });
};

export const incluirLoteVinculoContaUsuario = body =>
  httpService.post('/vinculo-conta-usuario/incluir-lote', body);

export const excluirVinculoContaUsuario = body =>
  httpService.post('/vinculo-conta-usuario/excluir', body);

export const excluirLoteVinculoContaUsuario = body =>
  httpService.post('/vinculo-conta-usuario/excluir-lote', body);

// W-0541: Contas bloqueadas no extrato
export const listarGruposEmpresaExtrato = () =>
  httpService.get('/contas-extrato/grupos-empresa');

export const listarContasDisponiveisExtrato = codigoGrupoEmpresa =>
  httpService.get('/contas-extrato/contas-disponiveis', {
    params: { codigoGrupoEmpresa },
  });

export const listarContasBloqueadasExtrato = (
  pagina = 1,
  tamanhoPagina = 20,
  ordenarPor = 'apelidoGrupoEmpresa',
  ordemDescendente = false
) =>
  httpService.get('/contas-extrato/listar', {
    params: { pagina, tamanhoPagina, ordenarPor, ordemDescendente },
  });

export const bloquearContaExtrato = body =>
  httpService.post('/contas-extrato/bloquear', body);

export const desbloquearContaExtrato = body =>
  httpService.post('/contas-extrato/desbloquear', body);

// W-0512: Categorias de Contas
export const buscarCategoriaContas = () => httpService.get('/categoria-contas');

export const criarCategoriaContas = dados =>
  httpService.post('/categoria-contas', dados);

export const atualizarCategoriaContas = dados =>
  httpService.post('/categoria-contas/atualizar', dados);

export const excluirCategoriaContas = dados =>
  httpService.post('/categoria-contas/excluir', dados);

// W-0505: Regiões
export const obterRegioes = () => httpService.get('/regiao');

export const criarRegiao = dados => httpService.post('/regiao', dados);

export const atualizarRegiao = dados =>
  httpService.post('/regiao/atualizar', dados);

export const excluirRegiao = dados =>
  httpService.post('/regiao/excluir', dados);

// W-0529: Relatório Variantes de Ativo
export const listarRelatorioVariantesAtivo = (params) =>
  httpService.get('/relatorios/variantes-ativo', { params });
// W-0485: Redutores e Descontos
export const buscarRedutores = () =>
  httpService.get('/redutor-desconto/redutores');

export const inserirRedutor = data =>
  httpService.post('/redutor-desconto/redutores/inserir', data);

export const atualizarRedutor = data =>
  httpService.put('/redutor-desconto/redutores/atualizar', data);

export const excluirRedutor = codigo =>
  httpService.post('/redutor-desconto/redutores/excluir', { codigo });

export const buscarDescontosVendaUsuario = () =>
  httpService.get('/redutor-desconto/descontos');

export const buscarUsuariosDescontoVenda = () =>
  httpService.get('/redutor-desconto/descontos/usuarios');

export const buscarFamiliasDescontoVenda = () =>
  httpService.get('/redutor-desconto/descontos/familias');

export const incluirDescontoVendaUsuario = data =>
  httpService.post('/redutor-desconto/descontos/incluir', data);

export const excluirDescontoVendaUsuario = data =>
  httpService.post('/redutor-desconto/descontos/excluir', data);
// W-0493: Notificação Extra Judicial
export const listarNotificacoesExtraJudiciais = filtros =>
  httpService.get('/notificacao-extra-judicial/listar', { params: filtros });

export const obterResumoNotificacoesExtraJudiciais = filtros =>
  httpService.get('/notificacao-extra-judicial/resumo', { params: filtros });

export const obterPeriodoPorStatusNotificacaoExtraJudicial = filtros =>
  httpService.get('/notificacao-extra-judicial/periodo-por-status', {
    params: filtros,
  });

export const alterarStatusNotificacaoExtraJudicial = payload =>
  httpService.post('/notificacao-extra-judicial/alterar-status', payload);

export const imprimirNotificacaoExtraJudicial = payload =>
  httpService.fetch({
    url: '/notificacao-extra-judicial/imprimir-notificacao',
    data: payload,
    method: 'post',
    responseType: 'blob',
  });

export const exportarPdtecNotificacaoExtraJudicial = payload =>
  httpService.fetch({
    url: '/notificacao-extra-judicial/exportar-pdtec',
    data: payload,
    method: 'post',
    responseType: 'blob',
  });

export const imprimirCartaAdmNotificacaoExtraJudicial = payload =>
  httpService.fetch({
    url: '/notificacao-extra-judicial/imprimir-carta-adm',
    data: payload,
    method: 'post',
    responseType: 'blob',
  });

export const registrarRetornoComunicadoNotificacaoExtraJudicial = payload =>
  httpService.post(
    '/notificacao-extra-judicial/registrar-retorno-comunicado',
    payload
  );

export const imprimirTermoRescisaoNotificacaoExtraJudicial = payload =>
  httpService.fetch({
    url: '/notificacao-extra-judicial/imprimir-termo-rescisao',
    data: payload,
    method: 'post',
    responseType: 'blob',
  });

export const obterOcorrenciasNotificacaoExtraJudicial = (boleto, dataInc) =>
  httpService.get('/notificacao-extra-judicial/ocorrencias', {
    params: { boleto, data_inc: dataInc },
  });

export const validarEmpreendimentosImpressaoNotificacaoExtraJudicial = registros =>
  httpService.post(
    '/notificacao-extra-judicial/validar-empreendimentos-impressao',
    { registros }
  );

// === Contas de Salário — W-0494 ===
// G-02: grid global — sem parâmetro de GE (paridade Delphi UContaSalario.pas linhas 182-187)
export const listarContasSalario = () =>
  httpService.get('/conta-salario/listar');

export const incluirContaSalario = data =>
  httpService.post('/conta-salario/incluir', data);

export const excluirContaSalario = data =>
  httpService.post('/conta-salario/excluir', data);

export const listarHierarquiaContaSalario = tipo =>
  httpService.get('/conta-salario/hierarquia/listar?tipo=' + tipo);

export const incluirHierarquiaContaSalario = data =>
  httpService.post('/conta-salario/hierarquia/incluir', data);

export const atualizarStatusHierarquiaContaSalario = data =>
  httpService.post('/conta-salario/hierarquia/atualizar-status', data);

export const excluirHierarquiaContaSalario = data =>
  httpService.post('/conta-salario/hierarquia/excluir', data);

export const incluirSuplenteContaSalario = data =>
  httpService.post('/conta-salario/hierarquia/suplente/incluir', data);

// Extensão do lookup de contas existente — aceita tipos CSV (ex: '3,4')
export const listarLookupContasPorTipos = (codigoGe, tipos) =>
  httpService.get(
    '/grupo-empresa/lookup/contas/' + codigoGe + '?tipos=' + tipos
  );

// W-0500: Vínculo de Despesa com Tipo de Pagamento
export const listarDespesaTipoPagamento = () =>
  httpService.get('/despesa-tipo-pagamento');

export const criarDespesaTipoPagamento = dados =>
  httpService.post('/despesa-tipo-pagamento', dados);

export const excluirDespesaTipoPagamento = dados =>
  httpService.post('/despesa-tipo-pagamento/excluir', dados);
// Centro de Custo (W-0501)
export const listarCentroCusto = filtros =>
  httpService.post('/centro-custo/listar', filtros || {});

export const obterParametrosCentroCusto = () =>
  httpService.get('/centro-custo/parametros');

export const inserirCentroCusto = dados =>
  httpService.post('/centro-custo/inserir', dados);

export const atualizarCentroCusto = dados =>
  httpService.post('/centro-custo/atualizar', dados);

export const excluirCentroCusto = codigo =>
  httpService.post('/centro-custo/excluir', { codigo });
// W-0503 — Matricial: Usuário Alternativo
export const buscarMatricialUsuarioAlternativoVigente = codigoUsuarioTitular =>
  httpService.get(
    `/matricial-usuario-alternativo/vigente/${codigoUsuarioTitular}`
  );

export const definirMatricialUsuarioAlternativo = data =>
  httpService.post('/matricial-usuario-alternativo/definir', data);

export const inativarMatricialUsuarioAlternativo = codigo =>
  httpService.post('/matricial-usuario-alternativo/inativar', { codigo });

// W-0570 — GES Matricial de Despesas — Períodos
export const listarMatricialPeriodos = (pagina, tamanhoPagina, descricao) => {
  const params = [`pagina=${pagina}`, `tamanhoPagina=${tamanhoPagina}`];
  if (descricao) params.push(`descricao=${encodeURIComponent(descricao)}`);
  return httpService.get(`/matricial-periodos/listar?${params.join('&')}`);
};

export const detalharMatricialPeriodo = codigo =>
  httpService.get(`/matricial-periodos/${codigo}`);

export const incluirMatricialPeriodo = data =>
  httpService.post('/matricial-periodos/incluir', data);

export const editarMatricialPeriodo = (codigo, data) =>
  httpService.post(`/matricial-periodos/${codigo}/editar`, data);

export const removerMatricialPeriodo = codigo =>
  httpService.post(`/matricial-periodos/${codigo}/remover`, {});

// W-0576 — GES > Negócios > Nível de Retenção
export const GesRetencoesService = {
  listarUsuariosAtivos: () => httpService.get('/usuarios/ativos'),
  listarUsuariosRetencao: () => httpService.get('/ges/retencoes/usuarios'),
  incluirUsuarioRetencao: data =>
    httpService.post('/ges/retencoes/usuarios', data),
  alterarStatusUsuarioRetencao: data =>
    httpService.post('/ges/retencoes/usuarios/status', data),
  excluirUsuarioRetencao: data =>
    httpService.post('/ges/retencoes/usuarios/excluir', data),
};

// W-0518: Ferramentas / Digitalização
export const anexarDigitalizacao = formData =>
  httpService.post('/digitalizacao/anexar', formData);

export const listarGruposEmpresaDigitalizacao = () =>
  httpService.get('/digitalizacao/grupos-empresa');

export const listarSugestoesTituloDigitalizacao = tipo =>
  httpService.get('/digitalizacao/sugestoes-titulo', { params: { tipo } });

export const autocompleteEntidadeDigitalizacao = (
  tipo,
  termo,
  codigoGrupoEmpresa
) =>
  httpService.get('/digitalizacao/autocomplete-entidade', {
    params: { tipo, termo, ge: codigoGrupoEmpresa },
  });

export const buscarChaveDigitalizacao = (ge, portador, sequencia) =>
  httpService.get('/digitalizacao/buscar-chave', {
    params: { ge, portador, sequencia },
  });

export const buscarBoletoDigitalizacao = (modo, termo, codigoGrupoEmpresa) =>
  httpService.get('/digitalizacao/buscar-boleto', {
    params: { modo, termo, ge: codigoGrupoEmpresa },
  });

export const listarContasDigitalizacao = ge =>
  httpService.get('/digitalizacao/listar-contas', { params: { ge } });

export const buscarMataDigitalizacao = filtros =>
  httpService.get('/digitalizacao/buscar-mata', { params: filtros });

export const buscarNegocioDigitalizacao = filtros =>
  httpService.get('/digitalizacao/buscar-negocio', { params: filtros });
// region Isencoes de Cobranca (W-0825)
export const listarIsencoesCobranca = params =>
  httpService.get('/cobranca/isencoes/listar', { params });

export const listarContasIsencao = codigoGe =>
  httpService.get('/cobranca/isencoes/buscar/contas', { params: { codigoGe } });

export const listarGruposEmpresaIsencao = () =>
  httpService.get('/cobranca/isencoes/buscar/grupos-empresa');

export const listarUsuariosIsencao = () =>
  httpService.get('/cobranca/isencoes/buscar/usuarios');

export const verificarNegativacaoConta = (conta, ge) =>
  httpService.get('/cobranca/isencoes/verificar-negativacao', {
    params: { conta, ge },
  });

export const incluirIsencaoCobranca = payload =>
  httpService.post('/cobranca/isencoes/incluir', payload);

export const excluirIsencaoCobranca = payload =>
  httpService.post('/cobranca/isencoes/excluir', payload);

export const alterarValidadeLoteIsencaoCobranca = payload =>
  httpService.post('/cobranca/isencoes/alterar-validade-lote', payload);
// endregion

// W-0768 — Imóveis Vendidos
export const consultarImoveisVendidos = filtros =>
  httpService.post('/relatorios/imoveis-vendidos/consultar', filtros);

export const buscarFamiliasImoveisVendidos = ges =>
  httpService.get('/relatorios/imoveis-vendidos/familias', { params: { ges } });

export const buscarVendedoresImoveisVendidos = ges =>
  httpService.get('/relatorios/imoveis-vendidos/vendedores', {
    params: { ges },
  });
// W-0594: Contas Saldo Disponível
export const consultarContasSaldoDisponivel = (dataInicial, dataFinal) =>
  httpService.post('/relatorios/contas-saldo-disponivel/consultar', {
    data_inicial: dataInicial,
    data_final: dataFinal,
  });

// W-0590 - Relatorio Plano de Contas
export const listarGruposContasPlanoContas = () =>
  httpService.get('/financeiro/grupo-contas/listar');
export const baixarPdfPlanoContasContas = (params) =>
  httpService.get('/relatorio/plano-contas-contas/pdf', { params, responseType: 'blob' });

// W-0620: GES > Gerencial > Relatórios > Despesas > Analítico de despesas
export const listarOpcoesRelatorioDespesasAnalitico = () =>
  httpService.get('/relatorios/despesas-analitico/opcoes');

export const gerarRelatorioDespesasAnalitico = (filtros) =>
  httpService.post('/relatorios/despesas-analitico/gerar', filtros);

// W-0495: Solicitação de Débitos Municipais e Atualização Cadastral
export const getSolicitaDebMunicipioGruposEmpresa = () =>
  httpService.get('/solicita-deb-municipio/grupos-empresa');

export const getSolicitaDebMunicipioContas = codigoGrupoEmpresa =>
  httpService.get(
    `/solicita-deb-municipio/contas?codigoGrupoEmpresa=${codigoGrupoEmpresa}`
  );

export const getSolicitaDebMunicipioTipos = () =>
  httpService.get('/solicita-deb-municipio/tipos-solicitacao');

// DW-1019: combo de filtro da listagem inclui EXCLUSÃO DE TITULARIDADE (48),
// que segue indisponível na nova solicitação.
export const getSolicitaDebMunicipioTiposFiltro = () =>
  httpService.get('/solicita-deb-municipio/tipos-solicitacao-filtro');

export const getSolicitaDebMunicipioStatus = () =>
  httpService.get('/solicita-deb-municipio/status');

// DW-1019: `tiposSolicitacao` vai como CSV ("48,82") — o binder [FromUri] do Web API não
// popula List<int> de forma confiável; CSV é a convenção do backend para lista em query string.
export const listarSolicitaDebMunicipio = filtros =>
  httpService.get('/solicita-deb-municipio/listar', { params: filtros });

export const obterSolicitaDebMunicipio = codigo =>
  httpService.get(`/solicita-deb-municipio/${codigo}`);

export const listarSolicitaDebMunicipioAnexos = codigo =>
  httpService.get(`/solicita-deb-municipio/${codigo}/anexos`);

export const uploadSolicitaDebMunicipioAnexo = formData =>
  httpService.post('/solicita-deb-municipio/anexo/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// DW-1025 — anexos em solicitação já aberta
export const getSolicitaDebMunicipioTitulosAnexo = () =>
  httpService.get('/solicita-deb-municipio/titulos-anexo');

export const anexarSolicitaDebMunicipioDocumento = (codigo, token, titulo) =>
  httpService.post(`/solicita-deb-municipio/${codigo}/anexo/inserir`, {
    token,
    titulo,
  });

export const excluirSolicitaDebMunicipioAnexo = (codigo, seq) =>
  httpService.post(`/solicita-deb-municipio/${codigo}/anexo/excluir`, { seq });

export const baixarSolicitaDebMunicipioAnexo = (codigo, seq) =>
  httpService.get(`/solicita-deb-municipio/anexo/${codigo}/download`, {
    params: { seq },
    responseType: 'blob',
  });

// DW-1015 — extrai a listagem em XLSX no formato do departamento, com os filtros marcados
export const exportarSolicitaDebMunicipioExcel = filtros =>
  httpService.post('/solicita-deb-municipio/exportar-excel', filtros, {
    responseType: 'blob',
  });

export const inserirSolicitaDebMunicipio = payload =>
  httpService.post('/solicita-deb-municipio/inserir', payload);

export const excluirSolicitaDebMunicipio = codigo =>
  httpService.post('/solicita-deb-municipio/excluir', { codigo });

export const listarAtivosSolicitaDebMunicipio = (
  codigoFamilia,
  codigoGrupoEmpresa,
  codigoConta,
  incluirRescindidos = false
) =>
  httpService.get('/solicita-deb-municipio/ativos', {
    params: {
      codigoFamilia,
      codigoGrupoEmpresa,
      codigoConta,
      incluirRescindidos,
    },
  });

export const alterarStatusSolicitaDebMunicipio = payload =>
  httpService.post('/solicita-deb-municipio/alterar-status', payload);

export const gerarRequerimentoSolicitaDebMunicipio = codigo =>
  httpService.post('/solicita-deb-municipio/gerar-requerimento', { codigo });

export const getBoletoContextoSolicitaDebMunicipio = (
  codigoBoleto,
  codigoGrupoEmpresa
) =>
  httpService.get(
    `/solicita-deb-municipio/boleto/${codigoBoleto}/contexto?codigoGrupoEmpresa=${codigoGrupoEmpresa}`
  );

// W-0585 — Relatório de Contas
export const gerarRelatorioContas = params =>
  httpService.get('/relatorios/contas', { params });

export const listarOcorrenciasSolicitaDebMunicipio = codigo =>
  httpService.get(`/solicita-deb-municipio/${codigo}/ocorrencias`);

export const inserirOcorrenciaSolicitaDebMunicipio = (codigo, payload) =>
  httpService.post(
    `/solicita-deb-municipio/${codigo}/ocorrencia/inserir`,
    payload
  );

export const excluirOcorrenciaSolicitaDebMunicipio = (
  codigo,
  codigoCalc,
  data
) =>
  httpService.post(`/solicita-deb-municipio/${codigo}/ocorrencia/excluir`, {
    codigo_calc: codigoCalc,
    data,
  });

export const listarTitulosOcorrenciaSolicitaDebMunicipio = () =>
  httpService.get('/solicita-deb-municipio/titulos-ocorrencia');

export const listarTiposSolicitaDebMunicipioCadastro = () =>
  httpService.get('/solicita-deb-municipio/tipos');

export const inserirTipoSolicitaDebMunicipio = payload =>
  httpService.post('/solicita-deb-municipio/tipo/inserir', payload);

export const alterarTipoSolicitaDebMunicipio = payload =>
  httpService.post('/solicita-deb-municipio/tipo/alterar', payload);

export const excluirTipoSolicitaDebMunicipio = codigo =>
  httpService.post('/solicita-deb-municipio/tipo/excluir', { codigo });

// W-0562 — Histórico Padrão (GES)
export const listarHistoricoPadrao = params =>
  httpService.get('/historico-padrao/listar', { params });

export const criarHistoricoPadrao = data =>
  httpService.post('/historico-padrao/criar', data);

export const atualizarHistoricoPadrao = data =>
  httpService.post('/historico-padrao/atualizar', data);

export const excluirHistoricoPadrao = data =>
  httpService.post('/historico-padrao/excluir', data);
// W-0561: Estorno de Reapresentação de Cheques
export const buscarChequesParaEstorno = params =>
  httpService.get('/cheques/buscar-para-estorno-reapresentacao', { params });

export const executarEstornoReaprCheque = data =>
  httpService.post('/cheques/estorno-reapresentacao/executar', data);

// W-0564 — Cadastro de Templates de Rateio
export const listarRateioTemplates = params =>
  httpService.get('/rateio-template', { params });

export const obterRateioTemplate = codigo =>
  httpService.get(`/rateio-template/${codigo}`);

export const salvarRateioTemplate = data =>
  httpService.post('/rateio-template/salvar', data);

export const excluirRateioTemplate = codigo =>
  httpService.post('/rateio-template/excluir', { codigo });

export const sugerirCodigoRateioTemplate = () =>
  httpService.post('/rateio-template/sugerir-codigo');

export const recalcularRateioTemplatePorUsuarios = codigo =>
  httpService.post(`/rateio-template/${codigo}/recalcular-usuarios`);

export const recalcularRateioTemplatePorM2 = codigo =>
  httpService.post(`/rateio-template/${codigo}/recalcular-m2`);

// W-0564 fix-round: BE não expõe /departamento/ativos — usar lookup oficial
// /usuario/lookup/departamentos (UsuarioController.ListarDepartamentos) que já filtra Status='A' OR NULL.
export const listarDepartamentosRateioAtivos = () =>
  httpService.get('/usuario/lookup/departamentos');

// W-0563: Cadastro de Cartões (operadoras + taxas por GE)
export const listarCartoes = filtros =>
  httpService.get('/cartao/listar', { params: filtros });

export const obterCartao = codigo => httpService.get(`/cartao/${codigo}`);

export const salvarCartao = payload =>
  httpService.post('/cartao/salvar', payload);

export const excluirCartao = codigo =>
  httpService.post('/cartao/excluir', { codigo });

export const listarGruposEmpresaCartao = () =>
  httpService.get('/cartao/grupos-empresa');

// W-0624 — Perfil de Carteira por Faixa de Valor
export const perfilCarteiraGruposEmpresa = () =>
  httpService.get('/perfil-carteira/grupos-empresa');

export const perfilCarteiraDaOperadores = (codigoGe) =>
  httpService.get('/perfil-carteira/da-operadores', {
    params: { codigoGe },
  });

export const perfilCarteiraClientes = (codigoGe) =>
  httpService.get('/perfil-carteira/clientes', {
    params: { codigoGe },
  });

export const perfilCarteiraGerar = (data) =>
  httpService.post('/perfil-carteira/gerar', data);

// LICOES ciclo 10 L2: httpService.post(url, data, { responseType:'blob' }) descarta
// o responseType (3o arg vira header). Usar httpService.fetch direto.
export const perfilCarteiraExportarPdf = (data) =>
  httpService.fetch({
    url: '/perfil-carteira/exportar-pdf',
    method: 'post',
    data,
    responseType: 'blob',
  });
// W-0612 — Fluxo de Caixa Gerencial
export const listarGEsFluxoCaixa = () =>
  httpService.get('/fluxo-caixa/grupos-empresa');

export const listarEmpreendimentosFluxoCaixa = (codigosGE) =>
  httpService.get('/fluxo-caixa/empreendimentos', {
    params: { codigosGrupoEmpresa: codigosGE.join(',') },
  });

export const gerarFluxoCaixa = (data) =>
  httpService.post('/fluxo-caixa/relatorio', data);

const FLUXO_CAIXA_DW_BASE = '/relatorios/fluxo-caixa-dw';

export const buscarFiltrosFluxoCaixaDw = () =>
  httpService.get(`${FLUXO_CAIXA_DW_BASE}/filtros`);

export const buscarValoresEmpreendimentoFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/valores-empreendimento`, filtros);

export const buscarResumoFluxoCaixaFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/resumo-fluxo-caixa`, filtros);

export const buscarTipoParcelaFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/tipo-parcela`, filtros);

export const buscarFluxoPorAnoFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/fluxo-por-ano`, filtros);

export const buscarSituacaoContratoFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/situacao-contrato`, filtros);

export const buscarDetalhamentoFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/detalhamento`, filtros);

export const buscarDetalhamentoVendasFcDw = (filtros) =>
  httpService.post(`${FLUXO_CAIXA_DW_BASE}/detalhamento-vendas`, filtros);

export const buscarUltimaAtualizacaoFcDw = () =>
  httpService.get(`${FLUXO_CAIXA_DW_BASE}/ultima-atualizacao`);

// W-0879 — Processar Retorno Cobrança BRADESCO sem registro
export const processarRetornoBradesco = (file, forceReprocess = false) => {
  const form = new FormData();
  form.append('arquivo', file);
  return httpService.fetch({
    url: `/generate/retorno-cobranca-bradesco/processar?forceReprocess=${forceReprocess}`,
    data: form,
    method: 'post',
  });
};

export const consultar2ViaBradesco = (filtros) =>
  httpService.get('/generate/retorno-cobranca-bradesco/consultar-2via', { params: filtros });

export const reimprimir2ViaBradesco = (req) =>
  httpService.fetch({
    url: '/generate/retorno-cobranca-bradesco/reimprimir',
    data: req,
    method: 'post',
    responseType: 'blob',
  });

// DW-0982 — Controle de Horas PJ
export const listarPrestadoresPj = (filtros) => {
  // Soft delete: a listagem sempre traz só PJ ativo (Status=1) no backend.
  // O único filtro aceito é com_contrato_aberto.
  const params = {};
  if (filtros && filtros.comContratoAberto != null) {
    params.com_contrato_aberto = filtros.comContratoAberto;
  }
  return httpService.get('/juridico/prestadores/listar', { params });
};

export const criarPrestadorPj = payload =>
  httpService.post('/juridico/prestadores/criar', payload);

export const atualizarPrestadorPj = payload =>
  httpService.post('/juridico/prestadores/atualizar', payload);

export const excluirPrestadorPj = codigo =>
  httpService.post('/juridico/prestadores/excluir', { codigo });

export const obterDetalhesPrestadorPj = codigo =>
  httpService.get(`/juridico/prestadores/${codigo}/detalhes`);

export const listarSociosPrestadorPj = codigoPj =>
  httpService.get('/juridico/prestadores/socios/listar', {
    params: { codigoPj },
  });

export const salvarSociosPrestadorPj = payload =>
  httpService.post('/juridico/prestadores/socios/salvar', payload);

export const listarHistoricoValorHoraPj = codigo =>
  httpService.get(`/juridico/prestadores/${codigo}/historico-vh`);

export const obterCoberturaValorHoraPj = codigo =>
  httpService.get(`/juridico/prestadores/${codigo}/cobertura-vh`);

export const salvarVigenciaValorHoraPj = payload =>
  httpService.post('/juridico/prestadores/vigencias-vh/salvar', payload);

export const excluirVigenciaValorHoraPj = codigo =>
  httpService.post('/juridico/prestadores/vigencias-vh/excluir', { codigo });

export const listarFechamentosPj = filtros => {
  const params = {};
  if (filtros && filtros.codigoPj) params.codigoPj = filtros.codigoPj;
  if (filtros && filtros.competenciaInicio) params.competenciaInicio = filtros.competenciaInicio;
  if (filtros && filtros.competenciaFim) params.competenciaFim = filtros.competenciaFim;
  return httpService.get('/juridico/controlepj/fechamento/listar', { params });
};

export const calcularFechamentoPj = payload =>
  httpService.post('/juridico/controlepj/fechamento/calcular', payload);

export const salvarFechamentoPj = payload =>
  httpService.post('/juridico/controlepj/fechamento/salvar', payload);

export const atualizarFechamentoPj = payload =>
  httpService.post('/juridico/controlepj/fechamento/atualizar', payload);

export const excluirFechamentoPj = codigo =>
  httpService.post('/juridico/controlepj/fechamento/excluir', { codigo });

// DW-1063 (ADR-005 supersede ADR-004): sem função de leitura dedicada — a lista de
// adicionais viaja dentro do objeto de listarFechamentosPj (fechamento.nf_adicionais).

export const importarFechamentoPj = arquivo => {
  const form = new FormData();
  form.append('arquivo', arquivo);
  return httpService.fetch({
    url: '/juridico/controlepj/fechamento/importar',
    data: form,
    method: 'post',
  });
};
// W-0882 — Retorno Cobrança - Geral (4 bancos)
// Backend: codigoCliente + banco vão como query params; arquivo é IFormFile no body multipart.
// forceReprocess permite reprocessar arquivo já registrado em Conta_Bancaria_Processados
// (paridade com processarRetornoBradesco / W-0879).
export const processarArquivoManual = (file, codigoCliente, banco, forceReprocess = false) => {
  const form = new FormData();
  form.append('arquivo', file);
  const query = `codigoCliente=${encodeURIComponent(codigoCliente)}&banco=${encodeURIComponent(banco)}&forceReprocess=${forceReprocess}`;
  return httpService.fetch({
    url: `/retorno-cobranca/processar-manual?${query}`,
    data: form,
    method: 'post',
  });
};

export const baixarModeloImportacaoFechamentoPj = () =>
  httpService.fetch({
    url: '/juridico/controlepj/fechamento/importar/modelo',
    method: 'get',
    responseType: 'blob',
  });

export const obterHorasSugeridasFechamentoPj = (codigoPj, competencia) =>
  httpService.get('/juridico/controlepj/fechamento/horas-sugeridas', {
    params: { codigoPj, competencia },
  });

export const obterIpcaEfetivo = competencia =>
  httpService.get(`/juridico/controlepj/ipca/efetivo/${competencia}`);

export const listarOverridesIpca = () =>
  httpService.get('/juridico/controlepj/ipca/overrides');

// payload: { competencia, valor_percentual, observacao, codigo_usuario, codigo_usuario_criador,
//            aplicar_retroativo }. DW-0982 P6: aplicar_retroativo=true dispara o recálculo do ledger
//            de todos os PJs (botão "Alterar Todos os Fechamentos"); ausente/false preserva ADR-008.
export const salvarOverrideIpca = payload =>
  httpService.post('/juridico/controlepj/ipca/override/salvar', payload);

export const listarIpcasNoRangePj = (competenciaInicio, competenciaFim) =>
  httpService.get('/juridico/controlepj/ipca/efetivos', {
    params: { inicio: competenciaInicio, fim: competenciaFim, _: Date.now() },
  });

export const excluirOverrideIpcaPj = competencia =>
  httpService.post('/juridico/controlepj/ipca/override/excluir', { competencia });

export const exportarExtratoFundosPjExcel = filtros =>
  httpService.fetch({
    url: '/juridico/controlepj/relatorios/extrato-fundos/excel',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

export const exportarFechamentoConsolidadoPjExcel = filtros =>
  httpService.fetch({
    url: '/juridico/controlepj/relatorios/fechamento-consolidado/excel',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

export const exportarResumoPrestadoresPjExcel = filtros =>
  httpService.fetch({
    url: '/juridico/controlepj/relatorios/resumo-prestadores/excel',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

export const exportarCalculoRescisaoPjExcel = filtros =>
  httpService.fetch({
    url: '/juridico/controlepj/relatorios/calculo-rescisao/excel',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

export const listarFundosPj = filtros =>
  httpService.get('/juridico/controlepj/fundos/listar', {
    params: { ...(filtros || {}), _: Date.now() },
  });

export const obterSaldosFundosPj = codigoPj =>
  httpService.get(`/juridico/controlepj/fundos/saldos/${codigoPj}`, {
    params: { _: Date.now() },
  });

export const obterSaldosFundosBulkPj = (codigoPj = null) =>
  httpService.get('/juridico/controlepj/fundos/saldos-bulk', {
    params: { codigoPj: codigoPj || undefined, _: Date.now() },
  });

export const registrarSaqueFundoPj = payload =>
  httpService.post('/juridico/controlepj/fundos/saque', payload);

export const obterRescisaoPj = codigoPj =>
  httpService.get(`/juridico/controlepj/rescisao/${codigoPj}`, {
    params: { _: Date.now() },
  });

export const rescindirPj = (codigoPj, payload) =>
  httpService.post(`/juridico/controlepj/rescisao/${codigoPj}`, payload);

export const listarUfsJuridico = () =>
  httpService.get('/juridico/controlepj/listar/ufs');

export const listarCidadesJuridico = () =>
  httpService.get('/juridico/controlepj/listar/cidades');

export const listarUsuariosJuridico = () =>
  httpService.get('/juridico/controlepj/listar/usuarios');

export const listarBancosJuridico = () =>
  httpService.get('/juridico/controlepj/listar/bancos');

export const listarContratosPj = () =>
  httpService.get('/juridico/controlepj/contratos/listar');

export const listarAnexosContratoPj = codigo =>
  httpService.get(`/juridico/controlepj/contratos/${codigo}/anexos`);

// DW-0982 — Melhoria Modal Contrato: alimenta o modal em modo edição com a
// última vigência registrada no range do contrato + flag tem_fechamentos.
export const obterDetalhesContratoPj = codigo =>
  httpService.get(`/juridico/controlepj/contratos/${codigo}/detalhes`);

export const criarContratoPj = payload =>
  httpService.post('/juridico/controlepj/contratos/criar', payload);

export const atualizarContratoPj = payload =>
  httpService.post('/juridico/controlepj/contratos/atualizar', payload);

export const reativarContratoPj = payload =>
  httpService.post('/juridico/controlepj/contratos/reativar', payload);

export const uploadAnexosContratoPjLote = ({ codigoPj, codigoContrato, arquivos }) => {
  const form = new FormData();
  form.append('codigo_pj', codigoPj);
  form.append('codigo_contrato', codigoContrato);
  arquivos.forEach(arquivo => form.append('arquivo', arquivo));
  return httpService.fetch({
    url: '/juridico/controlepj/anexos',
    data: form,
    method: 'post',
  });
};

export const downloadAnexoPj = (codigo, codigoPj) =>
  httpService.get(`/juridico/controlepj/anexos/${codigo}/download`, {
    params: { codigoPj },
    responseType: 'blob',
  });

export const removerAnexoContratoPj = payload =>
  httpService.post('/juridico/controlepj/anexos/remover', payload);
export const obterArquivosNaoLidos = (codigoCliente) =>
  httpService.get(
    `/retorno-cobranca/arquivos-nao-lidos?codigoCliente=${codigoCliente}`
  );

export const obterTitulosNaoBaixados = (codigoArquivo) =>
  httpService.get(
    `/retorno-cobranca/arquivos/${codigoArquivo}/titulos-nao-baixados`
  );

export const consultarRetornos = (filtros) =>
  httpService.get('/retorno-cobranca/consultar', { params: filtros });

// LICOES Ciclo 10 L2 — usar httpService.fetch para blob (não httpService.post com responseType)
export const exportarDiferencaJurosExcel = (filtros) =>
  httpService.fetch({
    url: '/retorno-cobranca/exportar-diferenca-juros-excel',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

// W-0710 — Cancelamento Proposta Mista
export const listarPropostasMistas = (codigoGe, codigoConta) =>
  httpService.get('/imob/cancelamento-mista/propostas', {
    params: { codigoGe, codigoConta: codigoConta || 0 },
  });

export const listarImoveisMista = (codigoProposta, efe) =>
  httpService.get('/imob/cancelamento-mista/imoveis', {
    params: { codigoProposta, efe },
  });

export const listarTitulosMista = (codigoProposta) =>
  httpService.get('/imob/cancelamento-mista/titulos', {
    params: { codigoProposta },
  });

export const cancelarPropostaMista = (data) =>
  httpService.post('/imob/cancelamento-mista/cancelar', data);

// W-0634 — Manual de Apuração de Resultados
export const getManualApuracao = () =>
  httpService.get('/manual-apuracao');

export const salvarManualApuracao = (manualApuracao, paramVersao) =>
  httpService.post('/manual-apuracao/salvar', {
    manual_apuracao: manualApuracao,
    param_versao: paramVersao,
  });

// W-0652 — Altera Nome Ativo (preview + execução; mesmo endpoint, modo_simulacao alterna)
export const preVisualizarAlteraNomeAtivo = (data) =>
  httpService.post('/ativo/alterar-nome-lote', {
    ...data,
    modo_simulacao: true,
  });

export const executarAlteraNomeAtivo = (data) =>
  httpService.post('/ativo/alterar-nome-lote', {
    ...data,
    modo_simulacao: false,
  });

// W-0840 — Pro-Fit > Relatórios > Comissão de Imóveis
// ADR-002 separa POST /processar de GET /relatorio/{id} (re-impressão 2ª via barata)
// ADR-007: timeout estendido 200s (180s servidor + margem)
export const processarComissaoImoveis = (data) =>
  httpService.fetch({
    url: '/comissao-imoveis/processar',
    method: 'post',
    data,
    timeout: 200000,
  });

// LICOES Ciclo 10 L2: httpService.fetch com responseType, NUNCA httpService.post com 3o arg
export const baixarRelatorioComissaoImoveis = (processamentoId, incluir) =>
  httpService.fetch({
    url: `/comissao-imoveis/relatorio/${processamentoId}`,
    method: 'get',
    params: { incluir: (incluir || []).join(',') },
    responseType: 'blob',
  });

export const obterCorretoresComissaoImoveis = (codigoGE) =>
  httpService.get('/comissao-imoveis/corretores', { params: { ge: codigoGE } });

export const obterHistoricoComissaoImoveis = (filtros) =>
  httpService.get('/comissao-imoveis/historico', { params: filtros });

// W-0693 — Alertas de Empreendimentos
// Rotas plural /alertas-empreendimento alinhadas ao [RoutePrefix] do controller e TechSpec §2.4.
export const listarAlertasEmpreendimento = () =>
  httpService.get('/alertas-empreendimento/listar');

export const listarEmpreendimentosParaAlerta = () =>
  httpService.get('/alertas-empreendimento/empreendimentos');

export const cadastrarAlertaEmpreendimento = (data) =>
  httpService.post('/alertas-empreendimento/incluir', data);

export const atualizarAlertaEmpreendimento = (data) =>
  httpService.post('/alertas-empreendimento/atualizar', data);

export const excluirAlertaEmpreendimento = (seq) =>
  httpService.post('/alertas-empreendimento/excluir', { seq });

// W-0821 — Transferir títulos para cobrança (Imob > Cobrador)
// TechSpec §3.3. Exports usam httpService.fetch direto para responseType=blob (LICOES Ciclo 10 L2)
export const transfCobrancaLookups = () =>
  httpService.get('/transf-cobranca/lookups');

export const transfCobrancaPesquisar = (data) =>
  httpService.post('/transf-cobranca/pesquisar', data);

export const transfCobrancaLancar = (data) =>
  httpService.post('/transf-cobranca/lancar', data);

export const transfCobrancaExportarPdf = (data) =>
  httpService.fetch({
    url: '/transf-cobranca/exportar-pdf',
method: 'post',
  data,
  responseType: 'blob',
  });

export const transfCobrancaExportarExcel = (data) =>
  httpService.fetch({
    url: '/transf-cobranca/exportar-excel',
    method: 'post',
    data,
    responseType: 'blob',
  });

// W-0551: Baixa Título por Data (GES > Negócios > Títulos)
export const listarTitulosBaixa = (data) =>
  httpService.fetch({ url: '/baixa-titulo/listar', method: 'post', data });

export const calcularJurosBaixa = (data) =>
  httpService.fetch({ url: '/baixa-titulo/calcular-juros', method: 'post', data });

export const processarBaixaTitulo = (data) =>
  httpService.fetch({ url: '/baixa-titulo/processar', method: 'post', data });

export const listarDepartamentosBaixa = (codigoGrupoEmpresa) =>
  httpService.fetch({
    url: '/baixa-titulo/listar-departamentos',
    method: 'post',
    data: { codigoGrupoEmpresa },
  });

// W-0663 — Acerta contas de despesas/receitas
// Preview onBlur (3 endpoints) + commit transacional (1 endpoint).
// Backend retorna snake_case; ver TechSpec §2.
export const acertarContaService = {
  validarOrigem: (data) =>
    httpService.post('/ferramentas/acertar-conta/validar-origem', data),
  validarDestino: (data) =>
    httpService.post('/ferramentas/acertar-conta/validar-destino', data),
  validarCC: (data) =>
    httpService.post('/ferramentas/acertar-conta/validar-cc', data),
  executar: (data) => httpService.post('/ferramentas/acertar-conta', data),
};

// === W-0651: ALTERA CODIGO CONTA (Ferramenta GES, destrutiva) ===
// Namespace /ferramentas/alterar-codigo-conta (gate-1b Q-06=B). Backend snake_case.
// Fluxo: listar contas do GE -> validar (dry-run) -> executar (transacao SERIALIZABLE).
export const alterarCodigoContaService = {
  listarContas: (codigoGrupoEmpresa, busca, modo) =>
    httpService.get(
      `/ferramentas/alterar-codigo-conta/contas/${codigoGrupoEmpresa}`,
      { params: { busca, modo } }
    ),
  validar: (data) =>
    httpService.post('/ferramentas/alterar-codigo-conta/validar', data),
  executar: (data) =>
    httpService.post('/ferramentas/alterar-codigo-conta/executar', data),
};

// === W-0654: ALTERA CODIGO DEPARTAMENTO (Ferramenta GES, irreversivel) ===
// Namespace /ferramentas/alterar-codigo-departamento. Backend snake_case.
// Repoint-sem-disable no backend (sem NOCHECK/DROP, sem DELETE do antigo). Combo GE reusa
// listarGruposEmpresaDoUsuario (endpoint existente).
export const alterarCodigoDepartamentoService = {
  listarDepartamentos: (codigoGrupoEmpresa) =>
    httpService.get(
      `/ferramentas/alterar-codigo-departamento/departamentos/${codigoGrupoEmpresa}`
    ),
  validar: (data) =>
    httpService.post('/ferramentas/alterar-codigo-departamento/validar', data),
  executar: (data) =>
    httpService.post('/ferramentas/alterar-codigo-departamento/executar', data),
};

// === W-0489: CONSULTA DE OCORRÊNCIAS DE ATIVOS ===
// TechSpec §3.3. Read-only. Endpoints novos (titulos / ativos / datas) + estendido (ocorrencias).
// `ativoManutencaoListarOcorrencias` (linha 3977) mantida para retrocompat com ModalOcorrencias.
//
// Convencao do projeto: query params em snake_case ponta-a-ponta.
// titulo via query param (nao path) — suporta titulo='' para casar registros com Titulo NULL
// no banco (R4 Delphi: agregacoes normalizam NULL → '').

const toIsoOrNull = (data) => (data ? new Date(data).toISOString() : null);

export const listarTitulosOcorrenciasAtivo = (dataInicio = null) => {
  const iso = toIsoOrNull(dataInicio);
  return httpService.get('/ativo/ocorrencias/titulos', {
    params: iso ? { data_inicio: iso } : {},
  });
};

export const listarAtivosPorTituloOcorrencia = (titulo, data = null) => {
  const iso = toIsoOrNull(data);
  const params = { titulo: titulo != null ? titulo : '' };
  if (iso) params.data = iso;
  return httpService.get('/ativo/ocorrencias/ativos', { params });
};

export const listarDatasOcorrenciaAtivo = (titulo, codigoAtivo, data = null) => {
  const iso = toIsoOrNull(data);
  const params = {
    titulo: titulo != null ? titulo : '',
    codigo_ativo: codigoAtivo,
  };
  if (iso) params.data = iso;
  return httpService.get('/ativo/ocorrencias/datas', { params });
};

export const obterOcorrenciasDoAtivo = (
  codigoAtivo,
  { titulo, dataInicio, dataFim } = {}
) => {
  const params = {};
  if (titulo != null && titulo !== '') params.titulo = titulo;
  const isoIni = toIsoOrNull(dataInicio);
  const isoFim = toIsoOrNull(dataFim);
  if (isoIni) params.data_inicio = isoIni;
  if (isoFim) params.data_fim = isoFim;
  return httpService.get(`/ativo/ocorrencias/${codigoAtivo}`, { params });
};

// W-0560 — Reapresentação de Cheques Devolvidos (ADR-002 / ADR-011)
export const buscarChequesReapresentacao = (data) =>
  httpService.post('/reapresentacao-cheques/buscar', data);

export const processarChequesReapresentacao = (data) =>
  httpService.post('/reapresentacao-cheques/processar', data);

// === W-0490: Transferência de Ocorrências entre Contas (GES > Ferramentas) ===
export const listarGruposEmpresaTransferenciaOcorrencias = () =>
  httpService.get('/grupo-empresa');

export const listarContasParaTransferenciaOcorrencias = (ge) =>
  httpService.get(`/conta/por-ge/${ge}/transferencia-ocorrencias`);

export const contarOcorrenciasConta = (conta, ge) =>
  httpService.get(`/ocorrencia/conta/${conta}/ge/${ge}`);

export const transferirOcorrencias = (payload) =>
  httpService.post('/ocorrencia/transferir', payload);

// === W-0753 — Ficha de Empreendimento ===
// Acesso restrito por claim `is_adm` no JWT (ADR-001).

export const listarFichaEmpreendimento = (filtros) =>
  httpService.post('/relatorio/ficha-empreendimento/listar', filtros);

// Download blob via fetch (LICOES Ciclo 10 L2) — NUNCA via post() com 3o arg.
export const exportarFichaEmpreendimentoExcel = (filtros) =>
  httpService.fetch({
    url: '/relatorio/ficha-empreendimento/exportar',
    data: filtros,
    method: 'post',
    responseType: 'blob',
  });

// Lookup em cascata para o dropdown de Empreendimento (Família) do PainelFiltros.
// Backend deve aceitar `codigo_grupo_empresa` OU `codigo_grupo_ge` (mutuamente
// exclusivos) e responder com lista de empreendimentos elegíveis.
export const listarFamiliasFichaEmpreendimento = (filtros) =>
  httpService.post('/relatorio/ficha-empreendimento/lookup/empreendimentos', filtros);

// W-0881 — Conciliação Bancária - Geral (Generate > Retorno)
// LICOES Ciclo 10 L2: upload multipart/form-data exige httpService.fetch direto;
// httpService.post(url, data, config) passa o 3º arg como header e descarta o resto.
export const importarConciliacao = (formData) =>
  httpService.fetch({
    url: '/conciliacao-bancaria/importar',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const listarSessoesEmRevisao = (ge) =>
  httpService.get('/conciliacao-bancaria/sessoes/em-revisao', {
    params: { ge },
  });

export const listarMovimentosSessao = (codigo) =>
  httpService.get(`/conciliacao-bancaria/sessao/${codigo}/movimentos`);

export const atualizarContrapartida = (codigo, payload) =>
  httpService.post(
    `/conciliacao-bancaria/sessao/${codigo}/contrapartida`,
    payload
  );

export const marcarProcessadoConciliacao = (codigo, payload) =>
  httpService.post(
    `/conciliacao-bancaria/sessao/${codigo}/marcar-processado`,
    payload
  );

export const lancarConciliacao = (codigo) =>
  httpService.post(`/conciliacao-bancaria/sessao/${codigo}/lancar`);

export const descartarSessaoConciliacao = (codigo) =>
  httpService.post(`/conciliacao-bancaria/sessao/${codigo}/descartar`);

export const obterContasContrapartida = (ge, fornecedor) =>
  httpService.get('/conciliacao-bancaria/contas-contrapartida', {
    params: { ge, fornecedor },
  });

export const obterContasLancamento = (ge) =>
  httpService.get('/conciliacao-bancaria/contas-lancamento', {
    params: { ge },
  });

// W-0542: Contas de Intercâmbio (GES > Contas > Tabelas)
export const listarIntercambiosTabela = (params) =>
  httpService.get('/contasintercambio/listar', { params });

export const criarIntercambioTabela = (data) =>
  httpService.post('/contasintercambio/criar', data);

export const atualizarIntercambioTabela = (data) =>
  httpService.post('/contasintercambio/atualizar', data);

export const removerIntercambioTabela = (data) =>
  httpService.post('/contasintercambio/remover', data);

// W-0698 — Monitoramento de clientes (Imob/Administração)
// Backend usa snake_case na query string e no body (ver .run/MEMORY.md).
export const monitoraListar = ({
  ge,
  cliente,
  status,
  page,
  pageSize,
  sortColumn,
  sortDir,
}) =>
  httpService.fetch({
    url: '/imob/monitora/listar',
    method: 'get',
    params: {
      ge,
      cliente,
      status,
      page,
      page_size: pageSize,
      sort_column: sortColumn,
      sort_dir: sortDir,
    },
  });

export const monitoraFamilias = (ge, cliente) =>
  httpService.fetch({
    url: '/imob/monitora/familias',
    method: 'get',
    params: { ge, cliente },
  });

export const monitoraAtivos = (ge, cliente, familia, page, pageSize) =>
  httpService.fetch({
    url: '/imob/monitora/ativos',
    method: 'get',
    params: { ge, cliente, familia, page, page_size: pageSize },
  });

export const monitoraAtivosIds = (ge, cliente, familia) =>
  httpService.fetch({
    url: '/imob/monitora/ativos/ids',
    method: 'get',
    params: { ge, cliente, familia },
  });

export const monitoraClientes = (ge) =>
  httpService.fetch({
    url: '/imob/monitora/clientes',
    method: 'get',
    params: { ge },
  });

export const monitoraParamDias = () =>
  httpService.fetch({ url: '/imob/monitora/param-dias', method: 'get' });

export const monitoraAtivar = (data) =>
  httpService.post('/imob/monitora/ativar', data);

export const monitoraFinalizar = (data) =>
  httpService.post('/imob/monitora/finalizar', data);

// W-0553 — Estorno de baixa de títulos (ADR-003: POST em lote — ADR-011 sem PUT/DELETE)
export const buscarTitulosParaEstorno = (filtros) =>
  httpService.post('/titulos/estorno/buscar', filtros);

export const estornarTitulosEmLote = (payload) =>
  httpService.post('/titulos/estorno', payload);

// W-0664 — Fechamento de Caixa (GES > Ferramentas)
export const listarGruposEmpresaFechamentoCaixa = () =>
  httpService.get('/fechamento-caixa/grupos-empresa');

export const listarContasFechamentoCaixa = (ge) =>
  httpService.get(`/fechamento-caixa/contas?ge=${ge}`);

export const listarMoedasFechamentoCaixa = () =>
  httpService.get('/fechamento-caixa/moedas');

export const obterProcessoAnteriorFechamentoCaixa = (ge, conta, ativo) =>
  httpService.get(
    `/fechamento-caixa/processo-anterior?ge=${ge}&conta=${conta}&ativo=${ativo}`
  );

export const buscarFechamentoCaixa = (data) =>
  httpService.post('/fechamento-caixa/buscar', data);

export const calcularSaldoFechamentoCaixa = (data) =>
  httpService.post('/fechamento-caixa/calcular-saldo', data);

export const lancarConferenciaFechamentoCaixa = (data) =>
  httpService.post('/fechamento-caixa/lancar', data);

export const cancelarProcessoFechamentoCaixa = (data) =>
  httpService.post('/fechamento-caixa/cancelar', data);

// W-0579 — Relatório de Cheques Devolvidos (ADR-002: sem characteristic)
export const buscarGruposEmpresaChequesDevolvidos = () =>
  httpService.get('/cheques-devolvidos/grupos-empresa');

export const buscarCedentesChequesDevolvidos = (codigoGe) =>
  httpService.get(`/cheques-devolvidos/cedentes?ge=${codigoGe}`);

export const consultarChequesDevolvidos = (filtro) =>
  httpService.post('/cheques-devolvidos/consultar', filtro);

// W-0713 — Gerenciamento de E-mail
export const buscarClientesPorEmail = (email) =>
  httpService.get('/gerenciamento-email/buscar', { params: { email } });

export const bloquearAltEmail = (itens) =>
  httpService.post('/gerenciamento-email/bloquear', { itens });

export const liberarAltEmail = (itens) =>
  httpService.post('/gerenciamento-email/liberar', { itens });

// W-0872 — Relatório Remessa de Boletos
export const listarRemessaBoleto = (req) =>
  httpService.post('/relatorios/remessa-boletos/listar-boleto', req);

export const listarRemessaGrafica = (req) =>
  httpService.post('/relatorios/remessa-boletos/listar-grafica', req);

// Blob via httpService.fetch (LICOES Ciclo 10 L2 — nunca httpService.post + 3o arg)
export const exportarRemessaGraficaXlsx = (req) =>
  httpService.fetch({
    url: '/relatorios/remessa-boletos/exportar-grafica',
    method: 'post',
    data: req,
    responseType: 'blob',
  });

export const listarBancosRemessa = () =>
  httpService.post('/relatorios/remessa-boletos/listar-bancos', {});

// W-0539 — Contas Prefeitura Sem Convênio (CPSC)
// ADR-002: remoção via POST com body JSON (ADR-011 global — sem DELETE)
export const listarContasPrefeituraSemConvenio = (
  codigoGrupoEmpresa,
  codigoConta
) => {
  const params = {};
  if (codigoGrupoEmpresa != null) params.codigoGrupoEmpresa = codigoGrupoEmpresa;
  if (codigoConta != null) params.codigoConta = codigoConta;
  return httpService.get('/conta-prefeitura-sem-convenio', { params });
};

export const cadastrarContaPrefeituraSemConvenio = data =>
  httpService.post('/conta-prefeitura-sem-convenio', data);

export const removerContaPrefeituraSemConvenio = data =>
  httpService.post('/conta-prefeitura-sem-convenio/remover', data);

// W-0928 — Relatório Audit: Contas sem saldo conferido
// Pattern correto blob (LICOES Ciclo 10 L2): httpService.fetch com responseType,
// NUNCA httpService.post(url, data, { responseType: 'blob' }) — bug do W-0605.
export const gerarRelatorioContasSemSaldoConferido = filtro =>
  httpService.post(
    '/relatorios/audit/contas-sem-saldo-conferido/gerar',
    filtro
  );

export const exportarRelatorioContasSemSaldoConferidoExcel = filtro =>
  httpService.fetch({
    url: '/relatorios/audit/contas-sem-saldo-conferido/exportar-excel',
    method: 'post',
    data: filtro,
    responseType: 'blob',
  });

// W-0683 — Local de Atendimento (Imob)
// Backend usa [RoutePrefix("local-atendimento")] sem `/api/` (MEMORY.md handoff 2026-05-12).
export const listarLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/listar', request);

export const incluirLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/incluir', request);

export const atualizarLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/atualizar', request);

export const excluirLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/excluir', request);

export const listarUsuariosVinculadosLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/usuarios-vinculados', request);

export const vincularUsuarioLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/vincular-usuario', request);

export const desvincularUsuarioLocalAtendimento = (request) =>
  httpService.post('/local-atendimento/desvincular-usuario', request);

export const obterUsuariosDisponiveisLocalAtendimento = () =>
  httpService.post('/local-atendimento/usuarios-disponiveis', {});

export const obterFuncoesLocalAtendimento = () =>
  httpService.post('/local-atendimento/funcoes', {});

// W-0726 — Contas Isentas Jurídico (Imob)
export const listarContasIsentasJuridico = (codigoGe) =>
  httpService.get('/contas-isentas-juridico/listar', {
    params: { codigoGe },
  });

export const listarContasDisponiveisJuridico = (codigoGe) =>
  httpService.get('/contas-isentas-juridico/contas-disponiveis', {
    params: { codigoGe },
  });

export const incluirContaIsentaJuridico = (dados) =>
  httpService.post('/contas-isentas-juridico/incluir', dados);

export const excluirContaIsentaJuridico = (dados) =>
  httpService.post('/contas-isentas-juridico/excluir', dados);

// W-0935 — Cheques Prorrogados (módulo Auditoria)
export const obterRelatorioChequesProrrogados = (filtros) =>
  httpService.post('/audit/cheques-prorrogados/relatorio', filtros);

export const listarGrupoEmpresaChequesProrrogados = () =>
  httpService.get('/audit/cheques-prorrogados/grupos-empresa');

export const listarGrupoGEChequesProrrogados = () =>
  httpService.get('/audit/cheques-prorrogados/grupos-ge');

// ADR-002 — endpoint compartilhado por W-0930/W-0931/W-0934/W-0935
export const listarContasPorGE = (geId) =>
  httpService.get(`/contas?ge=${geId}`);

// W-0777 — Relatório Estoque Disponível Imob (Contábil)
export const estImobObterGes = () =>
  httpService.get('/relatorios/estoque-imob/ges');

export const estImobObterGruposGe = () =>
  httpService.get('/relatorios/estoque-imob/grupos-ge');

export const estImobObterEmpresas = (filtro) =>
  httpService.post('/relatorios/estoque-imob/empresas', filtro);

export const estImobObterEmpreendimentos = (filtro) =>
  httpService.post('/relatorios/estoque-imob/empreendimentos', filtro);

export const estImobConsultar = (filtros) =>
  httpService.post('/relatorios/estoque-imob/consultar', filtros);

// Blob via httpService.fetch (LICOES Ciclo 10 L2 — nunca httpService.post + 3o arg)
export const estImobExportarExcel = (filtros) =>
  httpService.fetch({
    url: '/relatorios/estoque-imob/exportar-excel',
    method: 'post',
    data: filtros,
    responseType: 'blob',
  });

// W-0858 — Relacionamento de Contas (Generate > Manutenção)
export const listarGesParaVinculo = () =>
  httpService.get('/bancos-vinculos/listar-ges');

export const listarContasPorGe = (ge, bancoFiltro = null, excluirGePrincipal = null) => {
  const params = { ge };
  if (bancoFiltro != null) params.banco_filtro = bancoFiltro;
  if (excluirGePrincipal != null) params.excluir_ge_principal = excluirGePrincipal;
  return httpService.get('/bancos-vinculos/listar-contas', { params });
};

export const listarVinculos = (gePrincipal, contaPrincipal) =>
  httpService.get('/bancos-vinculos/listar', {
    params: { ge_principal: gePrincipal, conta_principal: contaPrincipal },
  });

export const incluirVinculo = (data) =>
  httpService.post('/bancos-vinculos/incluir', data);

export const excluirVinculo = (data) =>
  httpService.post('/bancos-vinculos/excluir', data);

// W-0540 — Saldos de Contas (GES > Contas > Saldos de Contas)
export const listarGruposEmpresaSaldosContas = () =>
  httpService.get('/ges/saldos-contas/grupos-empresa');

export const listarContasSaldosContas = (codigoGrupoEmpresa) =>
  httpService.get(`/ges/saldos-contas/contas/${codigoGrupoEmpresa}`);

export const listarSaldosContas = (filtros) =>
  httpService.post('/ges/saldos-contas/listar', filtros);

export const conferirSaldoConta = (payload) =>
  httpService.post('/ges/saldos-contas/conferir', payload);

// Padrão ExportadorController: rota /exportador/excel/* + responseType blob (LICOES Ciclo 10 L2).
export const exportarSaldosContasExcel = (filtros) =>
  httpService.fetch({
    url: '/exportador/excel/saldos-contas',
    method: 'post',
    data: filtros,
    responseType: 'blob',
  });

export const inspecionarPlanilhaComunicado = (file) => {
  const form = new FormData();
  form.append('arquivo', file);
  return httpService.fetch({
    url: '/usuario/comunicado/inspecionar-planilha',
    data: form,
    method: 'post',
  });
};

export const enviarComunicadoTeste = (file, assunto, corpoHtml) => {
  const form = new FormData();
  form.append('arquivo', file);
  form.append('assunto', assunto);
  form.append('corpo_html', corpoHtml);
  return httpService.fetch({
    url: '/usuario/comunicado/enviar-teste',
    data: form,
    method: 'post',
  });
};

export const enviarComunicadoEmMassa = (file, assunto, corpoHtml) => {
  const form = new FormData();
  form.append('arquivo', file);
  form.append('assunto', assunto);
  form.append('corpo_html', corpoHtml);
  return httpService.fetch({
    url: '/usuario/comunicado/enviar',
    data: form,
    method: 'post',
  });
};

// DW-0996 — Sistema RSVP Eventos (Admin CRM)
// ADR-002: JWT do CRM (Authorization: Bearer), não token público
export const listarEventosRsvp = () =>
  httpService.get('/evento-rsvp/admin/listar');

export const obterEventoRsvp = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}`);

export const salvarEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/salvar', payload);

export const ativarEventoRsvp = (id, ativar) =>
  httpService.post(`/evento-rsvp/admin/${id}/ativar`, { ativar });

// Relatórios — modal com 2 abas (Confirmados+expand inline / Pendentes lazy)
export const obterContagensEventoRsvp = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/contagens`);

export const listarConfirmadosEventoRsvp = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/confirmados`);

export const obterDetalhesConfirmacaoEventoRsvp = (codigoConfirmacao) =>
  httpService.get(`/evento-rsvp/admin/confirmacao/${codigoConfirmacao}/detalhes`);

export const listarPendentesEventoRsvp = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/pendentes`);

// DW-0998 — Comparecimento (presença efetiva). Uma linha por confirmação com
// total_esperado/total_presentes; o front separa em compareceram x não compareceram.
export const listarComparecimentoEventoRsvp = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/comparecimento`);

export const exportarConfirmadosEventoRsvpExcel = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/exportar-confirmados-excel`, {
    responseType: 'blob',
  });

export const exportarPendentesEventoRsvpExcel = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/exportar-pendentes-excel`, {
    responseType: 'blob',
  });

// DW-0998 — Excel das guias de comparecimento (presença efetiva na portaria).
export const exportarCompareceramEventoRsvpExcel = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/exportar-compareceram-excel`, {
    responseType: 'blob',
  });

export const exportarNaoCompareceramEventoRsvpExcel = (id) =>
  httpService.get(`/evento-rsvp/admin/${id}/exportar-nao-compareceram-excel`, {
    responseType: 'blob',
  });

// DW-0998 — Check-in de Evento (portaria/recepção). Reusa caract. 671.
// Contrato snake_case. tipo = 'cpf' | 'nome' | 'telefone' | 'prospecto'.
export const buscarCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/buscar', payload);

export const marcarPresencaCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/marcar-presenca', payload);

export const marcarAcompanhanteCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/marcar-acompanhante', payload);

export const adicionarAcompanhanteCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/acompanhante', payload);

// Confirma um pendente (elegível por contrato) e abre o painel de presença.
// payload: { cpf }
export const confirmarPendenteCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/confirmar-pendente', payload);

// Insere um prospecto no evento como confirmado + presença marcada.
// payload: { codigo_prospecto }
export const registrarProspectoCheckinEventoRsvp = (payload) =>
  httpService.post('/evento-rsvp/admin/checkin/registrar-prospecto', payload);

// DW-0998 — Pesquisas Entrada/Saída do Evento SetGarden (tela interna do atendente).
// Contrato snake_case. Prefixo /evento-pesquisa/. tipo pendentes/exportar = 'A' (Ambos) | 'E' (Entrada) | 'S' (Saída).
// Perguntas/respostas continuam usando somente 'E' (Entrada) | 'S' (Saída).
// Excel: usar salvarEmExcel('/evento-pesquisa/exportar?tipo=...') de ~/Utils/Helpers.js.
export const obterPerguntasPesquisaEvento = (tipo) =>
  httpService.get(`/evento-pesquisa/perguntas?tipo=${tipo}`);

export const buscarPessoasPesquisaEvento = (payload) =>
  httpService.post('/evento-pesquisa/buscar', payload);

export const listarPendentesPesquisaEvento = (tipo) =>
  httpService.get(`/evento-pesquisa/pendentes?tipo=${tipo}`);

export const responderPesquisaEvento = (payload) =>
  httpService.post('/evento-pesquisa/responder', payload);

// W-0371 - Solicitacoes Juridicas
export const listarSolicitacoesJuridicas = params =>
  httpService.get('/solicitacao-juridica/listar', { params });

export const buscarSolicitacaoJuridica = codigo =>
  httpService.get(`/solicitacao-juridica/${codigo}`);

export const criarSolicitacaoJuridica = data =>
  httpService.post('/solicitacao-juridica/criar', data);

export const alterarStatusSolicitacaoJuridica = (codigo, data) =>
  httpService.post(`/solicitacao-juridica/${codigo}/status`, data);

export const listarResponsaveisSolicitacaoJuridica = departamento =>
  httpService.get('/solicitacao-juridica/responsaveis', {
    params: { departamento },
  });

export const listarHistoricoSolicitacaoJuridica = codigo =>
  httpService.get(`/solicitacao-juridica/${codigo}/historico`);

export const criarOcorrenciaSolicitacaoJuridica = (codigo, data) =>
  httpService.post(`/solicitacao-juridica/${codigo}/historico`, data);

export const uploadAnexoSolicitacaoJuridica = (codigo, data) =>
  httpService.fetch({
    url: `/solicitacao-juridica/${codigo}/anexo`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const downloadAnexoSolicitacaoJuridica = (codigo, seq) =>
  httpService.get(`/solicitacao-juridica/${codigo}/anexo/${seq}`, {
    responseType: 'blob',
  });

export const removerAnexoSolicitacaoJuridica = (codigo, seq) =>
  httpService.post(`/solicitacao-juridica/${codigo}/anexo/${seq}/remover`);

export const buscarLookupsSolicitacaoJuridica = () =>
  httpService.get('/solicitacao-juridica/lookups');

export const listarRazoesSolicitacaoJuridica = codigo_ge =>
  httpService.get('/solicitacao-juridica/lookups/razoes', {
    params: { codigo_ge },
  });

export const listarClientesSolicitacaoJuridica = codigo_ge =>
  httpService.get('/solicitacao-juridica/lookups/clientes', {
    params: { codigo_ge },
  });

export const listarEmpreendimentosSolicitacaoJuridica = codigo_ge =>
  httpService.get('/solicitacao-juridica/lookups/empreendimentos', {
    params: { codigo_ge },
  });

export const listarConfiguracaoAssuntosJuridicos = params =>
  httpService.get('/solicitacao-juridica/config/assuntos', { params });

export const salvarConfiguracaoAssuntoJuridico = data =>
  httpService.post('/solicitacao-juridica/config/assuntos/salvar', data);

export const removerConfiguracaoAssuntoJuridico = data =>
  httpService.post('/solicitacao-juridica/config/assuntos/remover', data);

export const listarDepartamentosConfigJuridica = params =>
  httpService.get('/solicitacao-juridica/config/departamentos', { params });

export const salvarUsuarioDepartamentoJuridica = data =>
  httpService.post('/solicitacao-juridica/config/departamentos/salvar', data);

export const removerUsuarioDepartamentoJuridica = data =>
  httpService.post('/solicitacao-juridica/config/departamentos/remover', data);

export const buscarParametrosSolicitacaoJuridica = () =>
  httpService.get('/solicitacao-juridica/config/parametros');

export const salvarParametrosSolicitacaoJuridica = data =>
  httpService.post('/solicitacao-juridica/config/parametros/salvar', data);

export const buscarHistoricoConfigSolicitacaoJuridica = () =>
  httpService.get('/solicitacao-juridica/config/historico');
// W-0496: Remanejamento de Caixas
export const listarUsuariosOrigemRemanejamento = () =>
  httpService.get('/remanejamento-caixa/usuarios-origem');

export const listarUsuariosDestinoRemanejamento = () =>
  httpService.get('/remanejamento-caixa/usuarios-destino');

export const listarItensRemanejamento = (codigoUsuarioOrigem) =>
  httpService.get('/remanejamento-caixa/itens?codigoUsuarioOrigem=' + codigoUsuarioOrigem);

export const remanejarCaixa = (dados) =>
  httpService.post('/remanejamento-caixa/remanejar', dados);

// W-0497: Cobrança SMS
export const pesquisarCobrancaSms = (body) =>
  httpService.post('/cobranca-sms/pesquisar', body);

export const enviarCobrancaSms = (body) =>
  httpService.post('/cobranca-sms/enviar', body);

export const listarMensagensCobrancaSms = (tipo) =>
  httpService.get(`/cobranca-sms/mensagens?tipo=${tipo}`);

export const salvarMensagemCobrancaSms = (body) =>
  httpService.post('/cobranca-sms/mensagens/salvar', body);

export const excluirMensagemCobrancaSms = ({ de, ate, tipo }) =>
  httpService.post('/cobranca-sms/mensagens/excluir', { de, ate, tipo });

export const listarEmpreendimentosCobrancaSms = () =>
  httpService.get('/cobranca-sms/empreendimentos');

export const listarCobradoresCobrancaSms = () =>
  httpService.get('/cobranca-sms/cobradores');

export const listarGesUsuarioCobrancaSms = () =>
  httpService.get('/cobranca-sms/ges-usuario');

export const listarClientesCobrancaSms = (codigoGrupoEmpresa) =>
  httpService.get(`/cobranca-sms/clientes?codigoGrupoEmpresa=${codigoGrupoEmpresa}`);

// W-0937 — Histórico de Imóveis (módulo Auditoria).
// Controller RoutePrefix SEM 'api/' (APIBASE já inclui 'api/'). Char 100 (Auditoria) no servidor.
// ⚠️ Consulta é GET com [FromUri] => os nomes da query string DEVEM ser camelCase EXATAMENTE
//    como a action do backend (codigoGrupoEmpresa, codigoGrupoGE, status, fasesContrato, ...).
//    status e fasesContrato são CSV (ex.: status=D,A,V / fasesContrato=1,2,3).
const BASE_HISTORICO_IMOVEIS = '/relatorios/audit/historico-imoveis';

const montarQueryHistoricoImoveis = (filtros) => {
  const partes = [];

  if (
    filtros.codigoGrupoEmpresa !== null &&
    filtros.codigoGrupoEmpresa !== undefined &&
    filtros.codigoGrupoEmpresa !== ''
  ) {
    partes.push(
      `codigoGrupoEmpresa=${encodeURIComponent(filtros.codigoGrupoEmpresa)}`
    );
  }
  if (
    filtros.codigoGrupoGE !== null &&
    filtros.codigoGrupoGE !== undefined &&
    filtros.codigoGrupoGE !== ''
  ) {
    partes.push(`codigoGrupoGE=${encodeURIComponent(filtros.codigoGrupoGE)}`);
  }
  if (
    filtros.codigoFamilia !== null &&
    filtros.codigoFamilia !== undefined &&
    filtros.codigoFamilia !== ''
  ) {
    partes.push(`codigoFamilia=${encodeURIComponent(filtros.codigoFamilia)}`);
  }

  // Status: CSV de letras (A/R/V/B/P/D/O).
  const statusCsv =
    filtros.status && filtros.status.length ? filtros.status.join(',') : '';
  partes.push(`status=${encodeURIComponent(statusCsv)}`);

  partes.push(`tipoPagamento=${encodeURIComponent(filtros.tipoPagamento)}`);

  // Fases de contrato: CSV de números (1..12).
  const fasesCsv =
    filtros.fasesContrato && filtros.fasesContrato.length
      ? filtros.fasesContrato.join(',')
      : '';
  partes.push(`fasesContrato=${encodeURIComponent(fasesCsv)}`);

  partes.push(
    `historicoCorrecoes=${filtros.historicoCorrecoes ? 'true' : 'false'}`
  );
  partes.push(
    `historicoMovimento=${filtros.historicoMovimento ? 'true' : 'false'}`
  );

  return partes.join('&');
};

export const consultarHistoricoImoveis = (filtros) =>
  httpService.get(
    `${BASE_HISTORICO_IMOVEIS}?${montarQueryHistoricoImoveis(filtros)}`
  );

export const listarGruposEmpresaHistoricoImoveis = () =>
  httpService.get(`${BASE_HISTORICO_IMOVEIS}/grupos-empresa`);

export const listarGruposGEHistoricoImoveis = () =>
  httpService.get(`${BASE_HISTORICO_IMOVEIS}/grupos-ge`);

export const listarEmpreendimentosHistoricoImoveis = (
  codigoGrupoEmpresa,
  codigoGrupoGE
) => {
  const partes = [];
  if (
    codigoGrupoEmpresa !== null &&
    codigoGrupoEmpresa !== undefined &&
    codigoGrupoEmpresa !== ''
  ) {
    partes.push(`codigoGrupoEmpresa=${encodeURIComponent(codigoGrupoEmpresa)}`);
  }
  if (
    codigoGrupoGE !== null &&
    codigoGrupoGE !== undefined &&
    codigoGrupoGE !== ''
  ) {
    partes.push(`codigoGrupoGE=${encodeURIComponent(codigoGrupoGE)}`);
  }
  const query = partes.length ? `?${partes.join('&')}` : '';
  return httpService.get(`${BASE_HISTORICO_IMOVEIS}/empreendimentos${query}`);
};

export const listarCorrecoesHistoricoImoveis = (boleto) =>
  httpService.get(`${BASE_HISTORICO_IMOVEIS}/correcoes?boleto=${encodeURIComponent(boleto)}`);

// W-0502: Validador Assinatura Digital
export const listarValidadorUsuariosElegiveis = () =>
  httpService.get('/validador-assinatura-digital/usuarios-elegiveis');

export const listarValidadorHistorico = (tipo) =>
  httpService.get(`/validador-assinatura-digital/historico?tipo=${tipo}`);

export const ativarValidadorAssinaturaDigital = (codigoUsuario, tipo) =>
  httpService.post('/validador-assinatura-digital/ativar', {
    codigo_usuario: codigoUsuario,
    tipo,
  });

// W-0527 — Cadastro de Cartão de Crédito
export const listarCartoesCreditos = () =>
  httpService.get('/cartao-credito/listar');

export const listarGruposEmpresaDeCartao = () =>
  httpService.get('/cartao-credito/grupos-empresa');

export const listarBandeirasCartao = () =>
  httpService.get('/cartao-credito/bandeiras');

export const incluirCartaoCredito = data =>
  httpService.post('/cartao-credito/incluir', data);

export const alterarCartaoCredito = data =>
  httpService.post('/cartao-credito/alterar', data);

export const excluirCartaoCredito = codigo =>
  httpService.post('/cartao-credito/excluir', { codigo });

// W-0531 — Solicita Reembolso Clientes (IPTU)
export const listarTiposReembolso = () =>
  httpService.get('/imob/reembolso-iptu/lookup/tipos-reembolso');

export const buscarImoveisReembolsoIptu = (data) =>
  httpService.post('/imob/reembolso-iptu/buscar-imoveis', data);

export const lancarReembolsoIptu = (data) =>
  httpService.post('/imob/reembolso-iptu/lancar', data);

export const importarExcelReembolsoIptu = (formData) =>
  httpService.post('/imob/reembolso-iptu/importar-excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const verificarChavesReembolsoIptu = (data) =>
  httpService.post('/imob/reembolso-iptu/verificar-chaves', data);

// W-0533 — Manutenção de Títulos
export const buscarTitulosManutencao = (filtro) =>
  httpService.get(`/rastreamento-titulos/buscar`, { params: filtro });

export const obterDetalheTituloManutencao = (cod) =>
  httpService.get(`/rastreamento-titulos/${cod}`);

export const listarGruposEmpresaManutencao = () =>
  httpService.get(`/manutencao-titulos/grupos-empresa`);

export const listarJustificativasManutencao = () =>
  httpService.get(`/manutencao-titulos/justificativas`);

export const obterContextoManutencao = (cod) =>
  httpService.get(`/manutencao-titulos/${cod}/contexto`);

export const simularManutencaoTitulo = (data) =>
  httpService.post(`/manutencao-titulos/simular`, data);

export const processarManutencaoTitulo = (data) =>
  httpService.post(`/manutencao-titulos/processar`, data);

// LICOES Ciclo 10 L2: responseType na config do fetch, nunca 3º arg de post.
export const imprimirChequeManutencao = (cod) =>
  httpService.fetch({
    url: `/manutencao-titulos/${cod}/imprimir-cheque`,
    method: 'get',
    responseType: 'blob',
  });

// W-0537 — Atualiza vencimento de títulos
export const buscarPropostaTitulosAtualizaVenc = (data) =>
  httpService.post('/atualizar-vencimento-titulo/buscar', data);

export const simularNovaDataAtualizaVenc = (data) =>
  httpService.post('/atualizar-vencimento-titulo/simular', data);

export const lancarAtualizacaoVencimentoTitulos = (data) =>
  httpService.post('/atualizar-vencimento-titulo/lancar', data);

// W-0543: Contas de Difícil Liquidação
export const listarContasDisponiveisDifLiq = (params) =>
  httpService.get('/contas-dif-liq/disponiveis', { params });
export const listarGruposEmpresaDifLiq = () =>
  httpService.get('/contas-dif-liq/grupos-empresa');
export const listarContasDifLiq = (params) =>
  httpService.get('/contas-dif-liq/listar', { params });
export const listarFamiliasAtivasDifLiq = (codigoGrupoEmpresa) =>
  httpService.get('/contas-dif-liq/familias-ativas', { params: { codigoGrupoEmpresa } });
export const incluirContasDifLiq = (data) =>
  httpService.post('/contas-dif-liq/incluir', data);
export const editarDeflacaoDifLiq = (conta, data) =>
  httpService.post(`/contas-dif-liq/${conta}/editar`, data);
export const removerContaDifLiq = (conta, data) =>
  httpService.post(`/contas-dif-liq/${conta}/remover`, data);
export const copiarContasDifLiq = (data) =>
  httpService.post('/contas-dif-liq/copiar', data);

// === W-0547: Importação XLS de Contas ===

export const processarPlanilhaContas = (formData) =>
  httpService.post('/importacao-xls-contas/processar', formData);

export const gravarImportacaoContas = (request) =>
  httpService.post('/importacao-xls-contas/gravar', request);

export const listarEmpreendimentosImportacaoContas = (ge) =>
  httpService.get(`/importacao-xls-contas/empreendimentos?ge=${ge}`);

export const listarGruposEmpresaImportacaoContas = () =>
  httpService.get('/importacao-xls-contas/grupos-empresa');

// W-0554 — Correção de Títulos a Pagar
export const simularCorrecaoTitulos = (codigoGrupoEmpresa, codigoConta, codigoMoedaForte) =>
  httpService.get('/correcao-titulos/simular', {
    params: { codigoGrupoEmpresa, codigoConta, codigoMoedaForte },
  });

export const efetivarCorrecaoTitulos = (payload) =>
  httpService.post('/correcao-titulos/efetivar', payload);

export const listarMoedasFortes = () =>
  httpService.get('/correcao-titulos/moedas-fortes');

// W-0569 — Lançamento de Compra de Imobilizado
export const lancarCompraImobilizado = (payload) =>
  httpService.post('/imobilizado-lancamento/lancar', payload);

// Replica carga de `cdge` do Delphi UImobilizado.pas:627-633 — filtrado por
// usuario_grupo_empresa (usuário logado) + Param_Grupo_Empresa.
export const listarGruposEmpresaImobilizado = () =>
  httpService.get('/imobilizado-lancamento/grupos-empresa');

export const listarContasImobilizado = (codigoGrupoEmpresa) =>
  httpService.get(`/conta/listar-imobilizado?codigoGrupoEmpresa=${codigoGrupoEmpresa}`);

export const listarMoedas = () =>
  httpService.get('/ativo/listar-moedas');

export const listarFornecedoresImobilizado = (codigoGrupoEmpresa) =>
  httpService.get(`/cadastro-unico-fornecedor/listar?codigoGrupoEmpresa=${codigoGrupoEmpresa}`);

export const listarAtivosImobilizadoLookup = () =>
  httpService.post('/ativo/listar', { tipo: 1, tamanho_pagina: 9999 });

// W-0574: Aprovação de Chaves de Pagamento
export const listarPagamentosPendentes = (params) =>
  httpService.get('/ges/pagamentos/pendentes', { params });

export const obterDetalhesPagamento = (id) =>
  httpService.get(`/ges/pagamentos/${id}/detalhes`);

export const listarOcorrenciasPagamento = (id, tipo) =>
  httpService.get(`/ges/pagamentos/${id}/ocorrencias`, { params: { tipo: tipo || 'DP' } });

export const aprovarPagamentosLote = (dados) =>
  httpService.post('/ges/pagamentos/aprovar', dados);

export const recusarPagamentosLote = (dados) =>
  httpService.post('/ges/pagamentos/recusar', dados);

export const listarAnexosPagamento = (id, tipo) =>
  httpService.get(`/ges/pagamentos/${id}/anexos`, { params: { tipo: tipo || 'DP' } });

export const baixarAnexoPagamento = (id, numero, tipo) =>
  httpService.get(`/ges/pagamentos/${id}/anexos/${numero}/download`, {
    params: { tipo: tipo || 'DP' },
    responseType: 'blob',
  });

export const listarHistoricoFornecedorMes = (id, mes, ano) =>
  httpService.get(`/ges/pagamentos/${id}/historico-fornecedor`, {
    params: {
      mes: mes != null ? mes : undefined,
      ano: ano != null ? ano : undefined,
    },
  });

// W-0611 — Saldo de Conta Banco
export const listarGEsSaldoBanco = () =>
  httpService.get('/saldo-banco/grupos-empresa');

export const listarContasSaldoBanco = (codigoGrupoEmpresa) =>
  httpService.get('/saldo-banco/contas', {
    params: { codigoGrupoEmpresa },
  });

export const listarMoedasSaldoBanco = () =>
  httpService.get('/saldo-banco/moedas');

export const obterCotacoesAtual = (ativos) =>
  httpService.get('/saldo-banco/cotacoes-atual', {
    params: { ativos: ativos.join(',') },
  });

export const consultarSaldosBanco = (data) =>
  httpService.post('/saldo-banco/saldos', data);

export const consultarExtratoCaixa = (data) =>
  httpService.post('/saldo-banco/extrato-caixa', data);

// W-0744: Relatório Débitos Municipais
export const listarGesDebMunicipais = () =>
  httpService.get('/imob/rel-debitos-municipais/ges');

export const listarFamiliasDebMunicipais = () =>
  httpService.get('/imob/rel-debitos-municipais/familias');

export const exportarDebMunicipais = filtro => {
  const token = LocalStorage.get(constants.AUTH_KEY)
    ? `Bearer ${LocalStorage.get(constants.AUTH_KEY)}`
    : null;
  return axios.post(
    `${constants.APIBASE}/imob/rel-debitos-municipais/exportar`,
    filtro,
    {
      headers: { 'Content-Type': 'application/json', Authorization: token },
      responseType: 'blob',
    }
  );
};

// === W-0516 — Alertas de Clientes ===

export const listarAlertasCliente = (params) =>
  httpService.get('/alerta-cliente/listar', { params });

export const criarAlertaCliente = (body) =>
  httpService.post('/alerta-cliente/criar', body);

// W-0584 — Relatório Ativo por Família (GES). Body: { familias:[int], status:"0"|"1"|null,
//   saldo:"COM"|"SEM"|null, ges:[int]? } -> [{ codigo_familia, codigo_ativo, nome, unidade,
//   custo_medio, preco_base, preco_padrao, nome_da_familia }]. Read-only, [AuthorizeUser] sem char.
export const listarAtivoFamilia = filtro =>
  httpService.post('/relatorios/ativo-familia/listar', filtro);

// --- W-0697: Imóveis Alugados (Imob > Administração) — read-only ---
// Fonte: ERP/ModuloImob/UImovAlugado.pas. Export Excel é client-side (CSV via Helpers).
export const buscarEmpreendimentosImoveisAlugados = () =>
  httpService.get('/imoveis-alugados/empreendimentos');

export const listarImoveisAlugados = codigoFamilia =>
  httpService.get('/imoveis-alugados/listar', { params: { codigoFamilia } });

// --- W-0775: Baixa de Título (Imob > Relatórios > Contábil) — read-only ---
// Fonte: ERP/ModuloImob/URelBaixa.pas + UQRBaixa.pas. Export Excel é client-side (CSV via Helpers).
export const buscarBaixaTituloFamilias = () =>
  httpService.get('/relatorios/contabil/baixa-titulo/familias');

export const buscarBaixaTituloRazoesSociais = () =>
  httpService.get('/relatorios/contabil/baixa-titulo/razoes-sociais');

export const buscarBaixaTitulo = params =>
  httpService.get('/relatorios/contabil/baixa-titulo', { params });

// --- W-0817: Conciliação dos Recebimentos (Imob > Relatórios > Cobrança) — read-only ---
// Fonte: ERP/Reports/Imob/Graficos/ConcRecebimento.rdl + ModuloImob/UConcRecebimento.pas (launcher).
// Export Excel é client-side (CSV via Helpers).
export const buscarConciliacaoRecebimentosUsuarios = () =>
  httpService.get('/relatorios/cobranca/conciliacao-recebimentos/usuarios');

export const buscarConciliacaoRecebimentos = params =>
  httpService.get('/relatorios/cobranca/conciliacao-recebimentos', { params });

// --- W-0883: Protocolo de Remessas (Generate > Consulta, read-only) ---
// Lookup de razões credenciadas (codigoscpc não nulo OU manda_serasa='S').
export const buscarRazoesProtocoloRemessas = () =>
  httpService.get('/protocolo-remessas/razoes');

// Q2 UNION SCPC/SERASA. Body:
//   { orgao:"SCPC"|"SERASA"|"AMBOS", status_retorno:"RETORNADOS"|"NAO_RETORNADOS"|"AMBOS",
//     mostrar_excluidas:bool, codigo_razao:int?, cnpj_razao:long? }
export const consultarProtocoloRemessas = data =>
  httpService.post('/protocolo-remessas/consultar', data);

// Export Excel do grid (mesmos filtros de /consultar). Blob via fetch+responseType
// (LICOES Ciclo 10 L2: NUNCA httpService.post + 3º arg para binário).
export const exportarProtocoloRemessas = data =>
  httpService.fetch({
    url: '/protocolo-remessas/exportar',
    method: 'post',
    data,
    responseType: 'blob',
  });

// W-0534: Cadastro de Alíneas
export const Alinea = {
  listar: (filtros) => httpService.post('/alinea/listar', filtros),
  proximoCodigo: () => httpService.get('/alinea/proximo-codigo'),
  inserir: (data) => httpService.post('/alinea/inserir', data),
  editar: (data) => httpService.post('/alinea/editar', data),
  excluir: (codigoAlinea) => httpService.post('/alinea/excluir', { codigo_alinea: codigoAlinea }),
};

// W-0484: Consulta CPF
export const consultaCPFLotes = (cpf) =>
  httpService.get(`/consulta-cpf/lotes?cpf=${encodeURIComponent(cpf)}`);

export const consultaCPFFinanceiro = (boletos) =>
  httpService.get(`/consulta-cpf/financeiro?boletos=${encodeURIComponent(boletos)}`);

export const consultaCPFCobranca = (boletos) =>
  httpService.get(`/consulta-cpf/cobranca?boletos=${encodeURIComponent(boletos)}`);

export const consultaCPFAlertas = (boletos) =>
  httpService.get(`/consulta-cpf/alertas?boletos=${encodeURIComponent(boletos)}`);

export const consultaCPFSocios = (boletos) =>
  httpService.get(`/consulta-cpf/socios?boletos=${encodeURIComponent(boletos)}`);

export const consultaCPFOutrosTitulos = (cpf) =>
  httpService.get(`/consulta-cpf/outros-titulos?cpf=${encodeURIComponent(cpf)}`);

export const consultaCPFNegativacaoStatus = (cpf) =>
  httpService.get(`/consulta-cpf/negativacao-status?cpf=${encodeURIComponent(cpf)}`);

export const consultaCPFNegativacaoHistorico = (cpf) =>
  httpService.get(`/consulta-cpf/negativacao/historico?cpf=${encodeURIComponent(cpf)}`);

export const consultaCPFNegativacaoIncluir = (data) =>
  httpService.post('/consulta-cpf/negativacao/incluir', data);

export const checaCgcCpf = () =>
  httpService.get('/parametros/checa-cgccpf');

// W-0477 — Comissão Retida
export const consultarComissaoRetida = (params) =>
  httpService.get('/comissao-retida', { params });

export const consultarVendasPendentesComissao = (ge) =>
  httpService.get('/comissao-retida/vendas-pendentes', { params: { ge } });

export const consultarPendenciasPrevenda = (prevenda) =>
  httpService.get(`/comissao-retida/pendencias/${prevenda}`);

export const liberarComissaoRetida = (dados) =>
  httpService.post('/comissao-retida/liberar', dados);

export const consultarClientesIncorporadores = (ge) =>
  httpService.get('/comissao-retida/filtros/clientes-incorporadores', { params: { ge } });

export const consultarEmpreendimentosComissao = (ge, conta) =>
  httpService.get('/comissao-retida/filtros/empreendimentos', { params: { ge, conta } });

// W-0526 — Autoriza Despesa/Projetos
export const listarAutorizaDespesa = (filtros, paginacao) =>
  httpService.post(
    '/chaves/autoriza-despesa/listar',
    construirPayloadListar(filtros, paginacao)
  );

export const listarGruposEmpresaAutorizaDespesa = () =>
  httpService.get('/chaves/autoriza-despesa/lookups/grupos-empresa');

export const listarContasAutorizaDespesa = (codigoGrupoEmpresa, filtro = '') =>
  httpService.post('/chaves/autoriza-despesa/lookups/contas', {
    codigo_grupo_empresa: codigoGrupoEmpresa,
    filtro,
  });

export const listarDepartamentosAutorizaDespesa = () =>
  httpService.get('/chaves/autoriza-despesa/lookups/departamentos');

export const buscarUsuariosAutorizaDespesa = (filtro = '', tamanhoPagina = 20, pagina = 1) =>
  httpService.post('/chaves/autoriza-despesa/lookups/usuarios', {
    termo: filtro,
    page_size: tamanhoPagina,
    page_number: pagina,
  });

export const aprovarAutorizaDespesa = (sequencias) =>
  httpService.post('/chaves/autoriza-despesa/aprovar', { sequencias });

export const estornarAprovacaoAutorizaDespesa = (sequencia, motivo = null) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/estornar`, { motivo });

export const cancelarLancamentoAutorizaDespesa = (sequencia, motivo = null) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/cancelar`, { motivo });

export const verificarPagamentoAutorizaDespesa = (sequencia) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/verificar`, {});

export const devolverAoDigitadorAutorizaDespesa = (sequencia) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/devolver`, {});

export const alterarVencimentoAutorizaDespesa = (sequencia, novoVencimento, motivo = null) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/alterar-vencimento`, {
    novo_vencimento: novoVencimento,
    motivo,
  });

export const obterRateiosAutorizaDespesa = (sequencia) =>
  httpService.get(`/chaves/autoriza-despesa/${sequencia}/rateios`);

export const obterSituacaoPagForAutorizaDespesa = (sequencia) =>
  httpService.get(`/chaves/autoriza-despesa/${sequencia}/situacao-pagfor`);

export const gravarOcorrenciaAutorizaDespesa = (sequencia, titulo, texto, tp) =>
  httpService.post(`/chaves/autoriza-despesa/${sequencia}/ocorrencias`, {
    titulo,
    texto,
    tp,
  });

export const obterImpostoDCTFAutorizaDespesa = (sequencia) =>
  httpService.get(`/chaves/autoriza-despesa/${sequencia}/imposto-dctf`);

export const obterImpostoRetidoAutorizaDespesa = (sequencia) =>
  httpService.get(`/chaves/autoriza-despesa/${sequencia}/impostos-retidos`);

export const validarSenhaUsuario = (senha) =>
  httpService.post('/usuario/validar-senha', { senha });

// W-0750 — Etiquetas Imóveis (Imob > Relatórios > Administração) — read-only.
// Fonte: ERP/ModuloImob/UEtqImoveis.pas. Export Excel é client-side (CSV via Helpers).
// ⚠️ [FromUri] vincula por NOME da action (camelCase): mandar `codigoFamilia`/`apenasDisponiveis`
// no querystring. snake_case não vincula → 400/404 (W-0488/0595). Sem `api/` (APIBASE é a raiz).
export const buscarEmpreendimentosEtiquetasImoveis = () =>
  httpService.get('/relatorios/administracao/etiquetas-imoveis/empreendimentos');

export const listarEtiquetasImoveis = (codigoFamilia, apenasDisponiveis) =>
  httpService.get(
    `/relatorios/administracao/etiquetas-imoveis?codigoFamilia=${codigoFamilia}&apenasDisponiveis=${apenasDisponiveis}`
  );

// W-0763 — Proposta Rápida (Relatórios > Comercial). RoutePrefix sem `api/`.
// Combos: GET com querystring camelCase `codigoGrupoEmpresa` ([FromUri] binda por nome).
// Consulta: POST com body JSON snake_case (SnakeCaseNamingStrategy global).
export const listarGruposEmpresaPropostaRapida = () =>
  httpService.get('/relatorios/comercial/proposta-rapida/grupos-empresa');

export const listarEmpreendimentosPropostaRapida = (codigoGrupoEmpresa) =>
  httpService.get('/relatorios/comercial/proposta-rapida/empreendimentos', {
    params: { codigoGrupoEmpresa },
  });

export const listarCidadesPropostaRapida = (codigoGrupoEmpresa) =>
  httpService.get('/relatorios/comercial/proposta-rapida/cidades', {
    params: { codigoGrupoEmpresa },
  });

export const listarCorretoresPropostaRapida = (codigoGrupoEmpresa) =>
  httpService.get('/relatorios/comercial/proposta-rapida/corretores', {
    params: { codigoGrupoEmpresa },
  });

export const consultarPropostaRapida = (body) =>
  httpService.post('/relatorios/comercial/proposta-rapida', body);

// W-0797 — Posição Cobrança (Imob > Cobrança). RoutePrefix sem `api/`.
// Combos: GET sem parâmetros (servidor deriva sojuris/pezao do JWT).
// Consulta: POST com body JSON snake_case (SnakeCaseNamingStrategy global).
export const listarGruposEmpresaPosicaoCobranca = () =>
  httpService.get('/imob/cobranca/posicao/grupos-empresa');

export const listarCobradoresPosicaoCobranca = () =>
  httpService.get('/imob/cobranca/posicao/cobradores');

export const consultarPosicaoCobranca = (body) =>
  httpService.post('/imob/cobranca/posicao', body);

// === W-0805 — Re-Financiamentos em Inadimplência (Cobrança/Imob) ===
// Backend: RoutePrefix relatorios/cobranca/refinanciamentos-inadimplencia (SEM api/).
// [FromUri] vincula por nome camelCase — snake_case é silenciosamente ignorado (bug
// sistêmico). Os enums tipoTitulo/foco/modo são 0 por default e PRECISAM ir no query
// string; serialize() de Helpers descarta falsy, então a query é montada manualmente.
export const listarRefinanciamentosInadimplencia = (filtros) => {
  const f = filtros ? filtros : {};
  const partes = [
    `dataInicial=${encodeURIComponent(f.dataInicial)}`,
    `dataFinal=${encodeURIComponent(f.dataFinal)}`,
    `tipoTitulo=${encodeURIComponent(f.tipoTitulo != null ? f.tipoTitulo : 0)}`,
    `foco=${encodeURIComponent(f.foco != null ? f.foco : 0)}`,
    `modo=${encodeURIComponent(f.modo != null ? f.modo : 0)}`,
  ];
  if (f.codigoCobrador != null && f.codigoCobrador !== '') {
    partes.push(`codigoCobrador=${encodeURIComponent(f.codigoCobrador)}`);
  }
  if (f.codigoFamilia != null && f.codigoFamilia !== '') {
    partes.push(`codigoFamilia=${encodeURIComponent(f.codigoFamilia)}`);
  }
  return httpService.get(
    `/relatorios/cobranca/refinanciamentos-inadimplencia?${partes.join('&')}`
  );
};

export const listarCobradoresRefinanciamentosInadimplencia = () =>
  httpService.get('/relatorios/cobranca/refinanciamentos-inadimplencia/cobradores');

// === W-0743 — Atualização Cadastral Prefeitura/Água ===
// httpService já desembrulha o payload (consumir `res` direto). Excel/Carta usam salvarEmExcel (POST+blob) no componente.
export const buscarAtualizacaoCadastral = (filtros) =>
  httpService.post('/relatorios/atualizacao-cadastral/buscar', filtros);

export const gerarOcorrenciasAtualizacaoCadastral = (filtros) =>
  httpService.post('/relatorios/atualizacao-cadastral/gerar-ocorrencias', filtros);

export const listarEmpresasAtualizacaoCadastral = (ges) =>
  httpService.get(`/relatorios/atualizacao-cadastral/empresas?ges=${ges}`);

export const listarEmpreendimentosAtualizacaoCadastral = (ges) =>
  httpService.get(`/relatorios/atualizacao-cadastral/empreendimentos?ges=${ges}`);

// W-0759 — Imóveis em Estoque (Relatório Comercial Imob).
// Blob via httpService.fetch (LICOES Ciclo 10 L2 — nunca httpService.post + 3o arg).
export const listarGruposEmpresaImoveisEstoque = () =>
  httpService.get('/relatorios/imoveis-estoque/grupos-empresa');

export const listarGruposGeImoveisEstoque = () =>
  httpService.get('/relatorios/imoveis-estoque/grupos-ge');

export const listarEmpreendimentosImoveisEstoque = (req) =>
  httpService.post('/relatorios/imoveis-estoque/empreendimentos', req);

export const listarCidadesImoveisEstoque = (req) =>
  httpService.post('/relatorios/imoveis-estoque/cidades', req);

export const consultarImoveisEstoque = (filtros) =>
  httpService.post('/relatorios/imoveis-estoque/consultar', filtros);

export const exportarImoveisEstoqueExcel = (filtros) =>
  httpService.fetch({
    method: 'post',
    url: '/relatorios/imoveis-estoque/excel',
    data: filtros,
    responseType: 'blob',
  });

export const abrirImoveisEstoqueReporting = (filtros) =>
  httpService.fetch({
    method: 'post',
    url: '/relatorios/imoveis-estoque/ssrs',
    data: filtros,
    responseType: 'blob',
  });

// === W-0604 — GES Etiquetas/Cartas (migração TFEtiqueta) ===
// RoutePrefix: etiquetas (sem api/ — ADR-011/ciclo 119).
export const buscarGruposEmpresaEtiquetas = () =>
  httpService.get('/etiquetas/grupos-empresa');

export const buscarCidadesEtiquetas = (codigoGrupoEmpresa) =>
  httpService.get('/etiquetas/cidades', {
    params: { codigo_grupo_empresa: codigoGrupoEmpresa },
  });

export const buscarRamosEtiquetas = () =>
  httpService.get('/etiquetas/ramos');

export const buscarRegioesEtiquetas = () =>
  httpService.get('/etiquetas/regioes');

export const buscarRemetentesEtiquetas = () =>
  httpService.get('/etiquetas/remetentes');

export const listarClientesDisponiveisEtiquetas = (payload) =>
  httpService.post('/etiquetas/clientes-disponiveis', payload);

export const emitirEtiquetas = (payload) =>
  httpService.fetch({
    method: 'post',
    url: '/etiquetas/emitir',
    data: payload,
    responseType: 'blob',
  });

export const emitirEtiquetasExcel = (payload) =>
  httpService.post('/etiquetas/emitir', payload);

export const emitirCartas = (formData) =>
  httpService.fetch({
    method: 'post',
    url: '/etiquetas/cartas',
    data: formData,
    responseType: 'blob',
  });

export const emitirEtiquetaAvulsa = (payload) =>
  httpService.fetch({
    method: 'post',
    url: '/etiquetas/avulsa',
    data: payload,
    responseType: 'blob',
  });
